var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * Main static class, holds all global config variables and functions for all views and components.
 */
var Main = (function () {
    /**
     * Creates a new Main instance, sets the templates for all views and components to use, creates a global socket connection, and gets the saved state from a cookie.
     *
     * @param config    Configuration variables passed in from config.php.
     */
    function Main(config) {
        var _this = this;
        //set the php config variables
        Main.config = config;
        this.setPrefixes();
        Main.templates = $("#templates");
        $(window).bind('resize orientationchange', function () { return _this.resize(); });
        this.resize();
        Main.socket = window.location.protocol + "//" + window.location.hostname + ":8080";
        var md = new MobileDetect(window.navigator.userAgent);
        Main.mobile = (md.mobile() || md.tablet()) ? true : false;
    }
    Main.prototype.resize = function () {
        Main.sWidth = $(window).width();
        Main.sHeight = $(window).height();
    };
    /**
     * Sets Main.xform and Main.transition by detecting which prefix exists on the current browser.
     */
    Main.prototype.setPrefixes = function () {
        var view = document.createElement('div');
        var prefixes = ['webkit', 'Moz', 'O', 'ms'];
        for (var i = 0; i < prefixes.length; i++) {
            var prefix = prefixes[i];
            var e = prefix + 'Transform';
            var t = prefix + 'Transition';
            if (typeof view.style[e] !== 'undefined') {
                Main.xform = e;
                Main.transition = t;
            }
        }
        view = null;
    };
    Main.socket = '';
    Main.room = 'fpo';
    Main.mobile = false;
    return Main;
}());
var NickelGroup = (function (_super) {
    __extends(NickelGroup, _super);
    function NickelGroup() {
        var _this = this;
        _super.call(this);
        this.addEventListener(NickelScene.TICK_EVENT, function (e) { return _this.children.forEach(function (c) { return c.dispatchEvent({
            type: NickelScene.TICK_EVENT,
            message: { dt: e.message.dt }
        }); }); });
    }
    return NickelGroup;
}(THREE.Group));
var NickelScene = (function (_super) {
    __extends(NickelScene, _super);
    function NickelScene() {
        var _this = this;
        _super.call(this);
        this.addEventListener(NickelScene.TICK_EVENT, function (e) { return _this.children.forEach(function (c) { return c.dispatchEvent({
            type: NickelScene.TICK_EVENT,
            message: { dt: e.message.dt }
        }); }); });
        Stage.events.forEach(function (e) { return _this.addEventListener(e, function (msg) { return _this.children.forEach(function (c) { return c.dispatchEvent({ type: e, message: msg }); }); }); });
    }
    NickelScene.prototype.getPostProcessingPasses = function () {
        return [];
    };
    NickelScene.TICK_EVENT = 'tick';
    return NickelScene;
}(THREE.Scene));
var NullCursor = (function (_super) {
    __extends(NullCursor, _super);
    function NullCursor() {
        _super.call(this);
        this.visible = false;
    }
    NullCursor.prototype.updateProgress = function (progress) {
    };
    NullCursor.prototype.updatePosition = function (mouse) {
    };
    NullCursor.prototype.reset = function () {
    };
    return NullCursor;
}(THREE.Object3D));
var Component = (function () {
    /**
     * Stores the global vars
     *
     * @param container A jQuery object containing the parent div for this view.
     * @param data      The config JSON data associated with this component.
     * @param delegate  The Class that instantiated this view.
     */
    function Component(container, data, delegate) {
        /**
         * Whether of not this instance is visible or not.
         */
        this.onStage = false;
        /**
         * The delay for setting display:none on this view after the showContent class is removed.
         */
        this.hideDelay = 0;
        /**
         * The delay for adding the showContent class to this view once display:block has been set.
         */
        this.showDelay = 25;
        /**
         * The object containing event listeners added to this specific component
         */
        this.listeners = {};
        /**
         * The object containing event listeners to be fired once added to this component
         */
        this.onceListeners = {};
        /**
         * The class to use for showing this component
         */
        this.displayClass = "block";
        this.uuid = Utils.generateUUID();
        this.container = container;
        this.delegate = delegate;
        this.data = data;
        this.bindEvents();
    }
    Component.prototype.resize = function (e) {
        if (e === void 0) { e = null; }
    };
    /**
     * Sets this.content with a JQuery object passed in (usually cloned from Main.templates)
     *
     * @param v JQuery wrapped DOM element
     */
    Component.prototype.setContent = function (v) {
        this.content = v;
        if (this.container) {
            this.container.append(this.content);
        }
    };
    /**
     * Adds an event listener for an event dispatched from this specific instance.
     *
     * @param evt      Event string we want to add an event listener for.
     * @param callback The function we want to call if that event is dispatched.
     * @param caller   Who called this
     */
    Component.prototype.on = function (evt, callback, caller) {
        if (!this.listeners[evt]) {
            this.listeners[evt] = {};
        }
        this.listeners[evt][caller.guid] = callback;
    };
    /**
     * Removes an event listener for an event dispatched from this specific instance.
     *
     * @param evt      Event string we want to remove an event listener for.
     * @param callback The function we want to remove from the listeners array for that event.
     * @param caller   Who called this
     */
    Component.prototype.off = function (evt, callback, caller) {
        var listeners = this.listeners[evt];
        delete listeners[caller.guid];
    };
    /**
     * Dispatches an event to any Classes listening for it from this instance.
     *
     * @param evt  The event we want to dispatch.
     * @param data The data we want to pass back to the event listener function.
     */
    Component.prototype.dispatch = function (evt, data) {
        if (data === void 0) { data = null; }
        var listeners = this.listeners[evt];
        var onceListeners = this.onceListeners[evt];
        for (var key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                listeners[key](data);
            }
        }
        for (var key in onceListeners) {
            if (onceListeners.hasOwnProperty(key)) {
                onceListeners[key](data);
                delete onceListeners[key];
            }
        }
    };
    /**
     * Binds all of the event listeners for this component.
     */
    Component.prototype.bindEvents = function () {
        var _this = this;
        $(window).bind('resize orientationchange', function (e) { return _this.resize(e); });
    };
    /**
     * Unbinds all of the Event listeners for this component.
     */
    Component.prototype.unbindEvents = function () {
        var _this = this;
        $(window).unbind('resize orientationchange', function (e) { return _this.resize(e); }); //TODO: MAKE THIS WORK
    };
    /**
     * Adds display block to this.content, and calls showContent
     */
    Component.prototype.showMe = function () {
        var _this = this;
        var style = (this.displayClass == "visible") ? "visibility" : "display";
        this.content.css(style, this.displayClass);
        this.onStage = true;
        clearTimeout(this.displayTimeout);
        this.displayTimeout = setTimeout(function () {
            _this.showContent();
        }, this.showDelay);
    };
    /**
     * Adds display none to this.content, calls hideContent
     */
    Component.prototype.hideMe = function () {
        var _this = this;
        this.hideContent();
        this.onStage = false;
        var style = (this.displayClass == "visible") ? "visibility" : "display";
        var hide = (style == "display") ? "none" : "hidden";
        clearTimeout(this.displayTimeout);
        this.displayTimeout = setTimeout(function () {
            _this.content.css(style, hide);
        }, this.hideDelay);
    };
    /**
     * Adds the showContent class and removes the hideContent class from this component.
     */
    Component.prototype.showContent = function () {
        this.content.removeClass('hideContent');
        this.content.addClass('showContent');
    };
    /**
     * Adds the hideContent class and removes the showContent class from this component.
     */
    Component.prototype.hideContent = function () {
        this.content.removeClass('showContent');
        this.content.addClass('hideContent');
    };
    /**
     * Kills this component, removes the event listeners, removes this.content, and set's itself to null;
     */
    Component.prototype.killMe = function () {
        this.unbindEvents();
        if (this.content) {
            this.content.remove();
        }
        this.content = null;
    };
    return Component;
}());
/**
 * Global event listener class. Used for passing global between views and components.
 */
var EventBus = (function () {
    function EventBus() {
    }
    /**
     * Adds an event listener for a global event.
     *
     * @param evt      Event string we're listening for
     * @param callback The callback function to call if the event is dispatched.
     * @param caller   Who called this
     */
    EventBus.addEventListener = function (evt, callback, caller) {
        if (!EventBus.listeners[evt]) {
            EventBus.listeners[evt] = {};
        }
        EventBus.listeners[evt][caller.uuid] = callback;
    };
    /**
     * Removes a specific event listener for a global event.
     *
     * @param evt      Event string we're removing
     * @param callback The callback function we want to remove.
     * @param caller   Who called this
     */
    EventBus.removeEventListener = function (evt, callback, caller) {
        var listeners = EventBus.listeners[evt];
        delete listeners[caller.uuid];
    };
    /**
     * Adds an event listener for a global event.
     *
     * @param evt  The event we want to dispatch.
     * @param data The data we want to pass into the callback function for that event.
     */
    EventBus.dispatchEvent = function (evt, data) {
        if (data === void 0) { data = null; }
        var listeners = EventBus.listeners[evt];
        for (var key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                listeners[key](data);
            }
        }
    };
    /**
     * Object containing all event listeners, with the key being the event string, and the value being an array of listener functions.
     */
    EventBus.listeners = {};
    return EventBus;
}());
/// <reference path='../scaffolding/Component.ts'/>
var Footer = (function (_super) {
    __extends(Footer, _super);
    function Footer(container, data, delegate) {
        var _this = this;
        _super.call(this, container, data, delegate);
        this.fullScreen = false;
        this.aboutOpen = false;
        this.creditsOpen = false;
        this.footerisHidden = false;
        this.content = container;
        $('#volumeCtrl').bind('mouseup touchend', function (e) { return _this.toggleMute(e); });
        $('#fullscreenCtrl').bind('mouseup touchend', function () { return _this.toggleFullSceen(); });
        $('#creditScreen-mobile, #creditScreen').bind('click touchend', function () { return _this.goToCredits(); });
        $('#aboutScreen-mobile, #aboutScreen').bind('click touchend', function () { return _this.gotToAbout(); });
        $('#startOver-mobile, #startOver').bind('click touchend', function () { return _this.startOver(); });
        EventBus.addEventListener('SHOW_HEADER', function () { return _this.showMe(); }, this);
        EventBus.addEventListener('HIDE_HEADER', function () { return _this.hideMe(); }, this);
        EventBus.addEventListener('INTRO_OVER', function () { return _this.showMe(); }, this);
        document.addEventListener('webkitfullscreenchange', function () { return _this.checkFullScreen(); });
        document.addEventListener('mozfullscreenchange', function () { return _this.checkFullScreen(); });
        document.addEventListener('fullscreenchange', function () { return _this.checkFullScreen(); });
        document.addEventListener('MSFullscreenChange', function () { return _this.checkFullScreen(); });
        if (Main.mobile) {
            $('#fullscreenCtrl').css('display', 'none');
            $('#volumeCtrl').addClass('footerBtn-last');
        }
    }
    Footer.prototype.goToCredits = function () {
        if (this.aboutOpen) {
            this.aboutOpen = false;
            EventBus.dispatchEvent(Footer.HIDE_ABOUT);
        }
        this.creditsOpen = true;
        EventBus.dispatchEvent(Footer.SHOW_CREDITS);
        gaTrackEvent('footer_credits', 'click');
    };
    Footer.prototype.gotToAbout = function () {
        if (this.creditsOpen) {
            this.creditsOpen = false;
            EventBus.dispatchEvent(Footer.HIDE_CREDITS);
        }
        this.aboutOpen = true;
        EventBus.dispatchEvent(Footer.SHOW_ABOUT);
        gaTrackEvent('footer_about', 'click');
    };
    Footer.prototype.startOver = function () {
        gaTrackEvent('footer_start_over', 'click');
        history.pushState({ state: '/skipIntro' }, Main.config.title, '/skipIntro');
        // History['pushState']({state: 1}, Main.config.title, state);
        location.reload();
    };
    Footer.prototype.toggleMute = function (e) {
        e.preventDefault();
        gaTrackEvent('footer_toggle_mute', 'click');
        EventBus.dispatchEvent(Footer.MUTE_VIDEO);
        if (Footer.muted) {
            Footer.muted = false;
            $('#volumeIcon').css('background-image', 'url(img/volume-icon-active.png)');
            for (var i in buzz.sounds) {
                buzz.sounds[i].unmute();
            }
        }
        else {
            for (var i in buzz.sounds) {
                buzz.sounds[i].mute();
            }
            $('#volumeIcon').css('background-image', 'url(img/mute.png)');
            Footer.muted = true;
        }
    };
    Footer.prototype.checkFullScreen = function () {
        var doc = document;
        if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
            EventBus.dispatchEvent('SHOW_HEADER');
        }
        else {
            EventBus.dispatchEvent('HIDE_HEADER');
        }
    };
    Footer.prototype.toggleFullSceen = function () {
        gaTrackEvent('footer_fullscreen', 'click');
        var doc = document;
        if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
            if (doc.documentElement.requestFullscreen) {
                doc.documentElement.requestFullscreen();
            }
            else if (doc.documentElement.msRequestFullscreen) {
                doc.documentElement.msRequestFullscreen();
            }
            else if (doc.documentElement.mozRequestFullScreen) {
                doc.documentElement.mozRequestFullScreen();
            }
            else if (doc.documentElement.webkitRequestFullscreen) {
                doc.documentElement.webkitRequestFullscreen();
            }
        }
        else {
            if (doc.exitFullscreen) {
                doc.exitFullscreen();
            }
            else if (doc.msExitFullscreen) {
                doc.msExitFullscreen();
            }
            else if (doc.mozCancelFullScreen) {
                doc.mozCancelFullScreen();
            }
            else if (doc.webkitExitFullscreen) {
                doc.webkitExitFullscreen();
            }
        }
    };
    Footer.muted = false;
    Footer.SHOW_CREDITS = "showcredits";
    Footer.SHOW_ABOUT = "showabout";
    Footer.HIDE_CREDITS = "hidecredits";
    Footer.HIDE_ABOUT = "hideabout";
    Footer.MUTE_VIDEO = "mutevideo";
    return Footer;
}(Component));
var Share = (function () {
    function Share() {
    }
    Share.onTwitter = function (shareUrl, tweetWithoutUrl) {
        //build tweet URL
        var url = 'https://twitter.com/intent/tweet?';
        if (shareUrl) {
            url += 'url=' + encodeURIComponent(shareUrl) + "&";
        }
        if (tweetWithoutUrl) {
            url += 'text=' + encodeURIComponent(tweetWithoutUrl);
        }
        Utils.openWindow(url, 550, 480);
    };
    Share.onFacebook = function (shareUrl) {
        var url = 'http://www.facebook.com/sharer.php?s=100&p[url]=' + encodeURIComponent(shareUrl);
        Utils.openWindow(url, 550, 480);
    };
    return Share;
}());
/// <reference path='../scaffolding/Component.ts'/>
/// <reference path='../scaffolding/Share.ts'/>
var Header = (function (_super) {
    __extends(Header, _super);
    function Header(container, data, delegate) {
        var _this = this;
        _super.call(this, container, data, delegate);
        this.menuIsOpen = false;
        this.content = container;
        $("#twitter").bind('click', function (e) { return _this.shareTwitter(e); });
        $("#fb").bind('click', function (e) { return _this.shareFacebook(e); });
        $('#nav-toggle').bind('click touchend', function () { return _this.menuOpen(); });
        EventBus.addEventListener('INTRO_OVER', function () { return _this.showMe(); }, this);
        EventBus.addEventListener('SHOW_HEADER', function () { return _this.showMe(); }, this);
        EventBus.addEventListener('HIDE_HEADER', function () { return _this.hideMe(); }, this);
    }
    Header.prototype.menuOpen = function () {
        $('#mobilenav').toggleClass('menu-open');
        $('body').toggleClass('menu-open');
    };
    Header.prototype.shareTwitter = function (e) {
        e.preventDefault();
        var copy = 'Seances – an indefatigable machine that makes never before seen films, never to be seen again!';
        Share.onTwitter(Main.config.shareUrl, copy);
        gaTrackEvent('share_twitter', 'click');
    };
    Header.prototype.shareFacebook = function (e) {
        e.preventDefault();
        Share.onFacebook(Main.config.shareUrl);
        gaTrackEvent('share_facebook', 'click');
    };
    return Header;
}(Component));
/// <reference path='../scaffolding/Component.ts'/>
/// <reference path='../scaffolding/EventBus.ts'/>
/// <reference path='./Footer.ts'/>
/// <reference path='./Header.ts'/>
/**
 * Simple component for loading and playing an video file with a <video> tag.
 */
var VideoPlayer = (function (_super) {
    __extends(VideoPlayer, _super);
    /**
     * Stores the global vars, sets the references to the video node, and loader.
     * @param container     A jQuery object containing the parent div for this component.
     * @param data          The JSON data unique to this component.
     * @param delegate      The Class that created this instance.
     */
    function VideoPlayer(container, data, delegate) {
        _super.call(this, container, data, delegate);
        /**
         * The url we're currently playing through the video node.
         */
        this.activeSrc = "";
        /**
         * If we should play the video as soon as it's loaded.
         */
        this.autoplay = false;
        /**
         * If the video is playing right now or not.
         */
        this.isPlaying = false;
        this.isMuted = false;
        /**
         * Whether or not we should be checking the progress of the video as it plays. Disabled by default for performace reasons.
         */
        this.checkProgress = false;
        this.videoLink = "";
        this.initialized = false;
        this.gaFired = 0;
        this.titleDeleted = false;
        this.isBuffering = false;
        this.setContent(Main.templates.find('.videoPlayer').clone());
        EventBus.addEventListener(VideoPlayer.LOAD_VIDEO, $.proxy(this.loadVideo, this), this);
        EventBus.addEventListener(VideoPlayer.SHOW_PLAYER, $.proxy(this.showMe, this), this);
        EventBus.addEventListener(VideoPlayer.HIDE_PLAYER, $.proxy(this.hideMe, this), this);
        EventBus.addEventListener(Footer.MUTE_VIDEO, $.proxy(this.toggleMute, this), this);
        $(window).bind('resize', $.proxy(this.resize, this));
        this.resize();
        // this.content.bind('click touchend', (e)=>this.togglePlay(e));
        this.loader = this.content.find('.loader');
    }
    VideoPlayer.prototype.togglePlay = function (e) {
        if (e.originalEvent.shiftKey) {
            this.skipToEnd();
            return;
        }
        if (this.player.paused()) {
            this.player.play();
        }
        else {
            this.player.pause();
        }
    };
    VideoPlayer.prototype.closeClicked = function () {
        this.hideMe();
    };
    VideoPlayer.prototype.setContent = function (v) {
        this.content = v;
        this.container.append(this.content);
    };
    VideoPlayer.prototype.onPlayerStateChange = function (e) {
    };
    VideoPlayer.prototype.init = function () {
        var _this = this;
        this.initialized = true;
        this.content.append("<video id = 'player' class = 'video-js vjs-default-skin'></video>");
        this.player = videojs('player', {
            autoplay: this.autoplay,
            controls: false,
            preload: 'auto'
        });
        $('.vjs-control-bar').hide(); //TODO, make this better
        this.setSrc();
        this.resize();
        if (this.autoplay) {
            this.player.show();
        }
        this.player.on('ended', function () { return _this.videoEnded(); });
    };
    VideoPlayer.prototype.setSrc = function () {
        this.player.src(this.videoLink);
        this.player.load();
        this.player.hide();
    };
    VideoPlayer.prototype.skipToEnd = function () {
        var time = this.player.duration() - 1;
        this.player.currentTime(time);
    };
    /**
     * Loads a video through the video node, binds the canplaythrough event.
     * @data        The url and poster frame for the video we want to load.
     */
    VideoPlayer.prototype.loadVideo = function (data) {
        this.videoId = data.expId;
        this.videoLink = this.getVideoLink(data.src);
        if (data.poster) {
            this.videoPoster = data.poster;
        }
        if (!this.initialized) {
            this.init();
        }
        else {
            this.setSrc();
        }
    };
    VideoPlayer.prototype.getVideoLink = function (path) {
        if (path.indexOf("http://") == 0 || path.indexOf("https://") == 0 || !Main.config['mediaBaseUrl']) {
            return path;
        }
        else {
            return Main.config['mediaBaseUrl'] + '/' + path;
        }
    };
    /**
     * Plays the video node, if we're checking progress, sets the checkTimeInt.
     */
    VideoPlayer.prototype.playVideo = function () {
        var _this = this;
        EventBus.dispatchEvent('VIDEO_START');
        this.player.show();
        this.player.play();
        // this.content.find('.loader').show();
        if (Main.mobile) {
            $('.play').bind('webkitendfullscreen', function () { return _this.videoEnded(); }, false);
        }
        if (this.isMuted) {
            this.player.muted(true);
        }
        this.isPlaying = true;
        clearInterval(this.currentTimeInterval);
        this.currentTimeInterval = setInterval(function () {
            var perc = _this.player.currentTime() / _this.player.duration();
            var percentFire = 0;
            if (perc >= 0.75 && _this.gaFired == 2) {
                _this.gaFired = 3;
                gaTrackEvent('75% completion', 'film_playback');
            }
            else if (perc >= 0.50 && _this.gaFired == 1) {
                _this.gaFired = 2;
                gaTrackEvent('50% completion', 'film_playback');
            }
            else if (perc >= 0.25 && _this.gaFired == 0) {
                _this.gaFired = 1;
                gaTrackEvent('25% completion', 'film_playback');
            }
            else if (perc >= 0.030 && !_this.titleDeleted) {
                _this.titleDeleted = true;
                _this.delegate.api.moveExperienceToGraveyard(_this.videoId);
                gaTrackEvent('title seen', 'film_playback');
            }
            if (_this.prevPercent == perc && !_this.isBuffering) {
                _this.buffering();
            }
            else if (_this.prevPercent != perc && _this.isBuffering) {
                _this.bufferingOver();
            }
            _this.prevPercent = perc;
        }, 150);
        this.dispatch(VideoPlayer.PLAY);
    };
    VideoPlayer.prototype.buffering = function () {
        this.isBuffering = true;
        this.content.find('.loader').show();
        // this.player.one('progress', ()=>this.bufferingOver())
    };
    VideoPlayer.prototype.bufferingOver = function () {
        if (this.isBuffering) {
            this.isBuffering = false;
            this.content.find('.loader').hide();
        }
    };
    /**
     * Pauses the video node.
     */
    VideoPlayer.prototype.pauseVideo = function () {
        this.isPlaying = false;
        clearInterval(this.currentTimeInterval);
        this.player.pause();
    };
    /**
     * Pauses the video and hides the component.
     */
    VideoPlayer.prototype.hideMe = function () {
        _super.prototype.hideMe.call(this);
        EventBus.dispatchEvent('SHOW_HEADER');
        if (this.player)
            this.pauseVideo();
    };
    VideoPlayer.prototype.showMe = function () {
        _super.prototype.showMe.call(this);
    };
    VideoPlayer.prototype.preventScroll = function (e) {
        e.preventDefault();
    };
    VideoPlayer.prototype.resize = function () {
        var h = window.innerHeight;
        var w = window.innerWidth;
        this.content.css({
            'top': 0,
            'height': h,
            'width': w
        });
        var pos = Utils.fitToContainer({
            'containerWidth': w,
            'containerHeight': h,
            'contentWidth': 1280,
            'contentHeight': 720,
            'vAlign': 'center',
            'hAlign': 'center',
            'scaleMode': 'proportionalInside'
        });
        if (this.player) {
            $("#player").css(pos);
        }
    };
    VideoPlayer.prototype.videoEnded = function () {
        this.killMe();
        EventBus.dispatchEvent("VIDEO_OVER");
    };
    VideoPlayer.prototype.toggleMute = function () {
        if (this.isMuted) {
            this.isMuted = false;
        }
        else {
            this.isMuted = true;
        }
        if (this.isPlaying) {
            this.player.muted(this.isMuted);
        }
    };
    /**
     * Event Dispatched once the video node begins to play.
     */
    VideoPlayer.PLAY = "playvideo";
    /**
     * Event Dispatched once the video node reaches the end.
     */
    VideoPlayer.VIDEO_END = "videoend";
    /**
     * Event Dispatched on an interval as the video plays.
     */
    VideoPlayer.PROGRESS = "progress";
    VideoPlayer.LOAD_VIDEO = "globalloadvideo";
    VideoPlayer.SHOW_PLAYER = "showglobalplayer";
    VideoPlayer.HIDE_PLAYER = "hideglobalplayer";
    return VideoPlayer;
}(Component));
var MoveItShader = (function () {
    function MoveItShader(texture, params) {
        this.transparent = true;
        this.depthWrite = false;
        this.uniforms = {
            fTime: { type: "f", value: 0.1 },
            tTexture: { type: "t", value: null },
            fDisplacement: { type: "f", value: 0.25 },
            vColour: { type: "v4", value: new THREE.Vector4(1.0, 1.0, 1.0, 0.4) },
            vRange: { type: "v3", value: new THREE.Vector3(1.0, 1.0, 4.0) },
            vUvBounds: { type: "Matrix2fv", value: [] },
            fDistortionIntensity: { type: "f", value: 0.000 } // reasonable amount is 0.00025
        };
        this.defines = {
            PI: Math.PI,
            ANIMATE_DRIFT: false,
            DISTANCE_FADEOUT: false
        };
        this.vertexShader = "\nuniform float fTime;\nuniform float fDisplacement;\nuniform vec3 vRange;\n\nvarying vec2 vUv;\n#ifdef DISTANCE_FADEOUT\nvarying float fZPos;\n#endif\n\nmat3 getRotationMatrix(float tick)\n{\n    return mat3(\n        cos(tick) * vRange.x,0,0,\n        0,sin(tick) * vRange.y,0,\n        0,0,cos(tick) * vRange.z\n    );\n}\n\nvoid main()\n{\n    vUv = uv;\n\n    vec3 displaced =\n#ifdef ANIMATE_DRIFT\n    getRotationMatrix(fTime) * vec3(fDisplacement) + position;\n#else\n    position;\n#endif\n\n#ifdef DISTANCE_FADEOUT\n    fZPos = (projectionMatrix * modelViewMatrix * vec4(displaced, 1.0)).z;\n#endif\n\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(displaced, 1.0);\n\n}\n";
        this.fragmentShader = "\nuniform vec4 vColour;\nuniform mat2 vUvBounds;\nuniform sampler2D tTexture;\nuniform float fTime;\nuniform float fDistortionIntensity;\n\nvarying vec2 vUv;\n\n#ifdef DISTANCE_FADEOUT\nvarying float fZPos;\n\nfloat sinh(float var) {\n    return (exp(var) - exp(-var)) / float(2);\n}\n\nfloat cosh(float var) {\n    return (exp(var) + exp(-var)) / float(2);\n}\n\nfloat tanh(in float var) {\n    return sinh(var)/cosh(var);\n}\n#endif\n\nvoid main()\n{\n    float normY = (vUv.y - vUvBounds[0].y)/(vUvBounds[1].y - vUvBounds[0].y);\n    vec4 tex = texture2D(\n        tTexture,\n        vec2(\n            clamp(\n                vUv.x + (sin((normY + fTime/float(4)) * PI * float(20.0)) * fDistortionIntensity),\n                vUvBounds[0].x,\n                vUvBounds[1].x\n            ),\n            vUv.y\n        )\n    );\n    \n    gl_FragColor = vec4(\n        tex.r * vColour.r,\n        tex.g * vColour.g,\n        tex.b * vColour.b,\n        tex.a * vColour.a\n    );\n#ifdef DISTANCE_FADEOUT\n    gl_FragColor.a *= clamp(tanh((float(210) - fZPos)/float(40)), 0.4, 1.0);\n#endif\n}\n";
        this.uniforms.tTexture.value = texture;
        if (params) {
            if (params.timeOffset)
                this.uniforms.fTime.value = params.timeOffset;
            if (params.driftAnimation)
                this.defines.ANIMATE_DRIFT = true;
            if (params.driftDisplacement)
                this.uniforms.fDisplacement.value = params.driftDisplacement;
            if (params.driftRange)
                this.uniforms.vRange.value = params.driftRange;
            if (params.distanceFadeOut)
                this.defines.DISTANCE_FADEOUT = true;
            if (params.colour)
                this.uniforms.vColour.value = params.colour;
        }
    }
    return MoveItShader;
}());
var Rect = (function () {
    function Rect(x, y, w, h, padding) {
        this.x = x;
        this.y = y;
        this.w = w;
        this.h = h;
        this.padding = padding || 0;
    }
    Object.defineProperty(Rect.prototype, "interiorWidth", {
        get: function () {
            return this.w;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "interiorHeight", {
        get: function () {
            return this.h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "exteriorWidth", {
        get: function () {
            return this.w + this.padding;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "exteriorHeight", {
        get: function () {
            return this.h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "interiorX1", {
        get: function () {
            return this.x + this.padding;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "interiorX2", {
        get: function () {
            return this.x + this.interiorWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "exteriorX1", {
        get: function () {
            return this.x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "exteriorX2", {
        get: function () {
            return this.x + this.exteriorWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "interiorY1", {
        get: function () {
            return this.y + this.padding;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "interiorY2", {
        get: function () {
            return this.y + this.interiorHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "exteriorY1", {
        get: function () {
            return this.y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "exteriorY2", {
        get: function () {
            return this.y + this.exteriorHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "x1", {
        set: function (i) {
            this.x = i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "x2", {
        set: function (i) {
            this.x = i - this.w;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "y1", {
        set: function (i) {
            this.y = i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "y2", {
        set: function (i) {
            this.h = i - this.h;
        },
        enumerable: true,
        configurable: true
    });
    return Rect;
}());
/// <reference path='./Rect.ts'/>
/// <reference path='./LineTextureRenderer.ts'/>
var TextureAtlas = (function () {
    /**
     * @param size The power of 2 to use for the size of the canvas
     * @param container
     */
    function TextureAtlas(size, container) {
        this.renderedStrings = {};
        this.rowHeight = -1;
        this.rows = [];
        this.atlases = [];
        this.size = size;
        this.renderer = container;
        this.rowWidth = Math.pow(2, size);
        this.canvasWidth = Math.pow(2, size);
        this.canvasHeight = Math.pow(2, size);
        this.addAtlas();
    }
    TextureAtlas.prototype.addAtlas = function () {
        var canvas = document.createElement('canvas');
        canvas.width = this.canvasWidth;
        canvas.height = this.canvasHeight;
        var ctx = canvas.getContext('2d');
        var texture = new THREE.CanvasTexture(canvas, THREE.Texture.DEFAULT_MAPPING, THREE.ClampToEdgeWrapping, THREE.ClampToEdgeWrapping, THREE.LinearFilter, THREE.LinearFilter, THREE.RGBAFormat);
        texture.flipY = false;
        texture.needsUpdate = true;
        texture.generateMipmaps = false;
        this.atlases.push({
            canvas: canvas,
            ctx: ctx,
            rows: [],
            texture: texture,
        });
        this.renderer.empty().append(canvas);
    };
    TextureAtlas.prototype.changeRowHeight = function (height, padding) {
        this.rowHeight = height;
        this.padding = padding;
    };
    TextureAtlas.prototype.paintText = function (text, w, h, face, extra) {
        var cacheKey = text + "-" + w + "-" + h;
        if (extra && extra.length !== 0) {
            cacheKey += "-" + extra.join('-');
        }
        if (this.renderedStrings[cacheKey]) {
            return this.renderedStrings[cacheKey];
        }
        var block = this.findBlockInRow(w, h);
        var brushOffset = block.exteriorY1;
        this.atlases[0].ctx.textBaseline = "hanging";
        this.atlases[0].ctx.fillText(text, block.interiorX1, brushOffset + 5);
        // this is useful when debugging
        // this.atlases[0].ctx.strokeStyle = 'black';
        // this.atlases[0].ctx.strokeRect(block.exteriorX1, block.exteriorY1, block.exteriorWidth, block.exteriorHeight);
        // this.atlases[0].ctx.strokeRect(block.interiorX1, block.interiorY1, block.interiorWidth, block.interiorHeight);
        this.atlases[0].texture.needsUpdate = true;
        this.renderedStrings[cacheKey] = block;
        return block;
    };
    TextureAtlas.prototype.measureText = function (text) {
        return this.atlases[0].ctx.measureText(text);
    };
    TextureAtlas.prototype.setFont = function (face, size, extra) {
        var font = size + "px " + face;
        if (extra && extra.length !== 0) {
            font = extra.join(' ') + (" " + font);
        }
        this.atlases[0].ctx.font = font;
        this.atlases[0].ctx.fillStyle = '#FFF';
    };
    TextureAtlas.prototype.getTexture = function () {
        return this.atlases[0].texture;
    };
    TextureAtlas.prototype.getTextureUV = function (d) {
        var ret = [
            this.getUVCoordinate(d.exteriorX1, d.exteriorY1),
            this.getUVCoordinate(d.exteriorX1, d.exteriorY2),
            this.getUVCoordinate(d.exteriorX2, d.exteriorY2),
            this.getUVCoordinate(d.exteriorX2, d.exteriorY1)
        ];
        ret.forEach(function (i) {
            if (i.x > 1 || i.y > 1) {
                console.warn('UV 0.0-1.0 range exceeded', i.x, i.y);
            }
        });
        return ret;
    };
    TextureAtlas.prototype.findBlockInRow = function (w, h) {
        var rowIdx = this.findRowWithVacancy(w + this.padding);
        var row = this.atlases[0].rows[rowIdx];
        var rect = new Rect(row.used, rowIdx * (this.rowHeight + this.padding), w, h, this.padding);
        row.allocate(rect.exteriorWidth);
        return rect;
    };
    TextureAtlas.prototype.findRowWithVacancy = function (required) {
        var atlas = this.atlases[0];
        var candidateRows = atlas.rows.filter(function (r) { return r.free > required; });
        if (candidateRows.length === 0) {
            var row = new Row(this.rowWidth);
            atlas.rows.push(row);
            return atlas.rows.indexOf(row);
        }
        else {
            var row = candidateRows[0];
            if (!row) {
                row = new Row(this.rowWidth);
                atlas.rows.push(row);
            }
            return atlas.rows.indexOf(row);
        }
    };
    /**
     * (0,0) is bottom-left
     *
     * @param x
     * @param y
     * @return UV
     */
    TextureAtlas.prototype.getUVCoordinate = function (x, y) {
        return new THREE.Vector2(x / this.canvasWidth, y / this.canvasHeight);
    };
    return TextureAtlas;
}());
var Row = (function () {
    function Row(size) {
        this.used = 0;
        this.size = size;
    }
    Row.prototype.allocate = function (length) {
        this.used += length + 2;
    };
    Object.defineProperty(Row.prototype, "free", {
        get: function () {
            return this.size - this.used;
        },
        enumerable: true,
        configurable: true
    });
    return Row;
}());
/// <reference path='./Rect.ts'/>
/// <reference path='./TextureAtlas.ts'/>
var LineTextureRenderer = (function () {
    function LineTextureRenderer(face, size, atlas) {
        this.padding = 6;
        this.face = face;
        this.size = size;
        this.atlas = atlas;
        this.atlas.setFont(face, size);
        this.renderer = $("#renderer");
        this.renderer.css({
            width: 'auto',
            height: 'auto',
            'font-size': size + "px",
            'font-face': face,
        });
        this.lineHeight = this.measureHeight('A');
        this.atlas.changeRowHeight(this.lineHeight.height + this.lineHeight.descender, this.padding);
    }
    LineTextureRenderer.prototype.makeLineTexture = function (text, extra) {
        this.atlas.setFont(this.face, this.size, extra);
        var dims = this.measureString(text);
        var empty = this.atlas.paintText(text, dims.w, dims.h, this.lineHeight, extra);
        var texUV = this.atlas.getTextureUV(empty);
        return {
            map: this.atlas.getTexture(),
            textAspectRatio: dims.exteriorWidth / dims.exteriorHeight,
            uvs: texUV
        };
    };
    LineTextureRenderer.prototype.measureString = function (text) {
        return new Rect(0, 0, this.atlas.measureText(text).width, this.lineHeight.height + this.lineHeight.descender, this.padding);
    };
    LineTextureRenderer.prototype.measureHeight = function (text) {
        var glyphs = 'ijMqm';
        var calcArea = $("<div>" + glyphs + "</div>")
            .css('position', 'fixed')
            .css('top', '-1000000px')
            .css('left', '-1000000px')
            .css('font-size', '1000000%')
            .css('font-family', this.face)
            .css('line-height', '1.0');
        this.renderer.append(calcArea);
        var subSpan = $("<span>" + glyphs + "</span>")
            .css('font-size', '0%');
        calcArea.append(subSpan);
        var baselinePosition = subSpan.get(0).offsetTop + subSpan.get(0).offsetHeight;
        var calcAreaOffsetHeight = calcArea.get(0).offsetHeight;
        var baselineRatio = (calcAreaOffsetHeight - baselinePosition) / calcAreaOffsetHeight;
        var renderSpan = $("<span>" + text + "</span>")
            .css('font-size', this.size + "px")
            .css('font-face', this.face)
            .css('white-space', 'pre');
        this.renderer.append(renderSpan);
        var height = renderSpan.height();
        renderSpan.detach();
        calcArea.detach();
        return {
            height: height,
            descender: Math.ceil(height * baselineRatio)
        };
    };
    return LineTextureRenderer;
}());
/// <reference path='../../seances/shaders/MoveItShader.ts'/>
/// <reference path='./LineTextureRenderer.ts'/>
var OFFSET_PRECISION = 10.0;
var Word = (function (_super) {
    __extends(Word, _super);
    function Word() {
        _super.apply(this, arguments);
    }
    Word.makeWord = function (data, renderer) {
        var extra = [];
        if (data.smallCaps) {
            extra.push('small-caps');
        }
        if (data.italic) {
            extra.push('italic');
        }
        var lineTexData = renderer.makeLineTexture(data.text, extra);
        var alpha = typeof data.alpha === 'number' ? data.alpha : Word.DEFAULT_ALPHA;
        var shaderParams = {
            timeOffset: Utils.randomFromInterval(0, 360) / (2 * Math.PI),
            driftAnimation: data.shaderMotion,
            driftDisplacement: data.lineHeight
        };
        if (data.colour) {
            // tasty
            shaderParams.colour = data.colour.toVector4(alpha);
            shaderParams.driftRange = new THREE.Vector3(2, 1, 1);
            shaderParams.driftDisplacement = 1.0;
        }
        else {
            shaderParams.colour = new THREE.Vector4(1.0, 1.0, 1.0, alpha);
        }
        if (data.distanceFadeOut) {
            shaderParams.distanceFadeOut = true;
        }
        var material = new THREE.ShaderMaterial(new MoveItShader(lineTexData.map, shaderParams));
        material.uniforms.vUvBounds.value = [
            lineTexData.uvs[0].x, lineTexData.uvs[0].y,
            lineTexData.uvs[2].x, lineTexData.uvs[2].y
        ];
        var textHeight = data.lineHeight;
        var textWidth = textHeight * lineTexData.textAspectRatio;
        var geometry = new THREE.PlaneGeometry(textWidth, textHeight);
        geometry.computeBoundingBox();
        geometry.faceVertexUvs[0][0] = [lineTexData.uvs[0], lineTexData.uvs[1], lineTexData.uvs[3]];
        geometry.faceVertexUvs[0][1] = [lineTexData.uvs[1], lineTexData.uvs[2], lineTexData.uvs[3]];
        geometry.uvsNeedUpdate = true;
        var line = new Word(geometry, material);
        line.name = data.text;
        if (data.userData) {
            line.userData = data.userData;
        }
        if (data.yRange) {
            var verticalShift = Utils.randomFromInterval(-data.yRange * OFFSET_PRECISION, data.yRange * OFFSET_PRECISION) / OFFSET_PRECISION;
            line.translateY(verticalShift);
        }
        line.addEventListener(NickelScene.TICK_EVENT, function () {
            line.material.uniforms.fTime.value += 0.01;
            if (data.worldTick) {
                data.worldTick();
            }
        });
        return line;
    };
    Word.prototype.width = function () {
        return this.geometry.boundingBox.max.x - this.geometry.boundingBox.min.x;
    };
    Word.DEFAULT_ALPHA = 0.4;
    return Word;
}(THREE.Mesh));
/// <reference path='../scaffolding/text/Word.ts'/>
var SeancesApi = (function () {
    function SeancesApi(fetch, baseUrl) {
        this.fetch = fetch;
        this.baseUrl = baseUrl;
    }
    SeancesApi.prototype.getExperienceGraveyard = function (page, id) {
        var path = this.baseUrl + "get-experience-graveyard/";
        if (id) {
            path += id + "/" + page;
        }
        else {
            path += "" + page;
        }
        return this.fetch(path)
            .then(function (response) { return response.json(); });
    };
    SeancesApi.prototype.getExperience = function () {
        return this.fetch(this.baseUrl + "get-experience")
            .then(function (response) { return response.json(); });
    };
    SeancesApi.prototype.getGraveyardCount = function () {
        console.log(this.baseUrl);
        return this.fetch("http://seances.nfb.ca/api?task=get-experience-counts")
            .then(function (response) { return response.json(); });
    };
    SeancesApi.prototype.moveExperienceToGraveyard = function (experienceId) {
        return this.fetch(this.baseUrl + "move-experience-to-graveyard/" + experienceId, {
            method: 'post',
            headers: { 'Accept': 'application/json' },
            body: ''
        })
            .then(function (response) { return response.json(); });
    };
    return SeancesApi;
}());
/// <reference path='../../scaffolding/Component.ts'/>
var SeancesScene = (function (_super) {
    __extends(SeancesScene, _super);
    function SeancesScene() {
        _super.call(this);
        this.backgroundPool = [
            'bol_1g.mp4',
            'db_1g.mp4',
            'dh_1.mp4',
            'dh_2.mp4',
            'dh_3g.mp4',
            'dj_1g.mp4',
            'dj_2g.mp4',
            'dj_3g.mp4',
            'foac_1.mp4',
            'fr_1.mp4',
            'gl_1.mp4',
            'jk_1.mp4',
            'pp_1g.mp4',
            'rausch_1.mp4',
            'sdw_1.mp4',
            'sdw_2g.mp4',
            'sdw_3g.mp4',
            'sdw_4g.mp4',
            'tgd_1.mp4',
            'ti_1.mp4'
        ];
        var light = new THREE.AmbientLight(0xffffff);
        this.add(light);
    }
    return SeancesScene;
}(NickelScene));
/// <reference path='Main.ts'/>
/**
 * Helper functions available to all other Classes.
 */
var Utils = (function () {
    function Utils() {
    }
    Utils.easeQuadOut = function (e0, e1, t) {
        return e0 + (e1 - e0) * (t * (2 - t));
    };
    Utils.wrapText = function (context, text, x, y, maxWidth, lineHeight) {
        y = lineHeight;
        var words = text.split(' ');
        var line = '';
        for (var n = 0; n < words.length; n++) {
            var testLine = line + words[n] + ' ';
            var metrics = context.measureText(testLine);
            var testWidth = metrics.width;
            if (testWidth > maxWidth && n > 0) {
                context.fillText(line, x, y);
                line = words[n] + ' ';
                y += lineHeight;
            }
            else {
                line = testLine;
            }
        }
        context.fillText(line, x, y);
    };
    Utils.pow2floor = function (v) {
        v++;
        var p = 1;
        while (v >>= 1) {
            p <<= 1;
        }
        return p;
    };
    Utils.pow2ceil = function (v) {
        v--;
        var p = 2;
        while (v >>= 1) {
            p <<= 1;
        }
        return p;
    };
    Utils.calcCameraView = function (objZ) {
        var distance = Stage.CAMERA.position.z + -objZ;
        var vFOV, height, hFOV, width;
        vFOV = (Stage.CAMERA.fov * Math.PI / 180);
        height = 2 * Math.tan(((Stage.CAMERA.fov * Math.PI / 180) / 2)) * distance;
        hFOV = 2 * Math.atan(Math.tan(vFOV / 2) * Stage.CAMERA.aspect);
        width = 2 * Math.tan((hFOV / 2)) * distance;
        return { width: width, height: height };
    };
    //calculates the pixel distance between two 3d points
    Utils.distanceBetween3DPoints = function (p1, p2) {
        return Math.round(Math.sqrt(((p2.x - p1.x) * (p2.x - p1.x)) + ((p2.y - p1.y) * (p2.y - p1.y)) + ((p2.z - p1.z) * (p2.z - p1.z))));
    };
    Utils.angleBetween3DPoints = function (p1, p2) {
        var xDiff = p2.x - p1.x;
        var yDiff = p2.y - p1.y;
        return Math.atan2(yDiff, xDiff) * (180 / Math.PI);
    };
    /* --------------------------------------------------------*/
    /* --------------------- MISC HELPERS ---------------------*/
    /* --------------------------------------------------------*/
    /**
     * Resizes a rectangle to fit into another rectangle using different positioning and scale properties to crop / position.
     * @data    The data object containig all of the paraeters for the calculation.
     */
    Utils.fitToContainer = function (data) {
        var newH, newW, top, left;
        var aspectRatio = data.contentWidth / data.contentHeight;
        //scale
        if (data.scaleMode == "proportionalInside") {
            newW = data.containerWidth;
            newH = newW / aspectRatio;
            if (newH > data.containerHeight) {
                newH = data.containerHeight;
                newW = newH * aspectRatio;
            }
        }
        else if (data.scaleMode == "proportionalOutside") {
            newW = data.containerWidth;
            newH = newW / aspectRatio;
            if (newH < data.containerHeight) {
                newH = data.containerHeight;
                newW = newH * aspectRatio;
            }
        }
        else if (data.scaleMode == "none" || !data.scaleMode) {
            newW = data.contentWidth;
            newH = data.contentHeight;
        }
        if (data.maxWidth) {
            if (newW > data.maxWidth) {
                newW = data.maxWidth;
                newH = newW / aspectRatio;
            }
        }
        if (data.maxHeight) {
            if (newH > data.maxHeight) {
                newH = data.maxHeight;
                newW = newH * aspectRatio;
            }
        }
        //fit
        left = (data.hAlign == "left") ? 0 : (data.hAlign == "right") ? -(newW - data.containerWidth) : (data.containerWidth - newW) / 2;
        top = (data.vAlign == "top") ? 0 : (data.vAlign == "bottom") ? -(newH - data.containerHeight) : (data.containerHeight - newH) / 2;
        return {
            'width': newW,
            'height': newH,
            'top': top,
            'left': left
        };
    };
    /**
     * Generates a UUID and returns it.
     */
    Utils.generateUUID = function () {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
        });
        return uuid;
    };
    /**
     * Generates a unique id, based off of the langth passed in.
     * @numChars    How may characters we want the (psuedo) unique ID to contain.
     */
    Utils.generateID = function (numChars) {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < numChars; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    };
    /**
     * Wrapper function to make an ajax request.
     * @data                The JSON data we want to pas in.
     * @successCallback     Callback function for on success.
     * @errorCallback       Callback function for error.
     */
    Utils.ajax = function (data, successCallback, errorCallback, ajaxUrl) {
        if (successCallback === void 0) { successCallback = null; }
        if (errorCallback === void 0) { errorCallback = null; }
        if (ajaxUrl === void 0) { ajaxUrl = null; }
        $.ajax({
            type: 'POST',
            url: 'ajax.cms.php',
            data: data,
            dataType: 'json',
            success: function (response) {
                if (successCallback) {
                    successCallback(response);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (errorCallback) {
                    errorCallback(jqXHR.responseText);
                }
            }
        });
    };
    /**
     * Pushes a browser state
     * @state   The state we want to push.
     */
    Utils.pushState = function (state) {
        // History['pushState']({state:1}, Main.config.pageTitle, state);
        History['pushState']({ state: 1 }, Main.config.title, state);
    };
    /**
     *Opens a popup window centered in the screen
     */
    Utils.openWindow = function (url, width, height) {
        var windowSize = {
            'width': width,
            'height': height,
            'left': (screen.width / 2) - (width / 2),
            'top': (screen.height / 2) - (height / 2 + 100)
        };
        var windowFeatures = "width=" + windowSize.width + ",height=" + windowSize.height + ",status,resizable,scrollbars,modal,alwaysRaised";
        windowFeatures += ",left=" + windowSize.left + ",top=" + windowSize.top + "screenX=" + windowSize.left + ",screenY=" + windowSize.top;
        window.open(url, '' + new Date().getTime() + '', windowFeatures);
    };
    /* --------------------------------------------------------*/
    /* ------------------------ STRING ------------------------*/
    /* --------------------------------------------------------*/
    /**
     * Capitalises the first letter of a string.
     * @str     The string you want to capitalise.
     */
    Utils.capitalize = function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    /**
     * Returns a formatted string for displaying the file size, from bytes.
     * @bytes       The filesize, in bytes.
     */
    Utils.formatBytes = function (bytes) {
        if (bytes >= 1000000000) {
            bytes = (bytes / 1000000000).toFixed(2) + ' GB';
        }
        else if (bytes >= 1000000) {
            bytes = (bytes / 1000000).toFixed(2) + ' MB';
        }
        else if (bytes >= 1000) {
            bytes = (bytes / 1000).toFixed(2) + ' KB';
        }
        else if (bytes > 1) {
            bytes = bytes + ' bytes';
        }
        else if (bytes == 1) {
            bytes = bytes + ' byte';
        }
        else {
            bytes = '0 byte';
        }
        return bytes;
    };
    /* --------------------------------------------------------*/
    /* ------------------------ OBJECT ------------------------*/
    /* --------------------------------------------------------*/
    /**
     * Counts the key/value pairs in an object.
     * @obj     The object you want to get a "length" from.
     */
    Utils.objSize = function (obj) {
        var size = 0, key;
        for (key in obj) {
            if (obj.hasOwnProperty(key))
                size++;
        }
        return size;
    };
    /* --------------------------------------------------------*/
    /* ----------------------- NUMBERS ------------------------*/
    /* --------------------------------------------------------*/
    /**
     * Detects if a value is numberic or not.
     * @n   The value we want to check.
     */
    Utils.isNumeric = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    };
    /**
     * Detects if a number is odd or event
     * @num     The value we want to check.
     */
    Utils.isOdd = function (num) {
        return (num % 2) == 16;
    };
    /**
     * Contain a number to a min and max.
     */
    Utils.clamp = function (min, max, val) {
        if (val < min)
            return min;
        if (val > max)
            return max;
        return val;
    };
    /* --------------------------------------------------------*/
    /* ------------------------- MATH -------------------------*/
    /* --------------------------------------------------------*/
    /**
     * Convert degrees to radians.
     */
    Utils.degreesToRadians = function (degrees) {
        return degrees * Math.PI / 180;
    };
    /**
     * Convert radians to degrees
     */
    Utils.radiansToDegrees = function (radians) {
        return radians * 180 / Math.PI;
    };
    /**
     * Calculates the distance between two points in 2D space.
     */
    Utils.lineDistance = function (point1, point2) {
        var xs = 0;
        var ys = 0;
        xs = point2.x - point1.x;
        xs = xs * xs;
        ys = point2.y - point1.y;
        ys = ys * ys;
        return Math.sqrt(xs + ys);
    };
    /**
     * Calculates the angle in degrees between two points
     */
    Utils.calcAngle = function (p1, p2) {
        var calcAngle = Math.atan2(p1.x - p2.x, p1.y - p2.y) * (180 / Math.PI);
        if (calcAngle < 0)
            calcAngle = Math.abs(calcAngle);
        else
            calcAngle = 360 - calcAngle;
        return calcAngle;
    };
    /**
     * Returns a random number between 2 numbers
     */
    Utils.randomFromInterval = function (from, to) {
        return Math.floor(Math.random() * (to - from + 1) + from);
    };
    /* --------------------------------------------------------*/
    /* ------------------------- ARRAY ------------------------*/
    /* --------------------------------------------------------*/
    /**
     * Switches the position of two array elements.
     * @array       The array containing both elements.
     * @a           The index of the first element.
     * @b           The index of the second element.
     * @return      The array with the elements switched.
     */
    Utils.swapArrayElements = function (array, a, b) {
        var temp = array[a];
        array[a] = array[b];
        array[b] = temp;
        return array;
    };
    /**
     * Removes one of more elements from an array.
     * @array       The array containing all of the elements.
     * @from        The first element we want to remove (and the last, if @to isn't set).
     * @to          The index of the last element we want to remove.
     * @return      The original array with the elements removed.
     */
    Utils.removeFromArray = function (array, from, to) {
        var rest = array.slice((to || from) + 1 || array.length);
        array.length = from < 0 ? array.length + from : from;
        return array.push.apply(array, rest);
    };
    /**
     * Randomly shuffles the contents of an array.
     * @array       The array containing all of the elements.
     */
    Utils.shuffleArray = function (array) {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array;
    };
    /* --------------------------------------------------------*/
    /* -------------------------- JSON ------------------------*/
    /* --------------------------------------------------------*/
    /**
     * Checks if a string is valid json.
     * @str     The string you want to check.
     */
    Utils.isValidJSON = function (str) {
        try {
            JSON.parse(str);
        }
        catch (e) {
            return false;
        }
        return true;
    };
    /**
     * Formats a JSON sting with line breaks for displaying pretty JSON.
     * @str     The string you want to format.
     */
    Utils.formatJSONString = function (str) {
        var jsonObj = JSON.parse(str);
        var jsonPretty = JSON.stringify(jsonObj, null, '\t');
        return jsonPretty;
    };
    /* --------------------------------------------------------*/
    /* ----------------- BROWSER / OS DETECTION ---------------*/
    /* --------------------------------------------------------*/
    /**
     * Detects the operating system on a mobile device, returns and os and the version.
     */
    Utils.detectMobileOS = function () {
        var mobileOS;
        var mobileOSver;
        var ua = navigator.userAgent;
        var uaindex;
        // determine OS
        if (ua.match(/iPad/i) || ua.match(/iPhone/i)) {
            mobileOS = 'iOS';
            uaindex = ua.indexOf('OS ');
        }
        else if (ua.match(/Android/i)) {
            mobileOS = 'Android';
            uaindex = ua.indexOf('Android ');
        }
        else {
            mobileOS = 'unknown';
        }
        // determine version
        if (mobileOS === 'iOS' && uaindex > -1) {
            mobileOSver = ua.substr(uaindex + 3, 3).replace('_', '.');
        }
        else if (mobileOS === 'Android' && uaindex > -1) {
            mobileOSver = ua.substr(uaindex + 8, 3);
        }
        else {
            mobileOSver = 'unknown';
        }
        var num = Number(mobileOSver);
        return { "os": mobileOS, "ver": num };
    };
    /* --------------------------------------------------------*/
    /* -------------------- FEATURE DETECTION -----------------*/
    /* --------------------------------------------------------*/
    /**
     * Detects if the current browser can play the mp4 video format or now.
     */
    Utils.canPlayMP4 = function () {
        var canPlay = false;
        var v = document.createElement('video');
        if (v.canPlayType && v.canPlayType('video/mp4').replace(/no/, '')) {
            canPlay = true;
        }
        return canPlay;
    };
    /**
     * Detects if the current browser supports Webgl.
     */
    Utils.canUseWebgl = function () {
        if (!!window.WebGLRenderingContext) {
            return true;
        }
        else {
            return false;
        }
    };
    /* --------------------------------------------------------*/
    /* ----------------------- DATE / TIME --------------------*/
    /* --------------------------------------------------------*/
    Utils.clientTimezone = function (date) {
        return date.addHours(-(new Date().getTimezoneOffset() / 60));
    };
    Utils.formatDate = function (date, format) {
        var d = Utils.clientTimezone(date);
        return date.toString(format).replace(' 0:', ' 12:'); // Fix date.js bug to show 12:00am instead of 0:00am
    };
    /* --------------------------------------------------------*/
    /* ------------------------ COOKIES -----------------------*/
    /* --------------------------------------------------------*/
    /**
     *Sets a cookie to the document object
     * @c_name      The name for the new cookie.
     * @value       The data to set on this cookie.
     * @exdays      How many days befor this cookie expires.
     */
    Utils.setCookie = function (c_name, value, exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        var c_value = value + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString()) + ";path=/";
        document.cookie = c_name + "=" + c_value;
    };
    /**
     * Retrives a cookie from the document object using the cookies name
     * @c_name      Label of the cookie you want to retrieve.
     */
    Utils.getCookie = function (c_name) {
        var c_value = document.cookie;
        var c_start = c_value.indexOf(" " + c_name + "=");
        if (c_start == -1) {
            c_start = c_value.indexOf(c_name + "=");
        }
        if (c_start == -1) {
            c_value = null;
        }
        else {
            c_start = c_value.indexOf("=", c_start) + 1;
            var c_end = c_value.indexOf(";", c_start);
            if (c_end == -1) {
                c_end = c_value.length;
            }
            c_value = c_value.substring(c_start, c_end);
        }
        return c_value;
    };
    /* --------------------------------------------------------*/
    /* ---------------------- VALIDATION ----------------------*/
    /* --------------------------------------------------------*/
    /**
     * Validates an email address.
     */
    Utils.realEmail = function (addressToTest) {
        var regPattern = /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
        return regPattern.test(addressToTest);
    };
    return Utils;
}());
var StoryUtils = (function () {
    function StoryUtils() {
    }
    StoryUtils.getFirstCutTime = function (story, sceneId) {
        var time = 0;
        var scene = StoryUtils.getScene(story, sceneId);
        if (scene) {
            var cuts = scene.sceneData.cuts;
            var first = cuts[0];
            if (first) {
                time = first.startFrame / scene.sceneData.videoFile.rate;
            }
        }
        return time;
    };
    StoryUtils.getScene = function (story, sceneId, params) {
        var r = null;
        if (story.acts) {
            for (var key in story.acts) {
                if (story.acts.hasOwnProperty(key)) {
                    var act = story.acts[key];
                    if (act.scenes) {
                        for (var s in act.scenes) {
                            if (act.scenes.hasOwnProperty(s)) {
                                var scene = act.scenes[s];
                                if (scene.id == sceneId) {
                                    r = scene;
                                    return r;
                                }
                            }
                        }
                    }
                }
            }
        }
        return r;
    };
    StoryUtils.getAct = function (story, actId, params) {
        var act = null;
        if (story.acts) {
            if (story.acts.hasOwnProperty(actId)) {
                act = story.acts[actId];
                return act;
            }
        }
        return act;
    };
    StoryUtils.getInventory = function (story, invId) {
        var r = null;
        //run through all of the acts, and their scenes, and look for the label matching this ID
        if (story.acts) {
            for (var key in story.acts) {
                if (story.acts.hasOwnProperty(key)) {
                    var act = story.acts[key];
                    if (act.inventory) {
                        for (var s in act.inventory) {
                            if (act.inventory.hasOwnProperty(s)) {
                                var inv = act.inventory[s];
                                if (inv.id == invId) {
                                    r = inv;
                                    return r;
                                }
                            }
                        }
                    }
                }
            }
        }
        return r;
    };
    return StoryUtils;
}());
Math.radians = function (degrees) {
    return degrees * Math.PI / 180;
};
// Converts from radians to degrees.
Math.degrees = function (radians) {
    return radians * 180 / Math.PI;
};
Number.clamp = function (min, max) {
    return Math.min(Math.max(this, min), max);
};
THREE.Color.prototype['toVector4'] = function (alpha) {
    if (!alpha) {
        alpha = 1.0;
    }
    else {
        if (alpha < 0.0 || alpha > 1.0) {
            console.warn('First parameter passed to THREE.Color.toVector4 must be 0.0 <= alpha <= 1.0');
            alpha = Number.clamp(0.0, 1.0);
        }
    }
    return new THREE.Vector4(this.r, this.g, this.b, alpha);
};
var InstructionTrigger = (function () {
    function InstructionTrigger(triggerFunction) {
        this.triggerClickCount = 3;
        this.triggerElapsedTime = 20;
        this.touchCount = 0;
        this.clickCount = 0;
        this.triggerFunction = triggerFunction;
        this.reset();
    }
    InstructionTrigger.prototype.recordTouch = function () {
        if (++this.touchCount >= this.triggerClickCount) {
            this.wrappedTrigger();
        }
    };
    InstructionTrigger.prototype.recordClick = function () {
        if (++this.clickCount >= this.triggerClickCount) {
            this.wrappedTrigger();
        }
    };
    InstructionTrigger.prototype.reset = function () {
        var _this = this;
        this.wrappedTrigger = _.once(function () { return _this.trigger(); });
        this.touchCount = 0;
        this.clickCount = 0;
        TweenLite.delayedCall(this.triggerElapsedTime, this.wrappedTrigger);
    };
    InstructionTrigger.prototype.disable = function () {
        TweenLite.killDelayedCallsTo(this.wrappedTrigger);
    };
    InstructionTrigger.prototype.trigger = function () {
        TweenLite.killDelayedCallsTo(this.wrappedTrigger);
        this.triggerFunction();
    };
    return InstructionTrigger;
}());
var ProgressCircleShader = (function () {
    function ProgressCircleShader(radius, thickness, filled, colour) {
        if (radius === void 0) { radius = 0.6; }
        this.uniforms = {
            fProgress: { type: "f", value: 0.5 },
            vColour: { type: "v4", value: new THREE.Vector4(1.0, 1.0, 1.0, 1.0) }
        };
        this.defines = {
            PI: Math.PI,
            RADIUS: 0.6,
            THICKNESS: null
        };
        this.vertexShader = "\nuniform float fProgress;\n\nvoid main() {\n    float rotation = (fProgress * (position.x + 0.5) * PI * float(2));\n    \n    vec2 screenSpace = mat2(\n        cos(rotation), -sin(rotation),\n        sin(rotation), cos(rotation)\n    ) * vec2(0, position.y+float(RADIUS)+float(THICKNESS));\n    \n    gl_Position = projectionMatrix * modelViewMatrix * \n        vec4(\n            screenSpace.x,\n            screenSpace.y,\n            position.z, \n            1.0\n        );\n} \n";
        this.fragmentShader = "\nuniform vec4 vColour;\n\nvoid main() {\n    gl_FragColor = vColour;\n}\n";
        this.defines.RADIUS = radius;
        this.uniforms.fProgress.value = filled ? 1.0 : 0.0;
        this.defines.THICKNESS = thickness;
        if (colour) {
            this.uniforms.vColour.value = colour;
        }
    }
    return ProgressCircleShader;
}());
/// <reference path='./shaders/ProgressCircleShader.ts'/>
var ProgressCircle = (function (_super) {
    __extends(ProgressCircle, _super);
    function ProgressCircle(camera, thickness, radius, resolution, child) {
        if (thickness === void 0) { thickness = 0.15; }
        if (radius === void 0) { radius = 0.4; }
        if (resolution === void 0) { resolution = 18; }
        if (Main.mobile) {
            radius = 1;
        }
        var geo = new THREE.PlaneGeometry(1, thickness, resolution, 1);
        var material;
        if (child) {
            var shader = new ProgressCircleShader(radius, thickness, true, new THREE.Vector4(1, 1, 1, 0.2));
            material = new THREE.ShaderMaterial(shader);
            material.transparent = true;
        }
        else {
            var shader = new ProgressCircleShader(radius, thickness);
            material = new THREE.ShaderMaterial(shader);
        }
        //noinspection TypeScriptValidateTypes
        _super.call(this, geo, material);
        this.camera = camera;
        if (!child) {
            this.visible = false;
            this.backgroundCircle = new ProgressCircle(camera, thickness, radius, resolution, true);
            this.add(this.backgroundCircle);
            this.translateZ(0.1);
        }
        this.tweenVar = 0;
    }
    ProgressCircle.prototype.updateProgress = function (prog) {
        this.visible = true;
        this.material.uniforms.fProgress.value = prog;
    };
    ProgressCircle.prototype.updatePosition = function (mouse) {
        mouse.unproject(this.camera);
        var dir = mouse.sub(this.camera.position).normalize();
        var dist = (-30 - this.camera.position.z) / dir.z;
        var var5 = this.camera.position.clone().add(dir.multiplyScalar(dist));
        this.position.x = var5.x;
        this.position.y = var5.y;
        this.position.z = var5.z;
    };
    ProgressCircle.prototype.reset = function () {
        this.visible = false;
    };
    return ProgressCircle;
}(THREE.Mesh));
var TitleGenerator = (function () {
    function TitleGenerator(tSeq, pools, finalTitle) {
        this.finalize = false;
        this.currentIdx = 0;
        this.tSeq = tSeq;
        this.pools = pools;
        this.finalTitle = finalTitle;
        this.currentTemplate = this.tSeq[0];
    }
    TitleGenerator.prototype.finalized = function () {
        return this.finalize;
    };
    TitleGenerator.prototype.update = function (finalize) {
        this.finalize = finalize;
        if (this.finalize || !this.last || Math.random() > 0.75) {
            return this.generate();
        }
        else {
            return this.swap();
        }
    };
    TitleGenerator.prototype.swap = function () {
        var rand = _.sample(this.last);
        var idx = this.last.indexOf(rand);
        var t = _.findWhere(this.currentTemplate, { type: rand.type });
        var oldString = this.last[idx].string;
        var oldPlurality = this.last[idx].plural;
        if (this.last[idx].type === 'modifier') {
            this.last[idx].string = _.sample(t.list);
        }
        else {
            var plurality = t.value !== 'any' ? t.value : _.sample(['plural', 'singular']);
            var pool = _.sample(this.pools);
            this.last[idx].string = _.sample(pool.word_pool[t.type])[plurality];
            this.last[idx].originalPlurality = t.value;
            this.last[idx].plural = plurality === 'plural';
        }
        this.last[idx].dirty = oldString !== this.last[idx].string || oldPlurality !== this.last[idx].plural;
        if (this.last[idx].dirty) {
            return this.last;
        }
        else {
            return this.swap();
        }
    };
    TitleGenerator.prototype.generate = function () {
        var _this = this;
        var title = [];
        var foundMatch = !this.finalize;
        do {
            if (++this.currentIdx >= this.tSeq.length) {
                this.currentIdx = 0;
            }
            this.currentTemplate = this.tSeq[this.currentIdx];
            this.currentTemplate.forEach(function (current) {
                _this.finalTitle.forEach(function (final) {
                    if (current.type !== 'modifier' && current.type === final.type) {
                        foundMatch = true;
                    }
                });
            });
        } while (!foundMatch);
        var pool = _.sample(this.pools);
        var skipIdx = this.finalize ? _.findIndex(this.currentTemplate, function (ct) { return _.chain(_this.currentTemplate)
            .filter(function (t) { return t.type !== 'modifier'; })
            .sample()
            .isEqual(ct) // this is why <boolean>
            .pop()
            .value(); }) : -1;
        this.currentTemplate.forEach(function (t, idx) {
            if (_this.finalize && t.type !== 'modifier' && skipIdx !== idx) {
                var finalId = _.findIndex(_this.finalTitle, function (ft) { return ft.type === t.type; });
                if (finalId !== -1) {
                    title[idx] = {
                        string: _this.finalTitle[finalId].string,
                        type: _this.finalTitle[finalId].type,
                        colour: '0xFFFFFF',
                        dirty: true,
                        word: []
                    };
                    return;
                }
            }
            if (t.type === 'modifier') {
                title[idx] = {
                    string: _.sample(t.list),
                    type: 'modifier',
                    colour: '0xFFFFFF',
                    dirty: true,
                    word: []
                };
                return;
            }
            var plurality = t.value !== 'any' ? t.value : _.sample(['plural', 'singular']);
            var lastIdx = _.findIndex(_this.last, function (v) { return v.type === t.type && v.originalPlurality === t.value; });
            if (lastIdx !== -1) {
                title[idx] = _this.last[lastIdx];
                delete _this.last[lastIdx];
                _this.last = _.compact(_this.last);
                return;
            }
            title[idx] = {
                string: _.sample(pool.word_pool[t.type])[plurality],
                type: t.type,
                colour: '0xFFFFFF',
                dirty: true,
                word: [],
                plural: plurality === 'plural',
                originalPlurality: t.value
            };
        });
        this.last = title;
        return title;
    };
    TitleGenerator.prototype.wordList = function () {
        var list = [];
        this.pools.forEach(function (p) {
            _.map(p.word_pool, function (wps) {
                wps.forEach(function (wp) {
                    list.push(wp.plural, wp.singular);
                });
            });
        });
        this.tSeq.forEach(function (t) { return t.forEach(function (tkv) {
            if (tkv.type === 'modifier') {
                tkv.list.forEach(function (m) { return list.push(m); });
            }
        }); });
        return list;
    };
    return TitleGenerator;
}());
var BaseTitleSequence = (function (_super) {
    __extends(BaseTitleSequence, _super);
    function BaseTitleSequence(renderer, titleGenerator) {
        var _this = this;
        _super.call(this);
        this.lastTitles = [];
        this.padding = 2;
        this.pivotX = 0;
        this.pivotY = 0;
        this.pivotZ = 0;
        this.titleGenerator = titleGenerator;
        this.renderer = renderer;
        this.preRenderText();
        this.addEventListener(SeancesIntroScene.TITLE_SWAP, function () { return _this.shift(false); });
        this.addEventListener(SeancesIntroScene.FINALIZE_TITLE, function () { return _this.shift(true); });
        this.timeline = new TimelineMax();
        this.rotation.order = 'ZYX';
        this.startXPivot();
        this.startYPivot();
        this.startZPivot();
    }
    BaseTitleSequence.prototype.shift = function (finalize) {
        this.timeline = new TimelineMax();
        var titles = this.titleGenerator.update(finalize);
        this.updateTitles(titles);
        this.lastTitles = titles;
    };
    BaseTitleSequence.prototype.updateTitles = function (titles) {
        var _this = this;
        titles.forEach(function (t) { return _this.copyReusableTemplates(t); });
        var oldUuid = _.filter(this.children, function (c) { return c instanceof Word; }).map(function (c) { return c.uuid; });
        titles.forEach(function (t) { return _this.updateDirtyTitleTemplate(t); });
        var newUuid = _.pluck(_.flatten(titles.map(function (c) { return c.word; })), 'uuid');
        var remove = _.difference(oldUuid, newUuid);
        var add = _.difference(newUuid, oldUuid);
        var titleWords = titles.reduce(function (c, l) { return c + l.word.length; }, 0) - 1;
        var packedWidth = titles.reduce(function (c, l) {
            return c + l.word.reduce(function (c2, w) {
                return c2 + w.width();
            }, 0);
        }, this.padding * titleWords);
        var pos = -packedWidth / 2;
        titles.forEach(function (l) { return l.word.forEach(function (w, i) {
            pos += w.width() / 2;
            if (add.indexOf(w.uuid) !== -1) {
                w.position.x = pos;
                _this.timeline
                    .add(TweenMax.fromTo(w.position, 0.5, { z: 50 }, { z: 0 }), 0)
                    .add(TweenMax.fromTo(w.material.uniforms.vColour.value, 1, { w: 0 }, {
                    w: 1,
                    delay: l.word.length > 1 ? Math.random() / 4 : 0,
                    onStart: function () { return _this.add(w); }
                }), 0);
            }
            else if (remove.indexOf(w.uuid) === -1) {
                _this.timeline
                    .add(TweenMax.to(w.position, 1, { x: pos }), 0);
            }
            pos += w.width() / 2;
            pos += _this.padding;
        }); });
        remove.forEach(function (uuid) {
            var word = _this.getObjectByProperty('uuid', uuid);
            if (word) {
                _this.timeline
                    .add(TweenMax.to(word.position, 0.5, { z: -100 }), 0)
                    .add(TweenMax.to(word.material.uniforms.vColour.value, 0.75, {
                    w: 0,
                    onComplete: function () { return _this.remove(word); }
                }), 0);
            }
        });
        this.timeline.play();
    };
    BaseTitleSequence.prototype.updateDirtyTitleTemplate = function (t) {
        var _this = this;
        if (t.dirty) {
            var newWords_1 = t.string.split(' ').map(function (s) { return Word.makeWord({
                text: s,
                lineHeight: 10,
                colour: new THREE.Color(parseInt(t.colour)),
                yRange: 0,
                shaderMotion: true,
                distanceFadeOut: true
            }, _this.renderer); });
            if (t.word) {
                t.word.forEach(function (w, idx) {
                    if (newWords_1[idx]) {
                        newWords_1[idx].position.add(w.position);
                        newWords_1[idx].material.uniforms.fTime.value = w.material.uniforms.fTime.value;
                    }
                });
            }
            t.word = newWords_1;
            t.dirty = false;
        }
        return;
    };
    BaseTitleSequence.prototype.copyReusableTemplates = function (t) {
        var dirty = t.dirty;
        delete t.dirty;
        var tt = _.find(this.lastTitles, function (tt) { return _.isMatch(tt, t); });
        t.dirty = dirty;
        if (tt) {
            t.word = tt.word;
        }
    };
    BaseTitleSequence.prototype.getPivotFactor = function () {
        var rand = Math.random();
        return rand > 0.5 ? rand : rand - 1;
    };
    BaseTitleSequence.prototype.startXPivot = function () {
        var _this = this;
        TweenMax.to(this, 8, {
            pivotX: this.getPivotFactor() * 2 * Math.PI / 32,
            ease: Expo.easeOut,
            onUpdate: function () { return _this.rotation.x = _this.pivotX; },
            onComplete: function () { return _this.startXPivot(); }
        });
    };
    BaseTitleSequence.prototype.startYPivot = function () {
        var _this = this;
        TweenMax.to(this, 4, {
            pivotY: this.getPivotFactor() * 2 * Math.PI / 8,
            ease: Expo.easeOut,
            onUpdate: function () { return _this.rotation.y = _this.pivotY; },
            onComplete: function () { return _this.startYPivot(); }
        });
    };
    BaseTitleSequence.prototype.startZPivot = function () {
        var _this = this;
        TweenMax.to(this, 4, {
            pivotZ: this.getPivotFactor() * 2 * Math.PI / 64,
            ease: Expo.easeOut,
            onUpdate: function () { return _this.rotation.z = _this.pivotZ; },
            onComplete: function () { return _this.startZPivot(); }
        });
    };
    BaseTitleSequence.prototype.preRenderText = function () {
        var _this = this;
        this.titleGenerator.wordList().forEach(function (l) { return l.split(' ').forEach(function (w) { return _this.renderer.makeLineTexture(w); }); });
    };
    return BaseTitleSequence;
}(NickelGroup));
var TitleSequence = (function (_super) {
    __extends(TitleSequence, _super);
    function TitleSequence() {
        _super.apply(this, arguments);
    }
    TitleSequence.prototype.shift = function (finalize) {
        if (this.timeline.isActive()) {
            return;
        }
        return _super.prototype.shift.call(this, finalize);
    };
    return TitleSequence;
}(BaseTitleSequence));
var GenreGenerator = (function () {
    function GenreGenerator(genreData, filmLength) {
        this.startsWithVowel = {
            6: false,
            7: false,
            8: true,
            9: false,
            10: false,
            11: true,
            12: false,
            13: false,
            14: false,
            15: false,
            16: false,
            17: false,
            18: true,
            19: false,
            20: false,
            21: false,
            22: false
        };
        this.lastGenres = [];
        this.lastGenerated = [];
        this.mapping = ['adjectives', 'adjectives', 'nouns'];
        this.locked = false;
        this.genreData = genreData;
        this.filmLength = filmLength;
    }
    GenreGenerator.prototype.generate = function () {
        while (this.lastGenres.reduce(function (c, l) {
            // this is bad and I feel bad
            return (l !== undefined) ? c + 1 : c;
        }, 0) !== 3) {
            this.changeGenreText();
        }
        if (!this.locked)
            this.changeFilmLength();
        this.changeGenreText();
        this.lastGenerated = [{
                genre: this.startsWithVowel[this.lastFilmTime] ? 'An' : 'A',
                italics: false
            }, {
                genre: this.lastFilmTime.toString(),
                italics: false
            }, {
                genre: 'minute',
                italics: false
            },
            this.lastGenres[0],
            this.lastGenres[1],
            this.lastGenres[2]
        ];
        this.locked = false;
        return this.lastGenerated;
    };
    GenreGenerator.prototype.wordList = function () {
        var genres = [];
        for (var idx in this.genreData) {
            genres.push.apply(genres, this.genreData[idx]);
        }
        return genres;
    };
    GenreGenerator.prototype.lockFilmLength = function () {
        this.lastFilmTime = this.filmLength;
        this.locked = true;
    };
    GenreGenerator.prototype.changeFilmLength = function () {
        this.lastFilmTime = Math.round(Math.random() * 8 + 13);
        return;
    };
    GenreGenerator.prototype.changeGenreText = function (idx) {
        var _this = this;
        if (!idx) {
            idx = Math.floor(Math.random() * 3);
        }
        var type = this.mapping[idx];
        var genre = _.reject(this.genreData[type], function (e) { return _.some(_this.lastGenres, function (f) {
            if (f && e)
                return f.genre === e.genre;
        }); });
        this.lastGenres[idx] = _.sample(genre);
        return;
    };
    return GenreGenerator;
}());
var GenreSequence = (function (_super) {
    __extends(GenreSequence, _super);
    function GenreSequence(renderer, genreGenerator) {
        var _this = this;
        _super.call(this);
        this.lastGenres = [];
        this.padding = 1;
        this.renderer = renderer;
        this.genreGenerator = genreGenerator;
        this.preRenderText();
        this.addEventListener(SeancesIntroScene.TITLE_SWAP, function () { return _this.shift(); });
        this.addEventListener(SeancesIntroScene.FINALIZE_TITLE, function () {
            _this.genreGenerator.lockFilmLength();
            _this.shift();
        });
        this.timeline = new TimelineMax();
    }
    GenreSequence.prototype.shift = function () {
        var _this = this;
        if (this.timeline.isActive()) {
            return;
        }
        this.timeline = new TimelineMax();
        var genres = this.genreGenerator.generate();
        genres.forEach(function (g) { return _this.copyReusable(g); });
        var oldUuid = this.children.map(function (c) { return c.uuid; });
        genres.forEach(function (g) { return _this.createGenreWord(g); });
        var newUuid = _.pluck(_.flatten(genres.map(function (c) { return c.word; })), 'uuid');
        var remove = _.difference(oldUuid, newUuid);
        var add = _.difference(newUuid, oldUuid);
        var packedWidth = genres.reduce(function (c, l) {
            return c + l.word.width();
        }, this.padding * genres.length);
        var pos = -packedWidth / 2;
        genres.forEach(function (l) {
            var w = l.word;
            pos += l.word.width() / 2;
            if (add.indexOf(l.word.uuid) !== -1) {
                w.position.x = pos;
                _this.timeline.add(TweenMax.fromTo(w.material.uniforms.vColour.value, 1, { w: 0 }, { w: (Math.random() * 0.3) + 0.7, onStart: function () { return _this.add(w); } }), 0);
            }
            else if (remove.indexOf(w.uuid) === -1) {
                _this.timeline.add(TweenMax.to(w.position, 1, { x: pos }), 0);
            }
            pos += w.width() / 2;
            pos += _this.padding;
        });
        remove.forEach(function (uuid) {
            var word = _this.getObjectByProperty('uuid', uuid);
            if (word) {
                _this.timeline.add(TweenMax.to(word.material.uniforms.vColour.value, 0.75, { w: 0, onComplete: function () { return _this.remove(word); } }), 0);
            }
        });
        this.lastGenres = genres;
        this.timeline.play();
    };
    GenreSequence.prototype.createGenreWord = function (gd) {
        if (!gd.word) {
            gd.word = Word.makeWord({
                text: gd.genre,
                lineHeight: 10,
                colour: new THREE.Color(parseInt('0xFFFFFF')),
                yRange: 0,
                shaderMotion: false,
                smallCaps: false,
                italic: gd.italics
            }, this.renderer);
        }
    };
    GenreSequence.prototype.copyReusable = function (gd) {
        var gdgd = _.find(this.lastGenres, function (gdgd) { return _.isMatch(gdgd, gd); });
        if (gdgd) {
            gd.word = gdgd.word;
        }
    };
    GenreSequence.prototype.preRenderText = function () {
        var _this = this;
        this.genreGenerator.wordList().forEach(function (l) {
            var extra = l.italics ? ['italic'] : [];
            _this.renderer.makeLineTexture(l.genre, extra);
        });
    };
    return GenreSequence;
}(NickelGroup));
var RGBGlitchShader = (function () {
    function RGBGlitchShader() {
        this.uniforms = {
            "tDiffuse": { type: "t", value: null },
            "tDiffuseNoise": { type: "t", value: null },
            "fGlobalTime": { type: "f", value: 0.1 },
            "fAmplitude": { type: "f", value: 0.00 },
            "fSpeed": { type: "f", value: 0.2 }
        };
        this.vertexShader = "\nuniform float fSpeed;\nuniform float fGlobalTime;\n\nvarying vec2 vUv;\nvarying float fDisplacement;\nvarying vec4 vOffsets;\n\nvoid main() {\n    vUv = uv;\n    fDisplacement = fGlobalTime * fSpeed;\n    float fDisplacementSpeed = fDisplacement * fSpeed * float(250);\n    \n    vec2 vOffset = vec2(\n        sin(fDisplacementSpeed),\n        cos(fDisplacementSpeed)\n    );\n    \n    vOffsets = vec4(vOffset.xy, vOffset.xy * -1.0);\n    \n    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}\n";
        this.fragmentShader = "\nuniform sampler2D tDiffuse;\nuniform sampler2D tDiffuseNoise;\nuniform float fAmplitude;\n\nvarying vec2 vUv;\nvarying float fDisplacement;\nvarying vec4 vOffsets;\n\nvoid main() {\n    vec4 linearShift = texture2D(tDiffuseNoise, vec2(fDisplacement, fDisplacement * 0.2), 0.0);\n    \n    vec4 shift = vec4(\n        pow(linearShift.xyz, vec3(8.0)), \n        linearShift.w\n    ) * vec4(vec3(fAmplitude), 1.0);\n    \n    shift *= 2.0 * shift.w - 1.0;\n\n    // multiply then add = single instruction\n    vec4 r = texture2D(tDiffuse, vec2(clamp(shift.x + shift.y, 0.0, 1.0)) * vOffsets.yw + vUv, 0.0);\n    vec4 g = texture2D(tDiffuse, vec2(clamp(shift.y + shift.z, 0.0, 1.0)) * vOffsets.xy + vUv, 0.0);\n    vec4 b = texture2D(tDiffuse, vec2(clamp(shift.z + shift.x, 0.0, 1.0)) * vOffsets.wz + vUv, 0.0);\n    \n    gl_FragColor = vec4(\n        r.x,\n        g.y,\n        b.z,\n        clamp(r.w + g.w + b.w, 0.0, 1.0)\n    );\n}\n";
    }
    return RGBGlitchShader;
}());
var GridImages = (function () {
    function GridImages() {
    }
    GridImages.randomImage = function () {
        if (GridImages.preloadedImages.length < 5) {
            GridImages.preload(GridImages.PRELOAD_BATCH_SIZE);
        }
        if (GridImages.preloadedImages.length === 0) {
            return CDN_GLOBAL_PREFIX + GridImages.urlPrefix + _.sample(GridImages.urls);
        }
        return GridImages.preloadedImages.pop();
    };
    GridImages.width = function () {
        return 1920;
    };
    GridImages.height = function () {
        return 1080;
    };
    GridImages.preload = function (quantity) {
        var _this = this;
        var num = quantity;
        if (Main.mobile) {
            num = num / 2;
        }
        var imageLoader = new THREE.ImageLoader();
        imageLoader.setCrossOrigin('anonymous');
        var images = num ? _.sample(GridImages.urls, num) : GridImages.urls;
        images.forEach(function (url) {
            var fullUrl = CDN_GLOBAL_PREFIX + GridImages.urlPrefix + url;
            var loadedImages = imageLoader.load(fullUrl, function () { return _this.preloadedImages.push(fullUrl); });
        });
    };
    GridImages.urls = [
        "grid_image_bits_of_life_01.jpg",
        "grid_image_bits_of_life_02.jpg",
        "grid_image_bits_of_life_03.jpg",
        "grid_image_bits_of_life_04.jpg",
        "grid_image_bits_of_life_05.jpg",
        "grid_image_bits_of_life_06.jpg",
        "grid_image_bits_of_life_07.jpg",
        "grid_image_bits_of_life_08.jpg",
        "grid_image_bits_of_life_09.jpg",
        "grid_image_bits_of_life_10.jpg",
        "grid_image_bits_of_life_11.jpg",
        "grid_image_bits_of_life_12.jpg",
        "grid_image_bits_of_life_13.jpg",
        "grid_image_bits_of_life_14.jpg",
        "grid_image_blind_girl_01.jpg",
        "grid_image_blind_girl_02.jpg",
        "grid_image_blind_girl_03.jpg",
        "grid_image_blind_girl_04.jpg",
        "grid_image_blind_girl_05.jpg",
        "grid_image_blind_girl_06.jpg",
        "grid_image_blind_girl_07.jpg",
        "grid_image_blind_girl_08.jpg",
        "grid_image_bmm_01.jpg",
        "grid_image_cc_01.jpg",
        "grid_image_dalagang_bukid_01.jpg",
        "grid_image_dalagang_bukid_02.jpg",
        "grid_image_der_januskopf_01.jpg",
        "grid_image_der_januskopf_02.jpg",
        "grid_image_der_januskopf_03.jpg",
        "grid_image_der_januskopf_04.jpg",
        "grid_image_der_januskopf_05.jpg",
        "grid_image_der_januskopf_06.jpg",
        "grid_image_der_januskopf_07.jpg",
        "grid_image_dracula_halala_01.jpg",
        "grid_image_dream_woman_01.jpg",
        "grid_image_dream_woman_02.jpg",
        "grid_image_dream_woman_03.jpg",
        "grid_image_dream_woman_04.jpg",
        "grid_image_foc_alternate_01.jpg",
        "grid_image_foc_alternate_02.jpg",
        "grid_image_foc_alternate_03.jpg",
        "grid_image_foc_alternate_04.jpg",
        "grid_image_foc_alternate_05.jpg",
        "grid_image_forbidden_room_01.jpg",
        "grid_image_forbidden_room_04.jpg",
        "grid_image_forbidden_room_alt_01.jpg",
        "grid_image_forbidden_room_alt_02.jpg",
        "grid_image_forbidden_room_alt_03.jpg",
        "grid_image_gabriela_01.jpg",
        "grid_image_gabriela_02.jpg",
        "grid_image_gabriela_03.jpg",
        "grid_image_gabriela_04.jpg",
        "grid_image_gabriela_05.jpg",
        "grid_image_gabriela_06.jpg",
        "grid_image_gabriela_07.jpg",
        "grid_image_gbs_01.jpg",
        "grid_image_gbs_02.jpg",
        "grid_image_httab_01.jpg",
        "grid_image_lotm_05.jpg",
        "grid_image_obw_alternate_01.jpg",
        "grid_image_obw_alternate_02.jpg",
        "grid_image_obw_alternate_03.jpg",
        "grid_image_obw_alternate_04.jpg",
        "grid_image_poto_poto_06.jpg",
        "grid_image_poto_poto_07.jpg",
        "grid_image_potopoto_01.jpg",
        "grid_image_potopoto_02.jpg",
        "grid_image_potopoto_03.jpg",
        "grid_image_potopoto_04.jpg",
        "grid_image_potopoto_05.jpg",
        "grid_image_red_wolves_02.jpg",
        "grid_image_red_wolves_03.jpg",
        "grid_image_red_wolves_04.jpg",
        "grid_image_red_wolves_05.jpg",
        "grid_image_red_wolves_06.jpg",
        "grid_image_red_wolves_07.jpg",
        "grid_image_red_wolves_08.jpg",
        "grid_image_red_wolves_09.jpg",
        "grid_image_redwolves_01.jpg",
        "grid_image_saint_devil_woman_01.jpg",
        "grid_image_saint_devil_woman_02.jpg",
        "grid_image_saint_devil_woman_03.jpg",
        "grid_image_saint_devil_woman_04.jpg",
        "grid_image_saint_devil_woman_05.jpg",
        "grid_image_scorching_flame_01.jpg",
        "grid_image_scorching_flame_02.jpg",
        "grid_image_scorching_flame_03.jpg",
        "grid_image_scorching_flame_04.jpg",
        "grid_image_scorching_flame_05.jpg",
        "grid_image_scorching_flame_06.jpg",
        "grid_image_scorching_flame_07.jpg",
        "grid_image_scout_day_01.jpg",
        "grid_image_scout_day_02.jpg",
        "grid_image_soam_01.jpg",
        "grid_image_tokyo_ginza_district_01.jpg",
        "grid_image_tokyo_ginza_district_02.jpg",
        "grid_image_tokyo_ginza_district_03.jpg",
        "grid_image_tokyo_ginza_district_04.jpg",
        "grid_image_tokyo_ginza_district_05.jpg",
        "grid_image_tokyo_ginza_district_06.jpg",
        "grid_image_trumpet_island_01.jpg",
        "grid_image_trumpet_island_02.jpg",
        "grid_image_trumpet_island_03.jpg",
        "grid_image_trumpet_island_04.jpg",
        "grid_image_women_skeletons_01.jpg",
        "grid_image_women_skeletons_02.jpg",
        "grid_image_women_skeletons_03.jpg",
        "grid_image_women_skeletons_04.jpg",
        "grid_image_women_skeletons_05.jpg",
        "grid_image_women_skeletons_06.jpg",
        "grid_image_women_skeletons_07.jpg",
        "grid_image_women_skeletons_08.jpg",
        "grid_image_women_skeletons_09.jpg",
    ];
    GridImages.preloadedImages = [];
    GridImages.urlPrefix = '/img/grid/';
    GridImages.PRELOAD_BATCH_SIZE = 10;
    return GridImages;
}());
/// <reference path='./SeancesScene.ts'/>
/// <reference path='../../scaffolding/Main.ts'/>
/// <reference path='../../scaffolding/EventBus.ts'/>
/// <reference path='../../scaffolding/Utils.ts'/>
/// <reference path='../InstructionTrigger.ts'/>
/// <reference path='../ProgressCircle.ts'/>
/// <reference path='../title/TitleGenerator.ts'/>
/// <reference path='../title/TitleSequence.ts'/>
/// <reference path='../title/GenreGenerator.ts'/>
/// <reference path='../title/GenreSequence.ts'/>
/// <reference path='../shaders/RGBGlitchShader.ts'/>
/// <reference path='../assets/GridImages.ts'/>
var instructTween;
var SeancesIntroScene = (function (_super) {
    __extends(SeancesIntroScene, _super);
    function SeancesIntroScene(progress, textureLoader, d, bgDims, tDims, planeImageFactory) {
        var _this = this;
        _super.call(this);
        this.isCountdownOver = false;
        this.countdownTargetTime = 3;
        this.timeline = new TimelineMax();
        this.backgroundSwapping = false;
        this.instructionsVisible = false;
        this.lastTouchPosition = new THREE.Vector2(50, 200); // arbitrary values
        this.topBar = $('.top-bar');
        this.bottomBar = $('.footer');
        this.moveHandler = function (e) { return _this.mouseMove(e.message); };
        this.bgImages = [
            "Grid_Image_Bits_of_Life_09.jpg",
            "Grid_Image_Bits_of_Life_10.jpg",
            "Grid_Image_Bits_of_life_13.jpg",
            "Grid_Image_Blind_Girl_06.jpg",
            "Grid_Image_Der_Januskopf_05.jpg",
            "Grid_Image_Der_Januskopf_06.jpg",
            "Grid_Image_Der_Januskopf_07.jpg",
            "Grid_Image_Dream_Woman_02.jpg",
            "Grid_Image_Dream_Woman_021.jpg",
            "Grid_Image_Dream_Woman_04.jpg",
            "Grid_Image_Forbidden_Room_04.jpg",
            "Grid_Image_GBS_01.jpg",
            "Grid_Image_Saint_Devil_Woman_03.jpg",
            "Grid_Image_Saint_Devil_Woman_04.jpg",
            "Grid_Image_Saint_Devil_Woman_051.jpg",
            "Grid_Image_Scorching_Flame_03.jpg",
            "Grid_Image_Tokyo_Ginza_Disctrict_04.jpg",
            "Grid_Image_Tokyo_Ginza_District_03.jpg",
            "Grid_Image_Women_Skeletons_08.jpg",
            "Grid_Image_Women_Skeletons_09.jpg"
        ];
        this.mousePosition = new THREE.Vector3(0, 0, 0.5);
        this.textureLoader = textureLoader;
        this.backgroundDims = bgDims;
        this.titleDims = tDims;
        this.progressCircle = progress;
        this.add(this.progressCircle);
        this.planeImageFactory = planeImageFactory;
        if (Main.mobile) {
            $(window).bind('resize orientationchange', function () { return _this.mobileResize(); });
            this.mobileResize();
            this.init(d);
        }
        else {
            this.init(d);
        }
    }
    SeancesIntroScene.prototype.init = function (d) {
        var _this = this;
        this.titleScreenLoop = buzzSoundCdn('/audio/title_screen_loop.mp3').fadeIn(800).play().loop();
        this.clickStartSound = buzzSoundCdn('/audio/click_start.mp3');
        this.clickSuccessSound = buzzSoundCdn('/audio/click_success.mp3');
        this.clickFailSound = buzzSoundCdn("/audio/click_fail.mp3");
        this.glitchSounds = [
            buzzSoundCdn("/audio/Animation_glitch_01.mp3"),
            buzzSoundCdn("/audio/Animation_glitch_02.mp3"),
            buzzSoundCdn("/audio/Animation_glitch_03.mp3"),
            buzzSoundCdn("/audio/Animation_glitch_04.mp3")
        ];
        this.addEventListener('mousedown', function (e) { return _this.mouseDown(e.message); });
        this.addEventListener('touchstart', function (e) { return _this.mouseDown(e.message); });
        this.addEventListener('mousemove', this.moveHandler);
        this.addEventListener('touchmove', this.moveHandler);
        this.addEventListener('mouseup', function (e) { return _this.mouseUp(e.message); });
        this.addEventListener('touchend', function (e) { return _this.mouseUp(e.message); });
        this.texAtlas = new TextureAtlas(12, $("#atlasRenderer"));
        this.titleRenderer = new LineTextureRenderer('Hoefler Text SC', 36, this.texAtlas);
        this.genreRenderer = new LineTextureRenderer('Hoefler Text', 36, this.texAtlas);
        this.titleSequence = new TitleSequence(this.titleRenderer, new TitleGenerator(d.template_sequence, [d.a, d.b, d.c], d.title));
        this.genreSequence = new GenreSequence(this.genreRenderer, new GenreGenerator(d.genres, Math.floor(d.film_length / 60)));
        var genreZ = -375;
        var genreY = -70;
        var titleZ = -175;
        var titleY = 4;
        var imageZ = -375;
        var imageY = 84;
        if (Main.mobile) {
            genreZ = -120;
            genreY = -22;
            titleZ = -100;
            titleY = 1.8;
            imageZ = -100;
            imageY = 22;
        }
        this.titleSequence.translateZ(titleZ);
        this.titleSequence.translateY(titleY);
        this.add(this.titleSequence);
        this.genreSequence.translateZ(genreZ);
        this.genreSequence.translateY(genreY);
        this.add(this.genreSequence);
        this.addEventListener(NickelScene.TICK_EVENT, function () {
            _this.glitchPass.uniforms.fGlobalTime.value += 0.005;
        });
        this.planeImageFactory.createImage('/img/seances_wordmark_xl.png').then(function (i) {
            var scale = { x: 1, y: 1, z: 1 };
            for (var idx in scale) {
                scale[idx] = scale[idx] * 0.07;
            }
            i.position.setY(imageY);
            i.position.setZ(imageZ);
            i.geometry.scale(scale.x, scale.y, scale.z);
            _this.add(i);
        });
        if (!Main.mobile) {
            this.videoBackground = new VideoBackground(this.backgroundDims.height, this.backgroundPool);
            this.videoBackground.translateZ(-1000);
            this.add(this.videoBackground);
        }
        else {
            this.imageBackground = new ImageBackground(this.backgroundDims.height, this.bgImages);
            this.imageBackground.translateZ(-1000);
            this.add(this.imageBackground);
        }
        this.ambientGlitchingTimer();
        this.delayedShiftTitles();
        this.instructionsElement = $('#instructions');
        this.instructionsTrigger = new InstructionTrigger(function () { return _this.instructionsTriggered(); });
        this.instructionsTween = TweenMax.fromTo(this.instructionsElement, 1, { opacity: 0 }, {
            opacity: 0.8,
            onStart: function () {
                _this.instructionsVisible = true;
                _this.updateInstructionsPosition();
            },
            onReverseComplete: function () {
                _this.instructionsVisible = false;
            },
            immediateRender: true,
            paused: true
        });
        instructTween = this.instructionsTween;
        this.addEventListener(Stage.NEXT_SCENE, function () { return _this.instructionsTrigger.disable(); });
        gaTrackEvent('title_sequence', 'start');
    };
    SeancesIntroScene.prototype.instructionsTriggered = function () {
        this.instructionsTween.timeScale(1);
        this.instructionsTween.play();
    };
    SeancesIntroScene.prototype.mouseMove = function (e) {
        this.updateLastTouchPosition(e.originalEvent);
    };
    SeancesIntroScene.prototype.mouseDown = function (e) {
        this.updateLastTouchPosition(e.originalEvent);
        if (this.instructionsTween.progress() > 0.3 && !this.instructionsTween.reversed()) {
            this.instructionsTrigger.reset();
            this.instructionsTween.timeScale(4);
            this.instructionsTween.reverse();
        }
        this.startCountdown();
    };
    SeancesIntroScene.prototype.updateLastTouchPosition = function (e) {
        if (e instanceof MouseEvent) {
            this.lastTouchPosition.set(e.clientX, e.clientY);
            if (e.type == "mouseup") {
                this.instructionsTrigger.recordClick();
            }
        }
        else if (e instanceof TouchEvent) {
            this.lastTouchPosition.set(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            if (e.type === 'touchend') {
                this.instructionsTrigger.recordTouch();
            }
        }
        else {
            return;
        }
        this.updateInstructionsPosition();
    };
    SeancesIntroScene.prototype.updateInstructionsPosition = function () {
        var pointer = this.lastTouchPosition;
        if (!this.instructionsLastWidth || this.instructionsLastWidth < 10)
            this.instructionsLastWidth = this.instructionsElement[0].getBoundingClientRect().width;
        if (!this.instructionsLastHeight || this.instructionsLastHeight < 10)
            this.instructionsLastHeight = this.instructionsElement[0].getBoundingClientRect().height;
        var eleW = this.instructionsLastWidth;
        var eleH = this.instructionsLastHeight;
        var topBound = this.topBar.height() + eleH;
        var bottomBound = window.innerHeight - this.bottomBar.height();
        var rightBound = window.innerWidth - eleW;
        if (pointer.y < topBound) {
            pointer.setY(topBound);
        }
        else if (pointer.y > bottomBound) {
            pointer.setY(bottomBound);
        }
        if (pointer.x > rightBound) {
            pointer.setX(rightBound);
        }
        this.instructionsElement.css('left', pointer.x);
        this.instructionsElement.css('top', pointer.y - eleH);
    };
    SeancesIntroScene.prototype.startCountdown = function () {
        var _this = this;
        this.clickStartSound.play();
        this.timeline.add(TweenMax.fromTo(this.progressCircle, this.countdownTargetTime / 16, { tweenVar: 0 }, {
            tweenVar: 0.5,
            onUpdate: function () { return _this.updateCountdown(_this.progressCircle.tweenVar); },
        }));
        this.timeline.add(TweenMax.to(this.progressCircle, 15 * this.countdownTargetTime / 16, {
            tweenVar: 1,
            onUpdate: function () { return _this.updateCountdown(_this.progressCircle.tweenVar); },
            onComplete: function () { return _this.countdownOver(); }
        }));
        this.intensity = 'lots';
    };
    SeancesIntroScene.prototype.mouseUp = function (e) {
        this.updateLastTouchPosition(e.originalEvent);
        if (!this.isCountdownOver) {
            this.endCountdown();
        }
    };
    SeancesIntroScene.prototype.endCountdown = function () {
        this.intensity = 'none';
        this.progressCircle.reset();
        this.remove(this.staticBackground);
        this.timeline.clear();
        this.clickStartSound.stop();
        if (this.isCountdownOver) {
            this.clickSuccessSound.play();
            this.intensityTween.kill();
            this.shiftingTween.kill();
            for (var sound in buzz.sounds) {
                buzz.sounds[sound].stop();
            }
            this.dispatchEvent({ type: Stage.NEXT_SCENE });
            gaTrackEvent('title_sequence', 'end');
        }
        else {
            this.shiftingTween.resume();
            this.clickFailSound.play();
        }
    };
    SeancesIntroScene.prototype.updateCountdown = function (progress) {
        this.progressCircle.updateProgress(Math.min(progress, 1.00));
        switch (true) {
            case (progress >= 0.25 && progress < 0.50):
                this.intensity = 'lots';
                break;
            case (progress >= 0.50 && progress < 0.75):
                this.intensity = 'crazy';
                if (!this.shiftingTween.paused())
                    this.shiftFinalTitle();
                break;
            case (progress >= 0.75 && progress < 0.90):
                this.intensity = 'frenetic';
                break;
            case (progress >= 0.90 && progress < 1.00):
                this.intensity = 'lots';
                break;
        }
        if (progress >= 0.5 && !this.backgroundSwapping) {
            this.backgroundSwapping = true;
            this.changeStaticBackground();
        }
    };
    SeancesIntroScene.prototype.countdownOver = function () {
        this.isCountdownOver = true;
        this.endCountdown();
    };
    SeancesIntroScene.prototype.getPostProcessingPasses = function () {
        this.glitchPass = new ShaderPass(new RGBGlitchShader());
        this.glitchPass.uniforms.tDiffuseNoise.value = this.textureLoader.load('/img/tex16.png');
        this.glitchPass.uniforms.tDiffuseNoise.value.wrapS = this.glitchPass.uniforms.tDiffuseNoise.value.wrapT = THREE.RepeatWrapping;
        if (Main.mobile) {
            return [];
        }
        else {
            return [this.glitchPass];
        }
    };
    Object.defineProperty(SeancesIntroScene.prototype, "intensity", {
        get: function () {
            switch (this.glitchPass.uniforms.fAmplitude.value) {
                case 0:
                    return 'none';
                case 0.04:
                    return 'slight';
                case 0.08:
                    return 'lots';
                case 0.12:
                    return 'crazy';
                case 0.16:
                    return 'frenetic';
            }
        },
        set: function (glitch) {
            if (glitch != 'none') {
                this.playGlitchSound();
            }
            switch (glitch) {
                case 'none':
                    this.glitchPass.uniforms.fSpeed.value = 0.2;
                    this.glitchPass.uniforms.fAmplitude.value = 0;
                    if (this.titleSequence)
                        this.titleSequence.children.forEach(function (i) {
                            if (i instanceof Word)
                                i.material.uniforms.fDistortionIntensity.value = 0.0;
                        });
                    return;
                case 'slight':
                    this.glitchPass.uniforms.fSpeed.value = 0.2;
                    this.glitchPass.uniforms.fAmplitude.value = 0.04;
                    if (this.titleSequence)
                        this.titleSequence.children.forEach(function (i) {
                            if (i instanceof Word)
                                i.material.uniforms.fDistortionIntensity.value = 0.00025;
                        });
                    return;
                case 'lots':
                    this.glitchPass.uniforms.fSpeed.value = 0.4;
                    this.glitchPass.uniforms.fAmplitude.value = 0.08;
                    if (this.titleSequence)
                        this.titleSequence.children.forEach(function (i) {
                            if (i instanceof Word)
                                i.material.uniforms.fDistortionIntensity.value = 0.000375;
                        });
                    return;
                case 'crazy':
                    this.glitchPass.uniforms.fSpeed.value = 0.6;
                    this.glitchPass.uniforms.fAmplitude.value = 0.12;
                    if (this.titleSequence)
                        this.titleSequence.children.forEach(function (i) {
                            if (i instanceof Word)
                                i.material.uniforms.fDistortionIntensity.value = 0.00050;
                        });
                    return;
                case 'frenetic':
                    this.glitchPass.uniforms.fSpeed.value = 0.8;
                    this.glitchPass.uniforms.fAmplitude.value = 0.16;
                    if (this.titleSequence)
                        this.titleSequence.children.forEach(function (i) {
                            if (i instanceof Word)
                                i.material.uniforms.fDistortionIntensity.value = 0.000625;
                        });
                    return;
            }
        },
        enumerable: true,
        configurable: true
    });
    SeancesIntroScene.prototype.changeStaticBackground = function () {
        var _this = this;
        this.textureLoader.load(GridImages.randomImage(), function (t) {
            t.format = THREE.RGBFormat;
            _this.staticBackground = new Background(t, new THREE.Box2(new THREE.Vector2(0, 0), new THREE.Vector2(GridImages.width(), GridImages.height())), _this.backgroundDims.height);
            _this.staticBackground.translateZ(-950);
            _this.add(_this.staticBackground);
            setTimeout(function (b) { return _this.remove(b); }, 50, _this.staticBackground);
            setTimeout(function () { return _this.backgroundSwapping = false; }, Math.floor(Math.random() * 750));
        });
    };
    SeancesIntroScene.prototype.ambientGlitchingTimer = function () {
        var _this = this;
        if (this.glitchPass && this.intensity === 'none') {
            this.intensityTween = TweenMax.delayedCall(Math.random() * 9 + 1, function () {
                if (_this.glitchPass && _this.intensity === 'none')
                    _this.intensity = 'slight';
                _this.ambientGlitchingTimer();
            });
        }
        else if (this.glitchPass && this.intensity === 'slight') {
            this.intensityTween = TweenMax.delayedCall((Math.sin(2 * Math.PI * Math.random()) / 5 + 1), function () {
                if (_this.glitchPass)
                    _this.intensity = 'none';
                _this.ambientGlitchingTimer();
            });
        }
        else {
            this.intensityTween = TweenMax.delayedCall(1, function () { return _this.ambientGlitchingTimer(); });
        }
        return;
    };
    SeancesIntroScene.prototype.playGlitchSound = function () {
        _.sample(this.glitchSounds).play();
    };
    SeancesIntroScene.prototype.shiftTitles = function () {
        this.children.forEach(function (c) { return TweenMax.delayedCall(Math.random(), function () { return c.dispatchEvent({ type: SeancesIntroScene.TITLE_SWAP }); }); });
        return;
    };
    SeancesIntroScene.prototype.delayedShiftTitles = function () {
        var _this = this;
        this.shiftTitles();
        this.shiftingTween = TweenMax.delayedCall(Math.random() * 9 + 1, function () { return _this.delayedShiftTitles(); });
    };
    SeancesIntroScene.prototype.shiftFinalTitle = function () {
        this.shiftingTween.pause();
        this.children.forEach(function (c) { return c.dispatchEvent({ type: SeancesIntroScene.FINALIZE_TITLE }); });
    };
    SeancesIntroScene.prototype.mobileResize = function () {
        if (Main.sWidth > Main.sHeight) {
            $('#container').removeClass('hide');
            $('.rotate').removeClass('show');
        }
        else {
            $('#container').addClass('hide');
            $('.rotate').addClass('show');
        }
    };
    SeancesIntroScene.TITLE_SWAP = 'title_swap';
    SeancesIntroScene.FINALIZE_TITLE = 'finalize_title';
    return SeancesIntroScene;
}(SeancesScene));
/// <reference path='../../scaffolding/Component.ts'/>
/// <reference path='../../scaffolding/EventBus.ts'/>
var IntroSceneNoThree = (function (_super) {
    __extends(IntroSceneNoThree, _super);
    function IntroSceneNoThree(container, data, delegate) {
        _super.call(this, container, data, delegate);
        this.textCount = 0;
        this.outDelay = 3.5;
        this.duration = 1.7;
        this.textArray = [{
                "line1": "Guy Maddin, Evan Johnson, Galen Johnson and",
                "line2": "the National Film Board of Canada",
                "line3": "present"
            }, {
                "line1": "zero",
                "line2": "one",
                "line3": "two",
            }];
        this.setContent(Main.templates.find('.intro').clone());
        this.resize();
        this.instruction = this.content.find(".instruction");
        this.startAnimating();
    }
    IntroSceneNoThree.prototype.startAnimating = function () {
        gaTrackEvent('intro', 'start');
        var logo = this.content.find('.logo');
        TweenMax.to(logo, this.duration, { 'ease': Linear.easeNone, 'opacity': 1, delay: 0.5 });
        TweenMax.to(logo, this.duration, {
            'ease': Linear.easeNone,
            'opacity': 0,
            delay: this.outDelay,
            onComplete: $.proxy(this.creditAnimate, this)
        });
    };
    IntroSceneNoThree.prototype.creditAnimate = function () {
        var credit = this.content.find(".credit");
        var creditText = this.textArray[0];
        for (var text in creditText) {
            var line = "<div class='textLine'>" + creditText[text] + "</div>";
            credit.append(line);
        }
        TweenMax.to(credit, this.duration, { 'ease': Linear.easeNone, 'opacity': 1, delay: 0.5 });
        TweenMax.to(credit, this.duration, {
            'ease': Linear.easeNone,
            'opacity': 0,
            delay: this.outDelay,
            onComplete: $.proxy(this.seancesAnimate, this)
        });
    };
    IntroSceneNoThree.prototype.seancesAnimate = function () {
        var seances = this.content.find(".seances");
        TweenMax.to(seances, this.duration, { 'ease': Linear.easeNone, 'opacity': 1, delay: 0.5 });
        TweenMax.to(seances, this.duration, {
            'ease': Linear.easeNone,
            'opacity': 0,
            delay: this.outDelay,
            onComplete: $.proxy(this.instructionText, this)
        });
    };
    IntroSceneNoThree.prototype.instructionText = function () {
        var instructionText = this.textArray[1];
        var offset = this.duration;
        var count = 0;
        for (var text in instructionText) {
            TweenMax.to($("." + instructionText[text]), 1, {
                'ease': Linear.easeNone,
                'opacity': 1,
                delay: offset * count,
                onComplete: $.proxy(this.textDoneAnimating, this)
            });
            count++;
        }
    };
    IntroSceneNoThree.prototype.removeTextNode = function () {
        this.instruction.find('div:first').remove();
    };
    IntroSceneNoThree.prototype.textDoneAnimating = function () {
        this.textCount++;
        if (this.textCount == 3) {
            setTimeout(function () {
                EventBus.dispatchEvent('INTRO_OVER');
                gaTrackEvent('intro', 'over');
            }, 2000);
        }
    };
    IntroSceneNoThree.prototype.resize = function (e) {
        if (e === void 0) { e = null; }
        if (this.content) {
            this.content.css({
                'width': Main.sWidth,
                'height': Main.sHeight
            });
        }
    };
    return IntroSceneNoThree;
}(Component));
/// <reference path='../../scaffolding/Component.ts'/>
/// <reference path='../../scaffolding/EventBus.ts'/>
var AboutScene = (function (_super) {
    __extends(AboutScene, _super);
    function AboutScene(container, data, delegate) {
        var _this = this;
        _super.call(this, container, data, delegate);
        this.content = container;
        this.resize();
        $(".closeBtn").bind('click', function () { return _this.hideMe(); });
        EventBus.addEventListener('showabout', function () { return _this.showMe(); }, this);
        EventBus.addEventListener('hideabout', function () { return _this.hideMe(); }, this);
    }
    return AboutScene;
}(Component));
/// <reference path='../../scaffolding/Component.ts'/>
/// <reference path='../../scaffolding/EventBus.ts'/>
var CreditsScene = (function (_super) {
    __extends(CreditsScene, _super);
    function CreditsScene(container, data, delegate) {
        var _this = this;
        _super.call(this, container, data, delegate);
        this.content = container;
        $(".closeBtn").bind('click', function () { return _this.hideMe(); });
        EventBus.addEventListener('showcredits', function () { return _this.showMe(); }, this);
        EventBus.addEventListener('hidecredits', function () { return _this.hideMe(); }, this);
    }
    return CreditsScene;
}(Component));
var PlaneImageFactory = (function () {
    function PlaneImageFactory(loader) {
        this.loader = loader;
    }
    PlaneImageFactory.prototype.createImage = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.loader.load(url, function (image) {
                var canvas = document.createElement('canvas');
                canvas.width = image.width;
                canvas.height = image.height;
                canvas.getContext('2d').drawImage(image, 0, 0);
                var mat = new THREE.MeshBasicMaterial({
                    'map': new THREE.CanvasTexture(canvas),
                    'transparent': true
                });
                var geo = new THREE.PlaneGeometry(image.width, image.height);
                resolve(new THREE.Mesh(geo, mat));
            }, null, function (err) {
                reject(err);
            });
        });
    };
    return PlaneImageFactory;
}());
var PlaneImage = (function (_super) {
    __extends(PlaneImage, _super);
    function PlaneImage() {
        _super.apply(this, arguments);
    }
    return PlaneImage;
}(THREE.Mesh));
var ShaderPass = (function () {
    function ShaderPass(shader, textureID) {
        this.enabled = true;
        this.needsSwap = true;
        this.renderToScreen = false;
        this.textureID = "tDiffuse";
        this.clear = false;
        this.camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        this.scene = new THREE.Scene();
        this.quad = new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 2), null);
        if (textureID)
            this.textureID = textureID;
        if (shader instanceof THREE.ShaderMaterial) {
            this.uniforms = shader.uniforms;
            this.material = shader;
        }
        else if (shader) {
            this.uniforms = THREE.UniformsUtils.clone(shader.uniforms);
            this.material = new THREE.ShaderMaterial({
                defines: shader.defines || {},
                uniforms: this.uniforms,
                vertexShader: shader.vertexShader,
                fragmentShader: shader.fragmentShader
            });
        }
        this.camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        this.scene = new THREE.Scene();
        this.quad = new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 2), null);
        this.scene.add(this.quad);
    }
    ShaderPass.prototype.render = function (renderer, writeBuffer, readBuffer, delta) {
        if (this.uniforms[this.textureID]) {
            this.uniforms[this.textureID].value = readBuffer.texture;
        }
        this.quad.material = this.material;
        if (this.renderToScreen) {
            renderer.render(this.scene, this.camera);
        }
        else {
            renderer.render(this.scene, this.camera, writeBuffer, this.clear);
        }
    };
    return ShaderPass;
}());
var CopyShader = (function () {
    function CopyShader() {
        this.uniforms = {
            "tDiffuse": { type: "t", value: null },
            "opacity": { type: "f", value: 1.0 }
        };
        this.vertexShader = "\nvarying vec2 vUv;\n\nvoid main() {\n    vUv = uv;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}\n";
        this.fragmentShader = "\nuniform float opacity;\nuniform sampler2D tDiffuse;\n\nvarying vec2 vUv;\n\nvoid main() {\n    vec4 texel = texture2D( tDiffuse, vUv );\n    gl_FragColor = opacity * texel;\n}\n";
    }
    return CopyShader;
}());
var MaskPass = (function () {
    function MaskPass(scene, camera) {
        this.enabled = true;
        this.needsSwap = false;
        this.clear = true;
        this.inverse = false;
        this.scene = scene;
        this.camera = camera;
    }
    MaskPass.prototype.render = function (renderer, writeBuffer, readBuffer, delta) {
        var context = renderer.context;
        // don't update color or depth
        context.colorMask(false, false, false, false);
        context.depthMask(false);
        // set up stencil
        var writeValue, clearValue;
        if (this.inverse) {
            writeValue = 0;
            clearValue = 1;
        }
        else {
            writeValue = 1;
            clearValue = 0;
        }
        context.enable(context.STENCIL_TEST);
        context.stencilOp(context.REPLACE, context.REPLACE, context.REPLACE);
        context.stencilFunc(context.ALWAYS, writeValue, 0xffffffff);
        context.clearStencil(clearValue);
        // draw into the stencil buffer
        renderer.render(this.scene, this.camera, readBuffer, this.clear);
        renderer.render(this.scene, this.camera, writeBuffer, this.clear);
        // re-enable update of color and depth
        context.colorMask(true, true, true, true);
        context.depthMask(true);
        // only render where stencil is set to 1
        context.stencilFunc(context.EQUAL, 1, 0xffffffff); // draw if == 1
        context.stencilOp(context.KEEP, context.KEEP, context.KEEP);
    };
    return MaskPass;
}());
var ClearMaskPass = (function () {
    function ClearMaskPass() {
        this.enabled = true;
        this.needsSwap = false;
    }
    ClearMaskPass.prototype.render = function (renderer, writeBuffer, readBuffer, delta) {
        var context = renderer.context;
        context.disable(context.STENCIL_TEST);
    };
    return ClearMaskPass;
}());
/// <reference path='./ShaderPass.ts'/>
/// <reference path='./CopyShader.ts'/>
/// <reference path='./MaskPass.ts'/>
var EffectComposer = (function () {
    function EffectComposer(renderer, renderTarget) {
        this.passes = [];
        this.copyPass = new ShaderPass(new CopyShader());
        this.renderer = renderer;
        if (renderTarget === undefined) {
            var pixelRatio = renderer.getPixelRatio();
            var width = Math.floor(renderer.context.canvas.width / pixelRatio) || 1;
            var height = Math.floor(renderer.context.canvas.height / pixelRatio) || 1;
            var parameters = {
                minFilter: THREE.LinearFilter,
                magFilter: THREE.LinearFilter,
                format: THREE.RGBFormat,
                stencilBuffer: false
            };
            renderTarget = new THREE.WebGLRenderTarget(width, height, parameters);
        }
        this.renderTarget1 = renderTarget;
        this.renderTarget2 = renderTarget.clone();
        this.writeBuffer = this.renderTarget1;
        this.readBuffer = this.renderTarget2;
    }
    EffectComposer.prototype.swapBuffers = function () {
        var tmp = this.readBuffer;
        this.readBuffer = this.writeBuffer;
        this.writeBuffer = tmp;
    };
    EffectComposer.prototype.addPass = function (pass) {
        this.passes.push(pass);
    };
    EffectComposer.prototype.insertPass = function (pass, index) {
        this.passes.splice(index, 0, pass);
    };
    EffectComposer.prototype.render = function (delta) {
        this.writeBuffer = this.renderTarget1;
        this.readBuffer = this.renderTarget2;
        var maskActive = false;
        var pass, il = this.passes.length;
        for (var i = 0; i < il; i++) {
            pass = this.passes[i];
            if (!pass.enabled)
                continue;
            pass.render(this.renderer, this.writeBuffer, this.readBuffer, delta, maskActive);
            if (pass.needsSwap) {
                if (maskActive) {
                    var context = this.renderer.context;
                    context.stencilFunc(context.NOTEQUAL, 1, 0xffffffff);
                    this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, delta);
                    context.stencilFunc(context.EQUAL, 1, 0xffffffff);
                }
                this.swapBuffers();
            }
            if (pass instanceof MaskPass) {
                maskActive = true;
            }
            else if (pass instanceof ClearMaskPass) {
                maskActive = false;
            }
        }
    };
    EffectComposer.prototype.reset = function (renderTarget) {
        if (renderTarget === undefined) {
            renderTarget = this.renderTarget1.clone();
            var pixelRatio = this.renderer.getPixelRatio();
            renderTarget.setSize(Math.floor(this.renderer.context.canvas.width / pixelRatio), Math.floor(this.renderer.context.canvas.height / pixelRatio));
        }
        this.renderTarget1.dispose();
        this.renderTarget1 = renderTarget;
        this.renderTarget2.dispose();
        this.renderTarget2 = renderTarget.clone();
        this.writeBuffer = this.renderTarget1;
        this.readBuffer = this.renderTarget2;
    };
    EffectComposer.prototype.setSize = function (width, height) {
        this.renderTarget1.setSize(width, height);
        this.renderTarget2.setSize(width, height);
    };
    return EffectComposer;
}());
var RenderPass = (function () {
    function RenderPass(scene, camera, overrideMaterial, clearColor, clearAlpha) {
        this.enabled = true;
        this.needsSwap = false;
        this.clear = true;
        this.oldClearColor = new THREE.Color();
        this.oldClearAlpha = 1;
        this.scene = scene;
        this.camera = camera;
        this.overrideMaterial = overrideMaterial;
        this.clearColor = clearColor;
        this.clearAlpha = (clearAlpha !== undefined) ? clearAlpha : 1;
        this.oldClearColor = new THREE.Color();
        this.oldClearAlpha = 1;
        this.enabled = true;
        this.clear = true;
        this.needsSwap = false;
    }
    RenderPass.prototype.render = function (renderer, writeBuffer, readBuffer, delta) {
        this.scene.overrideMaterial = this.overrideMaterial;
        if (this.clearColor) {
            this.oldClearColor.copy(renderer.getClearColor());
            this.oldClearAlpha = renderer.getClearAlpha();
            renderer.setClearColor(this.clearColor, this.clearAlpha);
        }
        renderer.render(this.scene, this.camera, readBuffer, this.clear);
        if (this.clearColor) {
            renderer.setClearColor(this.oldClearColor, this.oldClearAlpha);
        }
        this.scene.overrideMaterial = null;
    };
    return RenderPass;
}());
/// <reference path='./PlaneImage.ts'/>
/// <reference path='./render/EffectComposer.ts'/>
/// <reference path='./render/RenderPass.ts'/>
var Stage = (function () {
    function Stage(params) {
        var _this = this;
        this.uuid = Utils.generateUUID();
        this.mousePosition = new THREE.Vector3(0, 0, 0.5);
        this.cameraTravel = new THREE.Vector2(10, 2);
        this.cameraRatio = new THREE.Vector2(0, 0);
        this.enableRenderLoop = false;
        this.params = params;
        Stage.CAMERA = new THREE.PerspectiveCamera(45, params.width / params.height, 1, 1100);
        this.container = params.container;
        this.textureLoader = new THREE.TextureLoader();
        this.textureLoader.crossOrigin = 'anonymous';
        var imageLoader = new THREE.ImageLoader();
        imageLoader.crossOrigin = 'anonymous';
        this.planeImageFactory = new PlaneImageFactory(imageLoader);
        this.clock = new THREE.Clock(true);
        Stage.RENDERER = new THREE.WebGLRenderer({
            precision: 'mediump',
            alpha: true
        });
        Stage.RENDERER.setClearColor(0x000000, 0);
        Stage.RENDERER.setSize(params.width, params.height);
        this.container.append(Stage.RENDERER.domElement);
        if (params.enableStats) {
            var stats = new Stats();
            stats.setMode(0);
            stats.domElement.style.position = 'absolute';
            stats.domElement.style.left = '0px';
            stats.domElement.style.top = '0px';
            stats.domElement.style.zIndex = '10';
            this.stats = stats;
            this.container.append(this.stats.domElement);
        }
        if (params.enableGui) {
            this.gui = new dat.GUI({ closed: true });
        }
        var canvas = $(Stage.RENDERER.domElement);
        Stage.events.forEach(function (e) {
            return canvas.on(e, function (event) {
                if (_this.currentScene) {
                    _this.currentScene.dispatchEvent({ type: e, message: event });
                }
            });
        });
        this.renderPass = new RenderPass(this.currentScene, Stage.CAMERA, undefined, new THREE.Color(0x000000), 1);
        // const pixelRatio = Stage.RENDERER.getPixelRatio();
        var pixelRatio = window.devicePixelRatio;
        var width = Math.floor(Stage.RENDERER.context.canvas.width / pixelRatio) || 1;
        var height = Math.floor(Stage.RENDERER.context.canvas.height / pixelRatio) || 1;
        var renderTarget = new THREE.WebGLRenderTarget(width, height, {
            minFilter: THREE.LinearFilter,
            magFilter: THREE.LinearFilter,
            format: THREE.RGBAFormat,
            stencilBuffer: false
        });
        this.composer = new EffectComposer(Stage.RENDERER, renderTarget);
        this.composer.addPass(this.renderPass);
        window.addEventListener('resize', function () { return _this.resize(); });
        this.resize();
        TweenMax.ticker.addEventListener('tick', function () { return _this.renderLoop(); });
    }
    Stage.prototype.resize = function () {
        this.params.width = window.innerWidth;
        this.params.height = window.innerHeight;
        Stage.RENDERER.setSize(window.innerWidth, window.innerHeight);
        this.composer.setSize(window.innerWidth, window.innerHeight);
        Stage.CAMERA.aspect = window.innerWidth / window.innerHeight;
        Stage.CAMERA.updateProjectionMatrix();
    };
    Stage.prototype.run = function () {
        this.enableRenderLoop = true;
        Stage.RENDERER.domElement.style.display = "block";
    };
    Stage.prototype.pause = function () {
        this.enableRenderLoop = false;
        Stage.RENDERER.domElement.style.display = "none";
    };
    Stage.prototype.changeScene = function (scene) {
        var _this = this;
        if (this.currentScene) {
            this.currentScene.children.forEach(function (c) { return _this.currentScene.remove(c); });
        }
        this.currentScene = scene;
        this.renderPass.scene = scene;
        this.composer.passes = [];
        this.composer.addPass(this.renderPass);
        this.currentScene.getPostProcessingPasses().forEach(function (p) { return _this.composer.addPass(p); });
        var copyPass = new ShaderPass(new CopyShader());
        copyPass.renderToScreen = true;
        this.composer.addPass(copyPass);
    };
    Stage.prototype.enableMouseCamera = function () {
        var _this = this;
        var newPos = new THREE.Vector2(0, 0);
        var cameraTarget = new THREE.Vector3(0, 0, -500);
        var updatePosition = function (x, y) {
            _this.cameraRatio.x = x / _this.params.width;
            _this.cameraRatio.y = y / _this.params.height;
            _this.mousePosition.x = _this.cameraRatio.x * 2 - 1;
            _this.mousePosition.y = _this.cameraRatio.y * -2 + 1;
            _this.mousePosition.z = 0.5;
            newPos.setX(_this.cameraTravel.x * _this.cameraRatio.x * 2 - _this.cameraTravel.x);
            newPos.setY(_this.cameraTravel.y * _this.cameraRatio.y * 2 - _this.cameraTravel.y);
            Stage.CAMERA.position.x = newPos.x;
            Stage.CAMERA.position.y = newPos.y;
            Stage.CAMERA.lookAt(cameraTarget);
            Stage.CAMERA.updateMatrixWorld(true);
        };
        var jQ = $(Stage.RENDERER.domElement);
        jQ.on('mousemove', function (j) {
            var e = j.originalEvent;
            updatePosition(e.clientX, e.clientY);
        });
        jQ.on('touchstart', function (j) {
            var e = j.originalEvent;
            updatePosition(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
        });
        jQ.on('touchmove', function (j) {
            var e = j.originalEvent;
            updatePosition(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
        });
        ['mousemove', 'touchstart', 'touchmove'].forEach(function (e) {
            var evtHandlers = $._data(Stage.RENDERER.domElement, 'events')[e];
            var lastHandler = evtHandlers.pop();
            evtHandlers.splice(0, 0, lastHandler);
        });
    };
    Stage.prototype.renderLoop = function () {
        if (this.enableRenderLoop) {
            this.stageTick();
            if (this.stats) {
                this.stats.update();
            }
            this.composer.render();
        }
    };
    Stage.prototype.stageTick = function () {
        if (this.currentScene) {
            this.currentScene.dispatchEvent({ type: NickelScene.TICK_EVENT, message: { dt: this.clock.getDelta() } });
        }
    };
    Stage.prototype.calculateCameraView = function (zDepth) {
        var view = Utils.calcCameraView(zDepth);
        window.addEventListener('resize', function () {
            var newView = Utils.calcCameraView(zDepth);
            view.width = newView.width;
            view.height = newView.height;
        });
        return view;
    };
    Stage.events = [
        'mousedown',
        'touchstart',
        'mousemove',
        'touchmove',
        'mouseup',
        'touchend'
    ];
    Stage.NEXT_SCENE = 'next_scene';
    return Stage;
}());
var Background = (function (_super) {
    __extends(Background, _super);
    function Background(map, size, cameraHeight) {
        var material = new THREE.MeshLambertMaterial({
            map: map,
            depthWrite: false
        });
        var backgroundHeight = cameraHeight * 1.1;
        var backgroundRatio = size.max.x / size.max.y;
        var backgroundWidth = backgroundHeight * backgroundRatio;
        var geometry = new THREE.PlaneGeometry(backgroundWidth, backgroundHeight);
        // TODO: File bug with JetBrains about this
        //noinspection TypeScriptValidateTypes
        _super.call(this, geometry, material);
        this.name = 'background';
    }
    return Background;
}(THREE.Mesh));
var VideoBackground = (function (_super) {
    __extends(VideoBackground, _super);
    function VideoBackground(cameraHeight, videoPool) {
        var _this = this;
        var videoElement = document.createElement('video');
        videoElement.crossOrigin = 'anonymous';
        var videoImage = document.createElement('canvas');
        videoImage.width = 176;
        videoImage.height = 80;
        var videoImageContext = videoImage.getContext('2d');
        videoImageContext.fillStyle = '#000000';
        videoImageContext.fillRect(0, 0, videoImage.width, videoImage.height);
        var videoTexture = new THREE.Texture(videoImage, THREE.Texture.DEFAULT_MAPPING, THREE.ClampToEdgeWrapping, THREE.ClampToEdgeWrapping, THREE.LinearFilter, THREE.LinearFilter);
        videoTexture.minFilter = THREE.LinearFilter;
        videoTexture.magFilter = THREE.LinearFilter;
        var movieMaterial = new THREE.MeshBasicMaterial({ map: videoTexture });
        var backgroundHeight = cameraHeight * 1.1;
        var backgroundRatio = videoImage.width / videoImage.height;
        var backgroundWidth = backgroundHeight * backgroundRatio;
        var geometry = new THREE.PlaneGeometry(backgroundWidth, backgroundHeight);
        // TODO: File bug with JetBrains about this
        //noinspection TypeScriptValidateTypes
        _super.call(this, geometry, movieMaterial);
        this.vEle = videoElement;
        this.vCtx = videoImageContext;
        this.vTex = videoTexture;
        this.videoPool = videoPool;
        videoElement.src = this.getRandomVideoUrl();
        videoElement.loop = true;
        videoElement.load();
        videoElement.play();
        videoElement.volume = 0;
        this.tickFn = function () {
            if (_this.vEle.readyState === _this.vEle.HAVE_ENOUGH_DATA) {
                _this.vCtx.drawImage(_this.vEle, 0, 0);
                if (_this.vTex) {
                    _this.vTex.needsUpdate = true;
                }
            }
        };
        this.addEventListener('added', function () {
            _this.realParent = _this.parent;
            _this.realParent.addEventListener(NickelScene.TICK_EVENT, _this.tickFn);
        });
        this.addEventListener('removed', function () {
            _this.vEle.pause();
            _this.realParent.removeEventListener(NickelScene.TICK_EVENT, _this.tickFn);
        });
    }
    VideoBackground.prototype.getRandomVideoUrl = function () {
        var prefix = CDN_GLOBAL_PREFIX;
        if (!Main.mobile) {
            var is_safari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
            if (is_safari) {
                prefix = "";
            }
        }
        return prefix + '/vid/backgrounds/' + _.sample(this.videoPool);
    };
    return VideoBackground;
}(THREE.Mesh));
var ImageBackground = (function (_super) {
    __extends(ImageBackground, _super);
    function ImageBackground(cameraHeight, imagePool) {
        var _this = this;
        // const imageElement
        var imageElment = document.createElement('img');
        imageElment.crossOrigin = 'anonymous';
        var image = document.createElement('canvas');
        image.width = 1280;
        image.height = 720;
        var imageContext = image.getContext('2d');
        imageContext.fillStyle = '#000000';
        imageContext.fillRect(0, 0, image.width, image.height);
        var imageTexture = new THREE.Texture(image, THREE.Texture.DEFAULT_MAPPING, THREE.ClampToEdgeWrapping, THREE.ClampToEdgeWrapping, THREE.LinearFilter, THREE.LinearFilter);
        imageTexture.minFilter = THREE.LinearFilter;
        imageTexture.magFilter = THREE.LinearFilter;
        var movieMaterial = new THREE.MeshBasicMaterial({ map: imageTexture });
        var backgroundHeight = cameraHeight * 1.1;
        var backgroundRatio = image.width / image.height;
        var backgroundWidth = backgroundHeight * backgroundRatio;
        var geometry = new THREE.PlaneGeometry(backgroundWidth, backgroundHeight);
        // TODO: File bug with JetBrains about this
        //noinspection TypeScriptValidateTypes
        _super.call(this, geometry, movieMaterial);
        this.vEle = imageElment;
        this.vCtx = imageContext;
        this.vTex = imageTexture;
        this.imagePool = imagePool;
        imageElment.src = this.getRandomVideoUrl();
        this.tickFn = function () {
            _this.vCtx.drawImage(_this.vEle, 0, 0);
            if (_this.vTex) {
                _this.vTex.needsUpdate = true;
            }
        };
        this.addEventListener('added', function () {
            _this.realParent = _this.parent;
            _this.realParent.addEventListener(NickelScene.TICK_EVENT, _this.tickFn);
        });
    }
    ImageBackground.prototype.getRandomVideoUrl = function () {
        var image = CDN_GLOBAL_PREFIX + '/img/bg_img/' + _.sample(this.imagePool);
        return image;
    };
    return ImageBackground;
}(THREE.Mesh));
/// <reference path='../scaffolding/EventBus.ts'/>
var BandwidthDetector = (function () {
    function BandwidthDetector() {
        this.file = "https://upload.wikimedia.org/wikipedia/commons/0/03/Mountain_Bluebird.jpg";
        this.size = 298475; // In Bytes
    }
    BandwidthDetector.prototype.getSpeed = function () {
        var startTime;
        var endTime;
        var scope = this;
        var img = new Image();
        img.onload = function () {
            endTime = (new Date()).getTime();
            scope.results(startTime, endTime);
        };
        img.onerror = function () { return console.warn("There was an error downloading the image"); };
        startTime = (new Date()).getTime();
        var fixCaching = "?cb=" + startTime; //cache busting
        img.src = this.file + fixCaching;
        clearTimeout(this.downloadTimeout);
        this.downloadTimeout = setTimeout(function () {
            EventBus.dispatchEvent(BandwidthDetector.GOT_SPEED, BandwidthDetector.LOW);
        }, 2500);
    };
    BandwidthDetector.prototype.results = function (startTime, endTime) {
        clearTimeout(this.downloadTimeout);
        var duration = (endTime - startTime) / 1000;
        var sizeInBits = this.size * 8;
        var speedBps = parseInt((sizeInBits / duration).toFixed(2));
        var speedKbps = parseInt((speedBps / 1024).toFixed(2));
        var speedMbps = parseInt((speedKbps / 1024).toFixed(2));
        var speedLevel;
        if (speedKbps < 2400) {
            speedLevel = BandwidthDetector.LOW;
        }
        else if (speedKbps < 8000) {
            speedLevel = BandwidthDetector.MEDIUM;
        }
        else {
            speedLevel = BandwidthDetector.HIGH;
        }
        EventBus.dispatchEvent(BandwidthDetector.GOT_SPEED, speedLevel);
    };
    BandwidthDetector.GOT_SPEED = "gotspeed";
    BandwidthDetector.LOW = "low";
    BandwidthDetector.MEDIUM = "medium";
    BandwidthDetector.HIGH = "high";
    return BandwidthDetector;
}());
/// <reference path='../../scaffolding/three/Stage.ts'/>
/// <reference path='../../scaffolding/three/Background.ts'/>
/// <reference path='../../scaffolding/three/VideoBackground.ts'/>
/// <reference path='../../scaffolding/three/ImageBackground.ts'/>
/// <reference path='../../scaffolding/BandwidthDetector.ts'/>
var SeancesStage = (function (_super) {
    __extends(SeancesStage, _super);
    function SeancesStage(api, params, skipIntro, graveyard) {
        var _this = this;
        _super.call(this, params);
        this.api = api;
        this.cont = $("#container");
        this.backgroundDims = this.calculateCameraView(-1000);
        if (graveyard) {
            this.startGraveyardScene();
        }
        else if (!skipIntro) {
            this.startIntroduction();
        }
        else {
            this.startIntroScene().then(function (e) { return _this.run(); });
        }
    }
    SeancesStage.prototype.startIntroduction = function () {
        var _this = this;
        var intro = new IntroSceneNoThree(this.cont, {}, this);
        EventBus.addEventListener("INTRO_OVER", function () {
            intro.killMe();
            _this.startIntroScene().then(function (e) { return _this.run(); });
        }, this);
    };
    SeancesStage.prototype.startIntroScene = function () {
        var _this = this;
        this.enableMouseCamera();
        var cursor = new ProgressCircle(Stage.CAMERA);
        cursor.addEventListener('mousemove', function (e) {
            cursor.updatePosition(_this.mousePosition);
        });
        cursor.addEventListener('touchmove', function (e) {
            cursor.updatePosition(_this.mousePosition);
        });
        cursor.addEventListener('touchstart', function (e) {
            cursor.updatePosition(_this.mousePosition);
        });
        var titleDims = this.calculateCameraView(-300);
        return this.api.getExperience()
            .then(function (e) { return e['data']; })
            .then(function (d) {
            _this.changeScene(new SeancesIntroScene(cursor, _this.textureLoader, d, _this.backgroundDims, titleDims, _this.planeImageFactory));
            _this.vidData = d;
            _this.getUrl();
        });
    };
    SeancesStage.prototype.getUrl = function () {
        var _this = this;
        var url;
        var vd;
        if (Main.mobile) {
            url = (this.vidData['m3u8_url']) ? this.vidData['m3u8_url'] : this.vidData['mp4_url'];
            vd = {
                src: url,
                expId: this.vidData['id']
            };
            this.loadVideoPlayer(vd);
            this.currentScene.addEventListener(Stage.NEXT_SCENE, function (e) { return _this.startVideoPlayer(vd); });
        }
        else {
            var band = new BandwidthDetector();
            EventBus.addEventListener(BandwidthDetector.GOT_SPEED, function (d) { return _this.gotBandwidth(d); }, this);
            band.getSpeed();
        }
    };
    SeancesStage.prototype.gotBandwidth = function (bandwidth) {
        var _this = this;
        var vd = {
            expId: this.vidData['id'],
            src: ''
        };
        if (bandwidth == BandwidthDetector.LOW) {
            vd.src = this.vidData['mp4_url_480'];
        }
        else if (bandwidth == BandwidthDetector.MEDIUM) {
            vd.src = this.vidData['mp4_url_720'];
        }
        else if (bandwidth == BandwidthDetector.HIGH) {
            vd.src = this.vidData['mp4_url'];
        }
        this.loadVideoPlayer(vd);
        this.currentScene.addEventListener(Stage.NEXT_SCENE, function (e) { return _this.startVideoPlayer(vd); });
    };
    SeancesStage.prototype.loadVideoPlayer = function (vd) {
        this.player = new VideoPlayer($("#container"), {}, this);
        this.player.loadVideo(vd);
    };
    SeancesStage.prototype.startVideoPlayer = function (vd) {
        var _this = this;
        $('canvas').remove();
        this.changeScene(new NickelScene());
        this.pause();
        this.player.playVideo();
        this.player.showMe();
        gaTrackEvent('film_start', 'film_playback');
        EventBus.addEventListener("VIDEO_OVER", function () {
            _this.startGraveyardScene();
            gaTrackEvent('100% completion', 'film_playback');
        }, this);
    };
    SeancesStage.prototype.startGraveyardScene = function (expId) {
        var data = {
            'api': this.api
        };
        if (this.vidData) {
            data.expId = this.vidData.id;
        }
        this.changeScene(new NickelScene());
        this.pause();
        var graveyard = new Graveyard(this.cont, data, this);
    };
    return SeancesStage;
}(Stage));
var MPEGArtifactShader = (function () {
    function MPEGArtifactShader() {
        this.uniforms = {
            "tDiffuse": { type: "t", value: null },
            "tDiffuseNoise": { type: "t", value: null },
            "fGlobalTime": { type: "f", value: 0.1 }
        };
        this.vertexShader = "\n        varying vec2 vUv;\n        void main() {\n            vUv = uv;\n            gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n        }\n    ";
        this.fragmentShader = "\n\n        uniform float fGlobalTime;\n        uniform sampler2D tDiffuse;\n        uniform sampler2D tDiffuseNoise;\n\n        varying vec2 vUv;\n\n        void main( )\n        {\n            vec2 uv = -1.0 + 2.0 *vUv;\n            vec2 block = floor(gl_FragCoord.xy / vec2(16));\n            vec2 uv_noise = block / vec2(64);\n            uv_noise += floor(vec2(fGlobalTime) * vec2(1234.0, 3543.0)) / vec2(64);\n            \n            float block_thresh = pow(fract(fGlobalTime * 1236.0453), 2.0) * 0.2;\n            float line_thresh = pow(fract(fGlobalTime * 2236.0453), 3.0) * 0.7;\n            \n            vec2 uv_r = uv, uv_g = uv, uv_b = uv;\n\n            // glitch some blocks and lines\n            if (texture2D(tDiffuseNoise, uv_noise).r < block_thresh ||\n                texture2D(tDiffuseNoise, vec2(uv_noise.y, 0.0)).g < line_thresh) {\n\n                vec2 dist = (fract(uv_noise) - 0.5) * 0.3;\n                uv_r += dist * 0.1;\n                uv_g += dist * 0.2;\n                uv_b += dist * 0.125;\n            }\n\n            gl_FragColor.r = texture2D(tDiffuse, uv_r).r;\n            gl_FragColor.g = texture2D(tDiffuse, uv_g).g;\n            gl_FragColor.b = texture2D(tDiffuse, uv_b).b;\n\n            // loose luma for some blocks\n            if (texture2D(tDiffuseNoise, uv_noise).g < block_thresh)\n                gl_FragColor.rgb = gl_FragColor.ggg;\n\n            // discolor block lines\n            if (texture2D(tDiffuseNoise, vec2(uv_noise.y, 0.0)).b * 3.5 < line_thresh)\n                gl_FragColor.rgb = vec3(0.0, dot(gl_FragColor.rgb, vec3(1.0)), 0.0);\n\n            // interleave lines in some blocks\n            if (texture2D(tDiffuseNoise, uv_noise).g * 1.5 < block_thresh ||\n                texture2D(tDiffuseNoise, vec2(uv_noise.y, 0.0)).g * 2.5 < line_thresh) {\n                float line = fract(gl_FragCoord.y / 3.0);\n                vec3 mask = vec3(3.0, 0.0, 0.0);\n                if (line > 0.333)\n                    mask = vec3(0.0, 3.0, 0.0);\n                if (line > 0.666)\n                    mask = vec3(0.0, 0.0, 3.0);\n                \n                gl_FragColor.xyz *= mask;\n            }\n        }";
    }
    return MPEGArtifactShader;
}());
/// <reference path='../ProgressCircle.ts'/>
var InstallationProgressCircle = (function (_super) {
    __extends(InstallationProgressCircle, _super);
    function InstallationProgressCircle() {
        _super.call(this, null);
        this.scale.set(6, 6, 6);
        // this.position.z = 0;
    }
    InstallationProgressCircle.prototype.setPos = function (pos) {
        this.position.x = pos.x;
        this.position.y = pos.y;
    };
    InstallationProgressCircle.prototype.destroy = function () {
    };
    return InstallationProgressCircle;
}(ProgressCircle));
/// <reference path='../../scaffolding/three/NickelGroup.ts'/>
/// <reference path='./InstallationProgressCircle.ts'/>
/// <reference path='../scenes/MultiTouchInterfaceScene.ts'/>
var PhotoCard = (function (_super) {
    __extends(PhotoCard, _super);
    function PhotoCard(textureLoader, img) {
        var _this = this;
        _super.call(this);
        this.cardWidth = 128;
        this.cardHeight = 72;
        this.initialScale = 0.1;
        this.minLife = 3;
        this.maxLife = 15;
        this.jitterStart = 1;
        this.jitterEnd = 5;
        this.countdownDuration = 3;
        this.useRate = 1;
        this.jitterStrength = 0;
        this.minDistance = 0;
        this.interactive = false;
        this.countdownRunning = false;
        this.jitter = true;
        this.textureLoader = textureLoader;
        this.imgSrc = img;
        this.imageMesh = this.getMesh();
        this.swapImageMesh = this.getMesh();
        this.imageMesh.scale.set(this.initialScale, this.initialScale, this.initialScale);
        this.add(this.imageMesh);
        this.addEventListener(NickelScene.TICK_EVENT, function () { return _this.tick(); });
        this.addEventListener("added", function () {
            if (_this.parent instanceof CardLayer) {
                _this.imageMesh.renderOrder = RenderOrder.BackgroundPhotoCards;
            }
            else if (_this.parent instanceof MultiTouchInterfaceScene) {
                _this.imageMesh.renderOrder = RenderOrder.CurrentPhotoCard;
            }
        });
        this.touchSound = buzzSoundCdn('/audio/del_01_click.mp3');
        this.cancelSound = buzzSoundCdn('/audio/click_fail.mp3');
        this.successSound = buzzSoundCdn('/audio/click_success.mp3');
    }
    PhotoCard.prototype.setPosition = function (pos) {
        if (this.animTween) {
            this.animTween.kill();
        }
        if (this.momentumTween) {
            this.momentumTween.kill();
        }
        this.cardPos = pos;
        this.position.x = this.cardPos.position.x;
        this.position.y = this.cardPos.position.y;
        this.position.z = this.cardPos.position.z;
        this.rotation.z = this.cardPos.rotation;
    };
    PhotoCard.prototype.tick = function () {
        if (this.countdownRunning) {
            this.circle.updateProgress(this.circle.tweenVar);
            if (this.circle.tweenVar >= 1) {
                this.countdownOver();
            }
        }
    };
    PhotoCard.prototype.getMesh = function () {
        var tex = this.textureLoader.load(this.imgSrc);
        var mat = new THREE.MeshBasicMaterial({ 'map': tex, 'transparent': true });
        var geo = new THREE.PlaneGeometry(this.cardWidth, this.cardHeight);
        return new THREE.Mesh(geo, mat);
    };
    PhotoCard.prototype.swapImage = function () {
        this.add(this.swapImageMesh);
        this.remove(this.imageMesh);
        var old = this.imageMesh;
        this.imageMesh = this.swapImageMesh;
        this.swapImageMesh = old;
    };
    PhotoCard.prototype.show = function () {
        var _this = this;
        this.targetScale = _.random(15, 20) / 100;
        this.initialOpacity = _.random(50, 80) / 100;
        this.targetScale = _.random(15, 20) / 100;
        this.targetRotation = Math.radians(_.random(-5, 5));
        var dly = _.random(500, 1000) / 1000;
        var opac = _.random(30, 40) / 100;
        var translate = _.random(30, 80) / 100;
        //position
        TweenMax.fromTo(this.imageMesh.position, translate, {
            x: _.random(-60, 60),
            y: _.random(-60, 60)
        }, {
            x: 0,
            y: 0,
            ease: Strong.easeOut,
            delay: dly
        });
        //rotation
        TweenMax.fromTo(this.imageMesh.rotation, translate, {
            x: Math.radians(_.random(-120, 120)),
            y: Math.radians(_.random(-120, 120)),
            z: Math.radians(_.random(-50, 50)),
        }, {
            x: 0,
            y: 0,
            z: this.targetRotation,
            ease: Strong.easeOut,
            delay: dly
        });
        //scale
        TweenMax.to(this.imageMesh.scale, translate, {
            x: this.targetScale,
            y: this.targetScale,
            z: this.targetScale,
            delay: dly,
            ease: Quad.easeOut,
            onComplete: function () {
                _this.imageMesh.geometry.computeBoundingBox();
                _this.interactive = true;
            }
        });
        //opacity
        TweenMax.fromTo(this.imageMesh.material, opac, {
            opacity: 0
        }, {
            opacity: this.initialOpacity,
            delay: dly,
        });
        var cycleDly = _.random(this.minLife, this.maxLife);
        if (MultiTouchInterfaceScene.AUTO_CYCLE) {
            var center_1 = (_.random(1, 100) <= 1);
            this.removeFunc = function () { return _this.hide(center_1); };
            TweenMax.delayedCall(cycleDly, this.removeFunc);
        }
        if (MultiTouchInterfaceScene.SWAP_IMAGES && _.random(0, 100) <= 20 && this.swapImageMesh) {
            this.swapFunc = function () { return _this.swapImage(); };
            TweenMax.delayedCall(cycleDly * _.random(40, 60) / 100, this.swapFunc);
            this.swapImageMesh.scale.set(this.targetScale, this.targetScale, this.targetScale);
            this.swapImageMesh.rotation.set(0, 0, this.targetRotation);
            this.swapImageMesh.geometry.computeBoundingBox();
        }
    };
    PhotoCard.prototype.hide = function (center) {
        var _this = this;
        if (center === void 0) { center = false; }
        var dly = 0.4;
        this.interactive = false;
        this.countdownRunning = false;
        TweenMax.killDelayedCallsTo(this.removeFunc);
        TweenMax.killDelayedCallsTo(this.swapFunc);
        if (center) {
            this.removeFromCircle();
            if (this.animTween) {
                this.animTween.kill();
            }
            if (this.momentumTween) {
                this.momentumTween.kill();
            }
            //animate to the middle
            this.animTween = TweenMax.to(this.position, 0.7, {
                x: 0,
                y: 40,
                z: -150,
            });
            this.tweenOpacity(0.3, 0, Linear.easeNone, 0.15);
            TweenMax.delayedCall(dly, function () { return EventBus.dispatchEvent(PhotoCard.ADD_TO_TITLE); });
        }
        else {
            this.tweenOpacity(1, 0, Quad.easeIn);
            this.animTween = TweenMax.to(this.imageMesh.scale, 1.5, {
                x: this.initialScale,
                y: this.initialScale,
                z: this.initialScale,
                ease: Quad.easeIn
            });
            if (this.distance > this.minDistance) {
                var duration = Math.max(Math.abs(this.speedX), Math.abs(this.speedY)) * 4000 / 1000;
                this.momentumTween = TweenMax.to(this.imageMesh.position, duration, {
                    onUpdate: function (evt) {
                        var progress = _this.momentumTween.progress();
                        _this.speedX *= (1 - progress);
                        _this.speedY *= (1 - progress);
                        var now = new Date();
                        var stepDuration = now.getTime() - _this.lastStepTime.getTime();
                        _this.lastStepTime = now;
                        var newX = (_this.position.x + (_this.speedX * stepDuration / 2)), newY = (_this.position.y + (_this.speedY * stepDuration / 2));
                        _this.position.x = newX;
                        _this.position.y = newY;
                        _this.checkProximity();
                    },
                    onComplete: function () { return _this.removeFromCircle(); }
                });
            }
        }
        TweenMax.delayedCall(0.8, function () { return EventBus.dispatchEvent(PhotoCard.REMOVE_CARD, _this); });
    };
    PhotoCard.prototype.touchStarted = function (mouse, id) {
        this.touchIndex = id;
        this.tweenOpacity(0.2, 1);
        this.removeFromCircle();
        mouse.unproject(Stage.CAMERA);
        var dir = mouse.sub(Stage.CAMERA.position).normalize();
        var dist = (this.cardPos.position.z - Stage.CAMERA.position.z) / dir.z;
        var var5 = Stage.CAMERA.position.clone().add(dir.multiplyScalar(dist));
        this.offsetX = var5.x - this.position.x;
        this.offsetY = var5.y - this.position.y;
        this.touchSound.play();
        this.startCountdown();
    };
    PhotoCard.prototype.removeFromCircle = function () {
        if (this.parent instanceof CardLayer) {
            this.parent.parent.add(this);
            this.position.setFromMatrixPosition(this.matrixWorld);
            this.rotation.setFromRotationMatrix(this.matrixWorld);
        }
    };
    PhotoCard.prototype.startCountdown = function () {
        var _this = this;
        this.countdownRunning = true;
        TweenMax.killDelayedCallsTo(this.removeFunc);
        TweenMax.killDelayedCallsTo(this.swapFunc);
        if (!this.circle) {
            this.circle = new InstallationProgressCircle();
            this.add(this.circle);
        }
        this.tween = TweenMax.fromTo(this.circle, this.countdownDuration / 16, { tweenVar: 0 }, {
            tweenVar: 0.5,
            onComplete: function () {
                _this.tween = TweenMax.to(_this.circle, 15 * _this.countdownDuration / 16, {
                    tweenVar: 1,
                    onComplete: function () { return _this.countdownOver(); }
                });
            }
        });
        if (this.jitter) {
            this.jitterTween = TweenMax.fromTo(this, this.countdownDuration, {
                jitterStrength: this.jitterStart
            }, {
                jitterStrength: this.jitterEnd,
                ease: Quint.easeIn,
                onUpdate: function () {
                    var x = Utils.randomFromInterval(-_this.jitterStrength * 100, _this.jitterStrength * 100) / 100;
                    var y = Utils.randomFromInterval(-_this.jitterStrength * 100, _this.jitterStrength * 100) / 100;
                    _this.imageMesh.position.set(x, y, _this.imageMesh.position.z);
                }
            });
        }
    };
    PhotoCard.prototype.countdownOver = function () {
        if (this.tween) {
            this.tween.kill();
        }
        this.circle.reset();
        EventBus.dispatchEvent(PhotoCard.COUNTDOWN_COMPLETE, this);
        this.successSound.play();
        this.hide(true);
    };
    PhotoCard.prototype.endCountdown = function () {
        this.tween.kill();
        if (this.jitter) {
            this.jitterTween.kill();
        }
        this.circle.reset();
        this.cancelSound.play();
        this.hide();
    };
    PhotoCard.prototype.touchMove = function (pos, evt) {
        this.lastPosition = this.position.clone();
        this.lastDragTime = this.dragTime;
        pos.unproject(Stage.CAMERA);
        var dir = pos.sub(Stage.CAMERA.position).normalize();
        var dist = (this.cardPos.position.z - Stage.CAMERA.position.z) / dir.z;
        var var5 = Stage.CAMERA.position.clone().add(dir.multiplyScalar(dist));
        this.position.x = var5.x - this.offsetX;
        this.position.y = var5.y - this.offsetY;
        //momentum 
        this.currentPosition = this.position;
        this.dragTime = evt.timeStamp;
        var dX = this.currentPosition.x - this.lastPosition.x, dY = this.currentPosition.y - this.lastPosition.y, dMs = Math.max(this.dragTime - this.lastDragTime, 1);
        // Speeds
        this.speedX = Math.max(Math.min(dX / dMs, 1), -1),
            this.speedY = Math.max(Math.min(dY / dMs, 1), -1);
        // Distance moved (Euclidean distance)
        this.distance = Math.sqrt(Math.pow(this.lastPosition.x - this.currentPosition.x, 2) + Math.pow(this.lastPosition.y - this.currentPosition.y, 2));
        this.lastStepTime = new Date();
        if (MultiTouchInterfaceScene.PROXIMITY_TRIGGER) {
            this.checkProximity();
        }
    };
    PhotoCard.prototype.checkProximity = function () {
        var r = 50;
        var centerX = 0;
        var centerY = 50;
        var x = this.position.x;
        var y = this.position.y;
        if (Math.sqrt((x - centerX) * (x - centerX) + (y - centerY) * (y - centerY)) < r) {
            this.countdownOver();
        }
    };
    PhotoCard.prototype.touchEnd = function () {
        this.endCountdown();
    };
    PhotoCard.prototype.tweenOpacity = function (duration, opacity, easing, delay) {
        this.imageMesh.material.depthWrite = (opacity === 1.0);
        var opts = { opacity: opacity };
        if (easing) {
            opts['easing'] = easing;
        }
        var tween = TweenMax.to(this.imageMesh.material, duration, opts);
        if (delay) {
            tween.delay(delay);
        }
        return tween;
    };
    PhotoCard.ADD_TO_TITLE = "addtotitle";
    PhotoCard.REMOVE_CARD = "removecard";
    PhotoCard.COUNTDOWN_COMPLETE = "countdowncomplete";
    return PhotoCard;
}(NickelGroup));
/// <reference path="./PhotoCard.ts" />
var InstallationTitleSequence = (function (_super) {
    __extends(InstallationTitleSequence, _super);
    function InstallationTitleSequence(renderer, titleGenerator) {
        var _this = this;
        _super.call(this, renderer, titleGenerator);
        this.shift(false);
        EventBus.addEventListener(PhotoCard.ADD_TO_TITLE, function () { return _this.shift(MultiTouchInterfaceScene.RESOLVING); }, this);
    }
    return InstallationTitleSequence;
}(BaseTitleSequence));
var VideoCard = (function (_super) {
    __extends(VideoCard, _super);
    function VideoCard(textureLoader, img) {
        _super.call(this, textureLoader, img);
        this.imgW = 256;
        this.imgH = 144;
        this.playing = false;
        this.updateFrame = false;
    }
    VideoCard.prototype.tick = function () {
        _super.prototype.tick.call(this);
    };
    VideoCard.prototype.show = function () {
        _super.prototype.show.call(this);
        this.playing = true;
        this.renderingVideo.play();
    };
    VideoCard.prototype.hide = function (center) {
        _super.prototype.hide.call(this, center);
        this.playing = false;
        this.renderingVideo.pause();
    };
    VideoCard.prototype.swapImage = function () {
        //override
    };
    VideoCard.prototype.getMesh = function () {
        if (this.renderingVideo) {
            return;
        }
        this.renderingVideo = document.createElement('video');
        this.renderingVideo.width = this.imgW;
        this.renderingVideo.height = this.imgH;
        this.renderingVideo.loop = true;
        this.renderingVideo.src = this.imgSrc;
        this.renderingVideo.load();
        this.tex = new THREE.VideoTexture(this.renderingVideo);
        this.tex.minFilter = THREE.LinearFilter;
        this.tex.magFilter = THREE.LinearFilter;
        this.tex.format = THREE.RGBFormat;
        var mat = new THREE.MeshBasicMaterial({ 'map': this.tex, 'transparent': true });
        var geo = new THREE.PlaneGeometry(this.cardWidth, this.cardHeight);
        return new THREE.Mesh(geo, mat);
    };
    return VideoCard;
}(PhotoCard));
var CardLayer = (function (_super) {
    __extends(CardLayer, _super);
    function CardLayer(vel, pos) {
        var _this = this;
        _super.call(this);
        this.tweenVelocity = true;
        this.minTweenDur = 2;
        this.maxTweenDur = 10;
        this.divider = 2000;
        this.minDelay = 0;
        this.maxDelay = 100;
        this.velocity = vel / this.divider;
        this.velocityMin = vel * 0.4;
        this.velocityMax = vel * 1.6;
        this.position.copy(pos);
        if (MultiTouchInterfaceScene.ROTATE) {
            this.addEventListener(NickelScene.TICK_EVENT, function () {
                _this.rotation.z += _this.velocity;
            });
        }
        if (this.tweenVelocity) {
            this.animateVelocity();
        }
        this.rotation.z = 0.5;
    }
    CardLayer.prototype.animateVelocity = function () {
        var _this = this;
        var dly = _.random(this.minDelay, this.maxDelay) / 100;
        var targ = _.random(this.velocityMin, this.velocityMax) / this.divider;
        this.velocityTween = TweenMax.to(this, _.random(this.minTweenDur, this.maxTweenDur), {
            velocity: targ,
            ease: Quad.easeInOut,
            delay: dly,
            onComplete: function () { return _this.animateVelocity(); }
        });
    };
    return CardLayer;
}(NickelGroup));
/// <reference path="../title/GenreSequence.ts" />
var InstallationGenreSequence = (function (_super) {
    __extends(InstallationGenreSequence, _super);
    function InstallationGenreSequence(renderer, genreGenerator) {
        var _this = this;
        _super.call(this, renderer, genreGenerator);
        EventBus.addEventListener(PhotoCard.ADD_TO_TITLE, function () { return _this.shift(); }, this);
    }
    return InstallationGenreSequence;
}(GenreSequence));
var InstallationVideoBackground = (function (_super) {
    __extends(InstallationVideoBackground, _super);
    function InstallationVideoBackground(cameraHeight, videoPool) {
        var _this = this;
        _super.call(this, cameraHeight, videoPool);
        this.vEle.loop = false;
        this.vEle.addEventListener('ended', function () {
            _this.vEle.src = _this.getRandomVideoUrl();
            _this.vEle.load();
            _this.vEle.play();
        }, false);
    }
    return InstallationVideoBackground;
}(VideoBackground));
/// <reference path='../scenes/SeancesScene.ts'/>
/// <reference path='../../scaffolding/Main.ts'/>
/// <reference path='../../scaffolding/EventBus.ts'/>
/// <reference path='../../scaffolding/Utils.ts'/>
/// <reference path='../ProgressCircle.ts'/>
/// <reference path='../title/TitleGenerator.ts'/>
/// <reference path='../shaders/RGBGlitchShader.ts'/>
/// <reference path='../shaders/MPEGArtifactShader.ts'/>
/// <reference path='../assets/GridImages.ts'/>
/// <reference path='../installation/InstallationTitleSequence.ts'/>
/// <reference path='../installation/PhotoCard.ts'/>
/// <reference path='../installation/VideoCard.ts'/>
/// <reference path='../installation/CardLayer.ts'/>
/// <reference path='../installation/InstallationGenreSequence.ts'/>
/// <reference path='../installation/InstallationVideoBackground.ts'/>
var MultiTouchInterfaceScene = (function (_super) {
    __extends(MultiTouchInterfaceScene, _super);
    function MultiTouchInterfaceScene(textureLoader, d, bgDims) {
        var _this = this;
        _super.call(this);
        this.intensityTimeout = -1;
        this.cards = [];
        this.cardPool = [];
        this.cardLayers = [];
        this.cardZPos = -210;
        this.touches = [];
        this.touchPositions = [];
        this.touchedCards = [];
        this.particleEmitter = {};
        this.activeCards = 0;
        this.cardPositions = [];
        this.cardImagePool = ['GRID_IMAGE00001.png', 'GRID_IMAGE00002.png', 'GRID_IMAGE00003.png', 'GRID_IMAGE00004.png', 'GRID_IMAGE00005.png', 'GRID_IMAGE00006.png', 'GRID_IMAGE00007.png', 'GRID_IMAGE00008.png', 'GRID_IMAGE00009.png', 'GRID_IMAGE00010.png', 'GRID_IMAGE00011.png', 'GRID_IMAGE00012.png', 'GRID_IMAGE00013.png', 'GRID_IMAGE00014.png', 'GRID_IMAGE00015.png', 'GRID_IMAGE00016.png', 'GRID_IMAGE00017.png', 'GRID_IMAGE00018.png', 'GRID_IMAGE00019.png', 'GRID_IMAGE00020.png', 'GRID_IMAGE00021.png', 'GRID_IMAGE00022.png', 'GRID_IMAGE00023.png', 'GRID_IMAGE00024.png', 'GRID_IMAGE00025.png', 'GRID_IMAGE00026.png', 'GRID_IMAGE00027.png', 'GRID_IMAGE00028.png', 'GRID_IMAGE00029.png', 'GRID_IMAGE00030.png', 'GRID_IMAGE00031.png', 'GRID_IMAGE00032.png', 'GRID_IMAGE00033.png', 'GRID_IMAGE00034.png', 'GRID_IMAGE00035.png', 'GRID_IMAGE00036.png', 'GRID_IMAGE00037.png', 'GRID_IMAGE00038.png', 'GRID_IMAGE00039.png', 'GRID_IMAGE00040.png', 'GRID_IMAGE00041.png', 'GRID_IMAGE00042.png', 'GRID_IMAGE00043.png', 'GRID_IMAGE00044.png', 'GRID_IMAGE00045.png', 'GRID_IMAGE00046.png', 'GRID_IMAGE00047.png', 'GRID_IMAGE00048.png', 'GRID_IMAGE00049.png', 'GRID_IMAGE00050.png', 'GRID_IMAGE00051.png', 'GRID_IMAGE00052.png', 'GRID_IMAGE00053.png', 'GRID_IMAGE00054.png', 'GRID_IMAGE00055.png', 'GRID_IMAGE00056.png', 'GRID_IMAGE00057.png', 'GRID_IMAGE00058.png', 'GRID_IMAGE00059.png', 'GRID_IMAGE00060.png', 'GRID_IMAGE00061.png', 'GRID_IMAGE00062.png', 'GRID_IMAGE00063.png', 'GRID_IMAGE00064.png', 'GRID_IMAGE00065.png', 'GRID_IMAGE00066.png', 'GRID_IMAGE00067.png', 'GRID_IMAGE00068.png', 'GRID_IMAGE00069.png', 'GRID_IMAGE00070.png', 'GRID_IMAGE00071.png', 'GRID_IMAGE00072.png', 'GRID_IMAGE00073.png', 'GRID_IMAGE00074.png', 'GRID_IMAGE00075.png', 'GRID_IMAGE00076.png', 'GRID_IMAGE00077.png', 'GRID_IMAGE00078.png', 'GRID_IMAGE00079.png', 'GRID_IMAGE00080.png', 'GRID_IMAGE00081.png', 'GRID_IMAGE00082.png', 'GRID_IMAGE00083.png', 'GRID_IMAGE00084.png', 'GRID_IMAGE00085.png', 'GRID_IMAGE00086.png', 'GRID_IMAGE00087.png', 'GRID_IMAGE00088.png', 'GRID_IMAGE00089.png', 'GRID_IMAGE00090.png', 'GRID_IMAGE00091.png', 'GRID_IMAGE00092.png', 'GRID_IMAGE00093.png', 'GRID_IMAGE00094.png', 'GRID_IMAGE00095.png', 'GRID_IMAGE00096.png', 'GRID_IMAGE00097.png', 'GRID_IMAGE00098.png', 'GRID_IMAGE00099.png', 'GRID_IMAGE00100.png', 'GRID_IMAGE00101.png', 'GRID_IMAGE00102.png', 'GRID_IMAGE00103.png', 'GRID_IMAGE00104.png', 'GRID_IMAGE00105.png', 'GRID_IMAGE00106.png', 'GRID_IMAGE00107.png', 'GRID_IMAGE00108.png', 'GRID_IMAGE00109.png', 'GRID_IMAGE00110.png', 'GRID_IMAGE00111.png', 'GRID_IMAGE00112.png', 'GRID_IMAGE00113.png', 'GRID_IMAGE00114.png', 'GRID_IMAGE00115.png', 'GRID_IMAGE00116.png', 'GRID_IMAGE00117.png', 'GRID_IMAGE00118.png', 'GRID_IMAGE00119.png', 'GRID_IMAGE00120.png', 'GRID_IMAGE00121.png', 'GRID_IMAGE00122.png', 'GRID_IMAGE00123.png', 'GRID_IMAGE00124.png', 'GRID_IMAGE00125.png', 'GRID_IMAGE00126.png', 'GRID_IMAGE00127.png', 'GRID_IMAGE00128.png', 'GRID_IMAGE00129.png', 'GRID_IMAGE00130.png', 'GRID_IMAGE00131.png', 'GRID_IMAGE00132.png', 'GRID_IMAGE00133.png', 'GRID_IMAGE00134.png', 'GRID_IMAGE00135.png', 'GRID_IMAGE00136.png', 'GRID_IMAGE00137.png', 'GRID_IMAGE00138.png', 'GRID_IMAGE00139.png', 'GRID_IMAGE00140.png', 'GRID_IMAGE00141.png', 'GRID_IMAGE00142.png', 'GRID_IMAGE00143.png', 'GRID_IMAGE00144.png', 'GRID_IMAGE00145.png', 'GRID_IMAGE00146.png', 'GRID_IMAGE00147.png', 'GRID_IMAGE00148.png', 'GRID_IMAGE00149.png', 'GRID_IMAGE00150.png', 'GRID_IMAGE00151.png', 'GRID_IMAGE00152.png', 'GRID_IMAGE00153.png', 'GRID_IMAGE00154.png', 'GRID_IMAGE00155.png', 'GRID_IMAGE00156.png', 'GRID_IMAGE00157.png', 'GRID_IMAGE15h22m11s94.png', 'GRID_IMAGE15h22m19s190.png', 'GRID_IMAGE15h22m48s163.png', 'GRID_IMAGE15h23m12s187.png', 'GRID_IMAGE15h23m17s7.png', 'GRID_IMAGE15h23m30s112.png', 'GRID_IMAGE15h23m43s0.png', 'GRID_IMAGE15h23m48s65.png', 'GRID_IMAGE15h23m53s113.png', 'GRID_IMAGE15h23m58s159.png', 'GRID_IMAGE15h24m03s212.png', 'GRID_IMAGE15h24m11s7.png', 'GRID_IMAGE15h24m17s84.png', 'GRID_IMAGE15h24m27s178.png', 'GRID_IMAGE15h24m33s239.png', 'GRID_IMAGE15h24m54s210.png', 'GRID_IMAGE15h26m08s134.png', 'GRID_IMAGE15h26m13s232.png', 'GRID_IMAGE15h26m22s62.png', 'GRID_IMAGE15h26m28s126.png', 'GRID_IMAGE15h27m16s0.png', 'GRID_IMAGE15h27m22s154.png', 'GRID_IMAGE15h27m28s216.png', 'GRID_IMAGE15h27m32s8.png', 'GRID_IMAGE15h27m55s221.png', 'GRID_IMAGE15h28m08s98.png', 'GRID_IMAGE15h28m16s164.png', 'GRID_IMAGE15h28m23s0.png', 'GRID_IMAGE15h28m29s57.png', 'GRID_IMAGE15h28m35s109.png', 'GRID_IMAGE15h29m34s141.png', 'GRID_IMAGE15h29m38s243.png', 'GRID_IMAGE15h29m43s26.png', 'GRID_IMAGE15h30m04s26.png', 'GRID_IMAGE15h30m18s116.png', 'GRID_IMAGE15h30m23s170.png', 'GRID_IMAGE15h30m37s42.png', 'GRID_IMAGE15h31m11s100.png', 'GRID_IMAGE15h31m28s50.png', 'GRID_IMAGE15h31m34s115.png', 'GRID_IMAGE15h31m41s186.png', 'GRID_IMAGE15h31m46s230.png', 'GRID_IMAGE15h31m54s64.png', 'GRID_IMAGE15h32m17s12.png', 'GRID_IMAGE15h32m32s184.png', 'GRID_IMAGE15h32m44s52.png', 'GRID_IMAGE15h32m50s109.png', 'GRID_IMAGE15h32m58s189.png', 'GRID_IMAGE15h33m02s233.png', 'GRID_IMAGE15h33m16s99.png', 'GRID_IMAGE15h33m20s156.png', 'GRID_IMAGE15h33m27s199.png', 'GRID_IMAGE15h33m39s71.png', 'GRID_IMAGE15h33m53s222.png', 'GRID_IMAGE15h33m57s9.png', 'GRID_IMAGE15h34m03s78.png', 'GRID_IMAGE15h34m37s140.png', 'GRID_IMAGE15h34m43s217.png', 'GRID_IMAGE15h34m52s26.png', 'GRID_IMAGE15h35m00s130.png', 'GRID_IMAGE15h36m29s227.png', 'GRID_IMAGE15h36m45s139.png', 'GRID_IMAGE15h36m54s235.png', 'GRID_IMAGE15h37m04s71.png', 'GRID_IMAGE15h37m22s10.png', 'GRID_IMAGE15h37m26s52.png', 'GRID_IMAGE15h37m34s136.png', 'GRID_IMAGE15h37m56s92.png', 'GRID_IMAGE15h40m14s190.png', 'GRID_IMAGE15h40m32s122.png', 'GRID_IMAGE15h40m37s163.png', 'GRID_IMAGE15h40m48s30.png', 'GRID_IMAGE15h40m54s90.png', 'GRID_IMAGE15h41m01s162.png', 'GRID_IMAGE15h42m11s56.png', 'GRID_IMAGE15h42m16s140.png', 'GRID_IMAGE15h42m21s183.png', 'GRID_IMAGE15h44m33s222.png', 'GRID_IMAGE15h44m42s52.png', 'GRID_IMAGE15h44m49s139.png', 'GRID_IMAGE15h44m55s192.png', 'GRID_IMAGE15h45m07s48.png', 'GRID_IMAGE15h45m26s255.png', 'GRID_IMAGE15h45m48s212.png', 'GRID_IMAGE15h45m54s22.png', 'GRID_IMAGE2016-04-08-15h16m36s73.png', 'GRID_IMAGE2016-04-08-15h16m40s143.png', 'GRID_IMAGE2016-04-08-15h16m43s177.png', 'GRID_IMAGE2016-04-08-15h16m50s242.png', 'GRID_IMAGE2016-04-08-15h16m53s15.png', 'GRID_IMAGE2016-04-08-15h16m59s79.png', 'GRID_IMAGE2016-04-08-15h17m04s133.png', 'GRID_IMAGE2016-04-08-15h18m46s131.png', 'GRID_IMAGE2016-04-08-15h18m55s213.png', 'GRID_IMAGE2016-04-08-15h19m02s37.png', 'GRID_IMAGE2016-04-08-15h19m04s54.png', 'GRID_IMAGE2016-04-08-15h19m06s80.png', 'GRID_IMAGE2016-04-08-15h19m09s103.png', 'GRID_IMAGE2016-04-08-15h19m11s130.png', 'GRID_IMAGE2016-04-08-15h19m13s146.png', 'GRID_IMAGE2016-04-08-15h19m49s241.png', 'GRID_IMAGE2016-04-08-15h19m51s10.png', 'GRID_IMAGE2016-04-08-15h19m52s25.png', 'GRID_IMAGE2016-04-08-15h19m54s40.png', 'GRID_IMAGE2016-04-08-15h19m56s68.png', 'GRID_IMAGE2016-04-08-15h19m59s90.png', 'GRID_IMAGE2016-04-08-15h20m01s114.png', 'GRID_IMAGE2016-04-08-15h20m04s143.png', 'GRID_IMAGE2016-04-08-15h20m08s175.png', 'GRID_IMAGE2016-04-08-15h20m33s181.png', 'GRID_IMAGE2016-04-08-15h20m35s202.png', 'GRID_IMAGE2016-04-08-15h20m40s215.png', 'GRID_IMAGE2016-04-08-15h20m46s51.png', 'GRID_IMAGE2016-04-08-15h20m54s127.png', 'GRID_IMAGE2016-04-08-15h21m04s234.png', 'GRID_IMAGE2016-04-08-15h21m10s29.png'];
        this.cardVideoPool = ["installation_video_1.mp4", "installation_video_10.mp4", "installation_video_100.mp4", "installation_video_101.mp4", "installation_video_102.mp4", "installation_video_103.mp4", "installation_video_104.mp4", "installation_video_105.mp4", "installation_video_106.mp4", "installation_video_107.mp4", "installation_video_108.mp4", "installation_video_109.mp4", "installation_video_11.mp4", "installation_video_110.mp4", "installation_video_111.mp4", "installation_video_112.mp4", "installation_video_113.mp4", "installation_video_114.mp4", "installation_video_115.mp4", "installation_video_116.mp4", "installation_video_117.mp4", "installation_video_118.mp4", "installation_video_119.mp4", "installation_video_12.mp4", "installation_video_120.mp4", "installation_video_121.mp4", "installation_video_122.mp4", "installation_video_123.mp4", "installation_video_124.mp4", "installation_video_125.mp4", "installation_video_126.mp4", "installation_video_127.mp4", "installation_video_128.mp4", "installation_video_129.mp4", "installation_video_13.mp4 ", "installation_video_130.mp4", "installation_video_131.mp4", "installation_video_132.mp4", "installation_video_133.mp4", "installation_video_134.mp4", "installation_video_135.mp4", "installation_video_136.mp4", "installation_video_137.mp4", "installation_video_138.mp4", "installation_video_139.mp4", "installation_video_14.mp4 ", "installation_video_140.mp4", "installation_video_141.mp4", "installation_video_142.mp4", "installation_video_143.mp4", "installation_video_144.mp4", "installation_video_145.mp4", "installation_video_146.mp4", "installation_video_147.mp4", "installation_video_148.mp4", "installation_video_149.mp4", "installation_video_15.mp4 ", "installation_video_150.mp4", "installation_video_151.mp4", "installation_video_152.mp4", "installation_video_153.mp4", "installation_video_154.mp4", "installation_video_155.mp4", "installation_video_156.mp4", "installation_video_157.mp4", "installation_video_158.mp4", "installation_video_159.mp4", "installation_video_16.mp4 ", "installation_video_160.mp4", "installation_video_161.mp4", "installation_video_162.mp4", "installation_video_163.mp4", "installation_video_164.mp4", "installation_video_165.mp4", "installation_video_166.mp4", "installation_video_167.mp4", "installation_video_168.mp4", "installation_video_169.mp4", "installation_video_17.mp4 ", "installation_video_170.mp4", "installation_video_171.mp4", "installation_video_172.mp4", "installation_video_173.mp4", "installation_video_174.mp4", "installation_video_175.mp4", "installation_video_176.mp4", "installation_video_177.mp4", "installation_video_178.mp4", "installation_video_179.mp4", "installation_video_18.mp4 ", "installation_video_180.mp4", "installation_video_181.mp4", "installation_video_182.mp4", "installation_video_183.mp4", "installation_video_184.mp4", "installation_video_185.mp4", "installation_video_186.mp4", "installation_video_187.mp4", "installation_video_188.mp4", "installation_video_19.mp4", "installation_video_190.mp4", "installation_video_191.mp4", "installation_video_192.mp4", "installation_video_193.mp4", "installation_video_194.mp4", "installation_video_195.mp4", "installation_video_196.mp4", "installation_video_197.mp4", "installation_video_198.mp4", "installation_video_199.mp4", "installation_video_2.mp4", "installation_video_20.mp4", "installation_video_21.mp4", "installation_video_22.mp4", "installation_video_23.mp4", "installation_video_24.mp4", "installation_video_25.mp4", "installation_video_26.mp4", "installation_video_27.mp4", "installation_video_28.mp4", "installation_video_29.mp4", "installation_video_3.mp4", "installation_video_30.mp4", "installation_video_31.mp4", "installation_video_32.mp4", "installation_video_33.mp4", "installation_video_34.mp4", "installation_video_35.mp4", "installation_video_36.mp4", "installation_video_37.mp4", "installation_video_38.mp4", "installation_video_39.mp4", "installation_video_4.mp4", "installation_video_40.mp4", "installation_video_41.mp4", "installation_video_42.mp4", "installation_video_43.mp4", "installation_video_44.mp4", "installation_video_45.mp4", "installation_video_46.mp4", "installation_video_47.mp4", "installation_video_48.mp4", "installation_video_49.mp4", "installation_video_5.mp4", "installation_video_50.mp4", "installation_video_51.mp4", "installation_video_52.mp4", "installation_video_53.mp4", "installation_video_54.mp4", "installation_video_55.mp4", "installation_video_56.mp4", "installation_video_57.mp4", "installation_video_58.mp4", "installation_video_59.mp4", "installation_video_6.mp4", "installation_video_60.mp4", "installation_video_61.mp4", "installation_video_62.mp4", "installation_video_63.mp4", "installation_video_64.mp4", "installation_video_65.mp4", "installation_video_66.mp4", "installation_video_67.mp4", "installation_video_68.mp4", "installation_video_69.mp4", "installation_video_7.mp4", "installation_video_70.mp4", "installation_video_71.mp4", "installation_video_72.mp4", "installation_video_73.mp4", "installation_video_74.mp4", "installation_video_75.mp4", "installation_video_76.mp4", "installation_video_77.mp4", "installation_video_78.mp4", "installation_video_79.mp4", "installation_video_8.mp4", "installation_video_80.mp4", "installation_video_81.mp4", "installation_video_82.mp4", "installation_video_83.mp4", "installation_video_84.mp4", "installation_video_85.mp4", "installation_video_86.mp4", "installation_video_87.mp4", "installation_video_88.mp4", "installation_video_89.mp4", "installation_video_9.mp4", "installation_video_90.mp4", "installation_video_91.mp4", "installation_video_92.mp4", "installation_video_93.mp4", "installation_video_94.mp4", "installation_video_95.mp4", "installation_video_96.mp4", "installation_video_97.mp4", "installation_video_98.mp4", "installation_video_99.mp4", "installation_video_189.mp4"];
        this.layerConfig = [
            {
                radius: 0.9,
                velocity: 3,
            },
            {
                radius: 1,
                velocity: -1
            },
            {
                radius: 1.1,
                velocity: 1
            },
            {
                radius: 1.2,
                velocity: -2
            },
            {
                radius: 1.3,
                velocity: -0.5
            }
        ];
        Main.mobile = false; //force not mobile on touch
        this.textureLoader = textureLoader;
        this.backgroundDims = bgDims;
        this.playOverlay = new PlayOverlay($("#container"), {}, this);
        this.raycaster = new THREE.Raycaster();
        this.texAtlas = new TextureAtlas(12, $("#atlasRenderer"));
        this.seaRenderer = new LineTextureRenderer('Hoefler Text SC', 36, this.texAtlas);
        //title sequence
        this.titleSequence = new InstallationTitleSequence(this.seaRenderer, new TitleGenerator(d.template_sequence, [d.a, d.b, d.c], d.title));
        this.titleSequence.translateZ(-150);
        this.titleSequence.scale.set(0.8, 0.8, 0.8);
        this.titleSequence.translateY(36);
        this.add(this.titleSequence);
        //genre sequence
        this.genreSequence = new InstallationGenreSequence(this.seaRenderer, new GenreGenerator(d.genres, Math.floor(d.film_length / 60)));
        this.genreSequence.translateZ(-100);
        this.genreSequence.scale.set(0.25, 0.25, 0.25);
        this.genreSequence.translateY(10);
        this.add(this.genreSequence);
        this.genreSequence.dispatchEvent({ type: SeancesIntroScene.TITLE_SWAP });
        //background
        this.videoBackground = new InstallationVideoBackground(this.backgroundDims.height, this.backgroundPool);
        this.videoBackground.translateZ(-1000);
        this.add(this.videoBackground);
        //event listeners 
        this.addEventListener(NickelScene.TICK_EVENT, function (e) {
            _this.glitchPass.uniforms.fGlobalTime.value += 0.005;
            _this.particleGroup.tick(e.message.dt);
        });
        var canvas = Stage.RENDERER.domElement;
        canvas.addEventListener('touchstart', function (e) { return _this.touchStart(e); }, false);
        canvas.addEventListener('touchmove', function (e) { return _this.touchMove(e); }, false);
        canvas.addEventListener('touchend', function (e) { return _this.touchEnd(e); }, false);
        this.addEventListener('remove', function () { return clearTimeout(_this.intensityTimeout); });
        EventBus.addEventListener(PhotoCard.REMOVE_CARD, function (card) { return _this.removeCard(card); }, this);
        EventBus.addEventListener(PhotoCard.COUNTDOWN_COMPLETE, (function (card) { return _this.removeFromTouchedCards(card); }), this);
        //init
        this.createCardPositionVectors();
        this.addInitialCards();
        this.ambientGlitchingTimer();
        this.initParticles();
    }
    MultiTouchInterfaceScene.prototype.resolveTitle = function () {
        var _this = this;
        MultiTouchInterfaceScene.RESOLVING = true;
        //make sure the title sequence shifts properly
        this.titleSequence.shift(true);
        TweenMax.delayedCall(3, function () {
            _this.titleSequence.shift(true);
        });
        TweenMax.to(this.titleSequence.position, 25, {
            y: 10,
            ease: Quad.easeOut
        });
        TweenMax.to(this.genreSequence.position, 25, {
            y: 0,
            ease: Quad.easeOut,
            onComplete: function () {
                _this.playOverlay.showMe();
            }
        });
    };
    MultiTouchInterfaceScene.prototype.initParticles = function () {
        this.particleGroup = new SPE.Group({
            texture: {
                value: this.textureLoader.load('/img/smokeparticle.png')
            },
            blending: THREE.NormalBlending,
            maxParticleCount: MultiTouchInterfaceScene.EMITTER_PARTICLES * MultiTouchInterfaceScene.MAX_TOUCHES,
            hasPerspective: true
        });
        for (var emitters = 0; emitters < MultiTouchInterfaceScene.MAX_TOUCHES; emitters++) {
            var emitter = new SPE.Emitter({
                type: SPE.distributions.BOX,
                maxAge: { value: 1 },
                size: { value: 50 },
                particleCount: MultiTouchInterfaceScene.EMITTER_PARTICLES,
                opacity: { value: [0.2, 0.1, 0.08, 0] },
                rotation: {
                    axis: new THREE.Vector3(0, 0, 1),
                    static: true,
                    angle: 1
                },
                color: {
                    value: [
                        new THREE.Color().setHSL(0.61, 1, 0.8),
                        new THREE.Color().setHSL(0.38, 1, 0.8),
                        new THREE.Color().setHSL(0.38, 1, 0.8)
                    ]
                },
            });
            this.particleGroup.addEmitter(emitter);
            emitter.disable();
            this.particleEmitter[emitters.toString()] = emitter;
        }
        this.particleGroup.mesh.position.setZ(-1);
        this.particleGroup.mesh.renderOrder = RenderOrder.ParticleTrails;
        this.add(this.particleGroup.mesh);
    };
    MultiTouchInterfaceScene.prototype.createCardPositionVectors = function () {
        var itemWidth = 30;
        var dims = Utils.calcCameraView(this.cardZPos);
        var center = new THREE.Vector3(0, 0, 0);
        Stage.CAMERA.updateMatrix();
        Stage.CAMERA.updateMatrixWorld(false);
        Stage.CAMERA.matrixWorldInverse.getInverse(Stage.CAMERA.matrixWorld);
        this.frustum = new THREE.Frustum();
        var matrix = new THREE.Matrix4().multiplyMatrices(Stage.CAMERA.projectionMatrix, Stage.CAMERA.matrixWorldInverse);
        this.frustum.setFromMatrix(matrix);
        for (var i = 0; i < this.layerConfig.length; i++) {
            var config = this.layerConfig[i];
            var radius = dims.width / 2 * config.radius;
            var circ = 2 * Math.PI * radius;
            var items = Math.floor(circ / itemWidth);
            var offset = (i % 2) ? 0 : 0.3; //makes it more "brick" like
            var pos = new THREE.Vector3(0, (dims.height / 2) - 1, 0);
            var layer = new CardLayer(config.velocity, pos);
            this.cardLayers.push(layer);
            this.add(layer);
            for (var j = 0; j < items; j++) {
                var placement = j + offset;
                var x = center.x + radius * Math.cos(2 * Math.PI * placement / items);
                var y = center.y + radius * Math.sin(2 * Math.PI * placement / items);
                var point = new THREE.Vector3(x, y, this.cardZPos);
                var rotation = Math.atan2(point.y - center.y, point.x - center.x) + 1.5708;
                var pos_1 = {
                    'layer': i,
                    'position': point,
                    'rotation': rotation
                };
                this.cardPositions.push(pos_1);
            }
        }
    };
    MultiTouchInterfaceScene.prototype.touchStart = function (evt) {
        evt.preventDefault();
        this.setTouchPositions(evt.touches);
        for (var i in evt.changedTouches) {
            var touch = evt.changedTouches[i];
            var id = touch.identifier;
            var pos = this.touchPositions[touch.identifier];
            if (pos) {
                this.raycaster.setFromCamera(pos, Stage.CAMERA);
                var intersects = this.raycaster.intersectObjects(this.cards, true)[0];
                if (intersects && intersects.object.parent) {
                    var photoCard = intersects.object.parent;
                    if (photoCard && photoCard.interactive && !photoCard.countdownRunning && photoCard instanceof PhotoCard || photoCard instanceof VideoCard) {
                        photoCard.touchStarted(pos, id);
                        this.touchedCards[id] = photoCard;
                        this.particleEmitter[id].enable();
                    }
                }
            }
        }
        this.updateParticleTrails();
        this.checkGlitch();
    };
    MultiTouchInterfaceScene.prototype.checkGlitch = function () {
        if (this.activeCards > 0) {
            this.intensity = 'slight';
        }
        else if (this.activeCards >= 3) {
            this.intensity = 'lots';
        }
        else if (this.activeCards >= 5) {
            this.intensity = 'crazy';
        }
        else if (this.activeCards >= 8) {
            this.intensity = 'frenetic';
        }
        else {
            this.intensity = 'none';
        }
    };
    MultiTouchInterfaceScene.prototype.touchMove = function (evt) {
        this.setTouchPositions(evt.touches);
        for (var i = 0; i < this.touchedCards.length; i++) {
            var card = this.touchedCards[i];
            if (card) {
                card.touchMove(this.touchPositions[i], evt);
            }
        }
        this.updateParticleTrails();
    };
    MultiTouchInterfaceScene.prototype.removeFromTouchedCards = function (card) {
        this.particleEmitter[card.touchIndex].disable();
        delete this.touchedCards[card.touchIndex];
    };
    MultiTouchInterfaceScene.prototype.updateParticleTrails = function () {
        this.activeCards = 0; //TODO, find a better place to do this count
        for (var i = 0; i < this.touchedCards.length; i++) {
            var card = this.touchedCards[i];
            if (card) {
                this.activeCards++;
                var bounds = card.imageMesh.geometry.boundingBox.clone().applyMatrix4(card.imageMesh.matrix);
                var width = bounds.max.x - bounds.min.x;
                var height = bounds.max.y - bounds.min.y;
                var angle = -card.rotation.z;
                var matrix = new THREE.Matrix4().makeRotationAxis(this.particleEmitter[i].rotation.axis, angle);
                var newPosition = card.position.clone();
                newPosition.applyMatrix4(matrix);
                this.particleEmitter[i].position.spread =
                    this.particleEmitter[i].position.spread.set(width, height, 0);
                this.particleEmitter[i].position.value.set(newPosition.x, newPosition.y, this.cardZPos + 1);
                this.particleEmitter[i].rotation.angle = angle;
            }
        }
    };
    MultiTouchInterfaceScene.prototype.setTouchPositions = function (touches) {
        if (touches) {
            for (var i = 0; i < touches.length; ++i) {
                var id = touches[i].identifier;
                this.touches[id] = touches[i];
                this.touchPositions[id] = this.getTouchPos(touches[i]);
            }
        }
    };
    MultiTouchInterfaceScene.prototype.removeCard = function (photoCard) {
        var index = _.findIndex(this.cards, function (card) { return card.id === photoCard.id; });
        if (index !== -1) {
            this.cards.splice(index, 1);
            var pos = photoCard.cardPos;
            this.remove(photoCard);
            this.cardPositions.push(pos);
            this.cardPool.push(photoCard);
        }
        if (!MultiTouchInterfaceScene.RESOLVING) {
            this.useCard();
        }
    };
    MultiTouchInterfaceScene.prototype.touchEnd = function (evt) {
        evt.preventDefault();
        //loop through the changed touches, and end them
        for (var i = 0; i < evt.changedTouches.length; i++) {
            var touch = evt.changedTouches[i];
            var id = touch.identifier;
            var card = this.touchedCards[id];
            if (card) {
                card.touchEnd();
            }
            delete this.touches[id];
            delete this.touchPositions[id];
            delete this.touchedCards[id];
            this.particleEmitter[id].disable();
        }
        this.checkGlitch();
    };
    MultiTouchInterfaceScene.prototype.getTouchPos = function (t) {
        var x = (t.clientX / window.innerWidth) * 2 - 1;
        var y = -(t.clientY / window.innerHeight) * 2 + 1;
        return new THREE.Vector3(x, y, 0.5);
    };
    MultiTouchInterfaceScene.prototype.addInitialCards = function () {
        var items = this.cardPositions.length * MultiTouchInterfaceScene.FILL_RATE;
        this.cardImagePool = _.shuffle(this.cardImagePool);
        this.cardVideoPool = _.shuffle(this.cardVideoPool);
        //create the pool
        for (var i = 0; i < items * 1.1; i++) {
            var index = i % (this.cardImagePool.length - 1);
            this.addCard(index);
        }
        //use the cards
        for (var j = 0; j < items; j++) {
            this.useCard();
        }
    };
    MultiTouchInterfaceScene.prototype.useCard = function () {
        var index = _.random(0, this.cardPool.length - 1);
        var card = this.cardPool[index];
        var pos = this.getPosition();
        this.cardPool.splice(index, 1);
        this.cards.push(card);
        this.cardLayers[pos.layer].add(card);
        card.setPosition(pos);
        card.show();
    };
    MultiTouchInterfaceScene.prototype.addCard = function (photoIndex) {
        var card, src;
        if (Math.random() >= MultiTouchInterfaceScene.VIDEO_RATE) {
            src = '/img/installation_images/' + this.cardImagePool[photoIndex];
            card = new PhotoCard(this.textureLoader, src);
        }
        else {
            src = '/vid/installation/' + this.cardVideoPool[photoIndex];
            card = new VideoCard(this.textureLoader, src);
        }
        this.cardPool.push(card);
    };
    MultiTouchInterfaceScene.prototype.getPosition = function () {
        var index = _.random(0, this.cardPositions.length - 1);
        var item = this.cardPositions[index];
        var pos = item.position;
        if (this.isOnScreen(pos)) {
            this.cardPositions.splice(index, 1);
            return item;
        }
        else {
            return this.getPosition();
        }
    };
    MultiTouchInterfaceScene.prototype.isOnScreen = function (position) {
        return true;
    };
    MultiTouchInterfaceScene.prototype.getPostProcessingPasses = function () {
        this.glitchPass = new ShaderPass(new RGBGlitchShader());
        this.glitchPass.uniforms.tDiffuseNoise.value = this.textureLoader.load('/img/tex16.png');
        this.glitchPass.uniforms.tDiffuseNoise.value.wrapS = this.glitchPass.uniforms.tDiffuseNoise.value.wrapT = THREE.RepeatWrapping;
        // this.artifactPass = new THREE.ShaderPass(new MPEGArtifactShader());
        // this.artifactPass.uniforms.tDiffuseNoise.value = this.textureLoader.load('/img/tex16.png');
        // this.artifactPass.uniforms.tDiffuseNoise.value.wrapS = this.artifactPass.uniforms.tDiffuseNoise.value.wrapT = THREE.RepeatWrapping;
        return [this.glitchPass];
    };
    Object.defineProperty(MultiTouchInterfaceScene.prototype, "intensity", {
        get: function () {
            switch (this.glitchPass.uniforms.fAmplitude.value) {
                case 0:
                    return 'none';
                case 0.04:
                    return 'slight';
                case 0.08:
                    return 'lots';
                case 0.12:
                    return 'crazy';
                case 0.16:
                    return 'frenetic';
            }
        },
        set: function (glitch) {
            switch (glitch) {
                case 'none':
                    this.glitchPass.uniforms.fSpeed.value = 0.2;
                    this.glitchPass.uniforms.fAmplitude.value = 0;
                    if (this.titleSequence)
                        this.titleSequence.children.forEach(function (i) {
                            if (i instanceof Word)
                                i.material.uniforms.fDistortionIntensity.value = 0.0;
                        });
                    return;
                case 'slight':
                    this.glitchPass.uniforms.fSpeed.value = 0.2;
                    this.glitchPass.uniforms.fAmplitude.value = 0.04;
                    if (this.titleSequence)
                        this.titleSequence.children.forEach(function (i) {
                            if (i instanceof Word)
                                i.material.uniforms.fDistortionIntensity.value = 0.00025;
                        });
                    return;
                case 'lots':
                    this.glitchPass.uniforms.fSpeed.value = 0.4;
                    this.glitchPass.uniforms.fAmplitude.value = 0.08;
                    if (this.titleSequence)
                        this.titleSequence.children.forEach(function (i) {
                            if (i instanceof Word)
                                i.material.uniforms.fDistortionIntensity.value = 0.000375;
                        });
                    return;
                case 'crazy':
                    this.glitchPass.uniforms.fSpeed.value = 0.6;
                    this.glitchPass.uniforms.fAmplitude.value = 0.12;
                    if (this.titleSequence)
                        this.titleSequence.children.forEach(function (i) {
                            if (i instanceof Word)
                                i.material.uniforms.fDistortionIntensity.value = 0.00050;
                        });
                    return;
                case 'frenetic':
                    this.glitchPass.uniforms.fSpeed.value = 0.8;
                    this.glitchPass.uniforms.fAmplitude.value = 0.16;
                    if (this.titleSequence)
                        this.titleSequence.children.forEach(function (i) {
                            if (i instanceof Word)
                                i.material.uniforms.fDistortionIntensity.value = 0.000625;
                        });
                    return;
            }
        },
        enumerable: true,
        configurable: true
    });
    MultiTouchInterfaceScene.prototype.ambientGlitchingTimer = function () {
        var _this = this;
        if (this.glitchPass && this.intensity === 'none') {
            this.intensityTween = TweenMax.delayedCall(Math.random() * 9 + 1, function () {
                if (_this.glitchPass && _this.intensity === 'none')
                    _this.intensity = 'slight';
                _this.ambientGlitchingTimer();
            });
        }
        else if (this.glitchPass && this.intensity === 'slight') {
            this.intensityTween = TweenMax.delayedCall((Math.sin(2 * Math.PI * Math.random()) / 5 + 1), function () {
                if (_this.glitchPass)
                    _this.intensity = 'none';
                _this.ambientGlitchingTimer();
            });
        }
        else {
            this.intensityTween = TweenMax.delayedCall(1, function () { return _this.ambientGlitchingTimer(); });
        }
        return;
    };
    MultiTouchInterfaceScene.AUTO_CYCLE = true;
    MultiTouchInterfaceScene.ROTATE = true;
    MultiTouchInterfaceScene.SWAP_IMAGES = true;
    MultiTouchInterfaceScene.PROXIMITY_TRIGGER = true;
    MultiTouchInterfaceScene.FILL_RATE = 0.6;
    MultiTouchInterfaceScene.EMITTER_PARTICLES = 200;
    MultiTouchInterfaceScene.VIDEO_RATE = 0.5;
    MultiTouchInterfaceScene.TOUCH_END = "interfacetouchend";
    MultiTouchInterfaceScene.TOUCH_MOVE = "interfacetouchmove";
    MultiTouchInterfaceScene.RESOLVING = false;
    MultiTouchInterfaceScene.MAX_TOUCHES = 10;
    return MultiTouchInterfaceScene;
}(SeancesScene));
var InstallationStage = (function (_super) {
    __extends(InstallationStage, _super);
    function InstallationStage(params) {
        var _this = this;
        _super.call(this, params);
        this.socket = io(Main.socket);
        this.socket.on('connect', function (evt) { return _this.connectedToSocket(evt); });
        this.socket.on('error', function (evt) { return _this.connectionError(evt); });
        this.socket.on('reconnect', function (evt) { return _this.connectedToSocket(evt); });
        this.socket.on('disconnect', function (evt) { return _this.disconnectedFromSocket(evt); });
        this.socket.on('reset', function (evt) { return _this.reset(evt); });
        $('.header, .footer').hide();
    }
    InstallationStage.prototype.reset = function (evt) {
        location.reload();
    };
    InstallationStage.prototype.connectionError = function (evt) {
        console.log("Socket Connection Error");
        console.log(evt);
    };
    InstallationStage.prototype.connectedToSocket = function (evt) {
        console.log("Socket Connection Successful");
        this.socket.emit('joinRoom', { 'roomName': Main.room });
    };
    InstallationStage.prototype.disconnectedFromSocket = function (evt) {
        console.log("Disconnected from Socket");
        console.log(evt);
    };
    return InstallationStage;
}(Stage));
var RenderOrder;
(function (RenderOrder) {
    RenderOrder[RenderOrder["Default"] = 0] = "Default";
    RenderOrder[RenderOrder["CurrentPhotoCard"] = 1] = "CurrentPhotoCard";
    RenderOrder[RenderOrder["ParticleTrails"] = 2] = "ParticleTrails";
    RenderOrder[RenderOrder["BackgroundPhotoCards"] = 3] = "BackgroundPhotoCards";
})(RenderOrder || (RenderOrder = {}));
/// <reference path='../scenes/MultiTouchInterfaceScene.ts'/>
/// <reference path='./InstallationStage.ts'/>
var InstallationInterfaceStage = (function (_super) {
    __extends(InstallationInterfaceStage, _super);
    function InstallationInterfaceStage(api, params) {
        var _this = this;
        _super.call(this, params);
        this.api = api;
        this.socket.on('initInterface', function () {
            _this.startInstallationScene().then(function (e) { return _this.run(); });
            _this.titleScreenLoop = buzzSoundCdn('/audio/title_screen_loop.mp3', 0).fadeTo(40, 2000).play().loop();
        });
        this.socket.on('getReady', function () {
            var scene = _this.currentScene;
            scene.resolveTitle();
            _this.titleScreenLoop.fadeOut(25000);
        });
        this.socket.on('playFilm', function (evt) { return _this.reset(evt); });
    }
    InstallationInterfaceStage.prototype.startInstallationScene = function () {
        var _this = this;
        var backgroundDims = this.calculateCameraView(-1000);
        return this.api.getExperience()
            .then(function (e) { return e['data']; })
            .then(function (d) {
            _this.socket.emit('loadFilm', {
                'src': d.mp4_url,
                'expId': d.id
            });
            _this.changeScene(new MultiTouchInterfaceScene(_this.textureLoader, d, backgroundDims));
        });
    };
    return InstallationInterfaceStage;
}(InstallationStage));
var PlayOverlay = (function (_super) {
    __extends(PlayOverlay, _super);
    function PlayOverlay(container, data, del) {
        _super.call(this, container, data, del);
        this.setContent(Main.templates.find('.play').clone());
        console.log("new play overlay");
    }
    return PlayOverlay;
}(Component));
/// <reference path='../VideoPlayer.ts'/>
/// <reference path='./PlayOverlay.ts'/>
var InstallationVideoPlayer = (function (_super) {
    __extends(InstallationVideoPlayer, _super);
    function InstallationVideoPlayer(container, data, delegate) {
        var _this = this;
        _super.call(this, container, data, delegate);
        this.socket = io(Main.socket);
        this.socket.on('connect', function (evt) { return _this.connectedToSocket(evt); });
        this.socket.on('error', function (evt) { return _this.connectionError(evt); });
        this.socket.on('reconnect', function (evt) { return _this.connectedToSocket(evt); });
        this.socket.on('disconnect', function (evt) { return _this.disconnectedFromSocket(evt); });
        this.socket.on('reset', function (evt) { return _this.reset(evt); });
        this.socket.on('getReady', function (d) { return _this.getReady(); });
        this.socket.on('loadFilm', function (d) { return _this.loadVideo(d); });
        this.socket.on('playFilm', function () { return _this.playVideo(); });
        this.autoplay = false;
        this.overlay = new PlayOverlay($("#container"), {}, this);
        this.showMe();
    }
    InstallationVideoPlayer.prototype.getReady = function () {
        var _this = this;
        console.log("get ready");
        TweenMax.delayedCall(25, function () {
            _this.overlay.showMe();
        });
    };
    InstallationVideoPlayer.prototype.playVideo = function () {
        //if we don't have a video loaded, get one from the db
        if (!this.videoLink) {
            this.getVideo();
        }
        else {
            this.player.show();
            this.player.play();
            this.overlay.hideMe();
        }
    };
    InstallationVideoPlayer.prototype.getVideo = function () {
        var _this = this;
        this.data.api.getExperience()
            .then(function (e) { return e['data']; })
            .then(function (d) {
            _this.loadVideo({
                src: d.mp4_url,
                expId: d.id
            });
            _this.playVideo();
        });
    };
    InstallationVideoPlayer.prototype.loadVideo = function (data) {
        this.videoLink = this.getVideoLink(data.src);
        this.expId = data.expId;
        if (data.poster) {
            this.videoPoster = data.poster;
        }
        if (!this.initialized) {
            this.init();
        }
        else {
            this.setSrc();
        }
    };
    InstallationVideoPlayer.prototype.getVideoLink = function (path) {
        var src = "/vid/installation/" + path.split("/")[5];
        return src;
    };
    InstallationVideoPlayer.prototype.reset = function (evt) {
        location.reload();
    };
    InstallationVideoPlayer.prototype.connectionError = function (evt) {
        console.log("Socket Connection Error");
        console.log(evt);
    };
    InstallationVideoPlayer.prototype.connectedToSocket = function (evt) {
        console.log("Socket Connection Successful");
        this.socket.emit('joinRoom', { 'roomName': Main.room });
    };
    InstallationVideoPlayer.prototype.disconnectedFromSocket = function (evt) {
        console.log("Disconnected from Socket");
    };
    return InstallationVideoPlayer;
}(VideoPlayer));
/// <reference path='../../scaffolding/Component.ts'/>
var InstallationGraveyardTitle = (function (_super) {
    __extends(InstallationGraveyardTitle, _super);
    function InstallationGraveyardTitle(container, data, delegate) {
        _super.call(this, container, data, delegate);
        this.jitterStrength = 500;
        this.setContent(Main.templates.find('.installationGraveyardTitle').clone());
        this.titleData = data;
        this.setText();
    }
    InstallationGraveyardTitle.prototype.setText = function () {
        this.content.html(this.data.title);
        this.content.css('top', this.data.top);
        var x = _.random(-this.jitterStrength, this.jitterStrength) / 100;
        var y = _.random(-this.jitterStrength, this.jitterStrength) / 100;
        var z = _.random(-this.jitterStrength, this.jitterStrength) / 100;
        var xform = 'translate3d(' + x + 'px,' + y + 'px,' + z + 'px)';
        this.content[0].style[Main.xform] = xform;
    };
    return InstallationGraveyardTitle;
}(Component));
/**
 * This module unifies handling of mouse whee event across different browsers
 *
 * See https://developer.mozilla.org/en-US/docs/Web/Reference/Events/wheel?redirectlocale=en-US&redirectslug=DOM%2FMozilla_event_reference%2Fwheel
 * for more details
 *
 * Usage:
 *  var addWheelListener = require('wheel').addWheelListener;
 *  var removeWheelListener = require('wheel').removeWheelListener;
 *  addWheelListener(domElement, function (e) {
 *    // mouse wheel event
 *  });
 *  removeWheelListener(domElement, function);
 */
var prefix = "", _addEventListener, _removeEventListener, support;
detectEventModel(typeof window !== 'undefined' && window, typeof document !== 'undefined' && document);
function addWheelListener(elem, callback, useCapture) {
    _addWheelListener(elem, support, callback, useCapture);
    // handle MozMousePixelScroll in older Firefox
    if (support == "DOMMouseScroll") {
        _addWheelListener(elem, "MozMousePixelScroll", callback, useCapture);
    }
}
;
function removeWheelListener(elem, callback, useCapture) {
    _removeWheelListener(elem, support, callback, useCapture);
    // handle MozMousePixelScroll in older Firefox
    if (support == "DOMMouseScroll") {
        _removeWheelListener(elem, "MozMousePixelScroll", callback, useCapture);
    }
}
;
function _addWheelListener(elem, eventName, callback, useCapture) {
    // TODO: in theory this anonymous function may result in incorrect
    // unsubscription in some browsers. But in practice, I don't think we should
    // worry too much about it (those browsers are on the way out)
    elem[_addEventListener](prefix + eventName, support == "wheel" ? callback : function (originalEvent) {
        !originalEvent && (originalEvent = window.event);
        // create a normalized event object
        var event = {
            // keep a ref to the original event object
            originalEvent: originalEvent,
            target: originalEvent.target || originalEvent.srcElement,
            type: "wheel",
            deltaMode: originalEvent.type == "MozMousePixelScroll" ? 0 : 1,
            deltaX: 0,
            deltaY: 0,
            deltaZ: 0,
            preventDefault: function () {
                originalEvent.preventDefault ?
                    originalEvent.preventDefault() :
                    originalEvent.returnValue = false;
            },
            stopPropagation: function () {
                if (originalEvent.stopPropagation)
                    originalEvent.stopPropagation();
            },
            stopImmediatePropagation: function () {
                if (originalEvent.stopImmediatePropagation)
                    originalEvent.stopImmediatePropagation();
            }
        };
        // calculate deltaY (and deltaX) according to the event
        if (support == "mousewheel") {
            event.deltaY = -1 / 40 * originalEvent.wheelDelta;
            // Webkit also support wheelDeltaX
            originalEvent.wheelDeltaX && (event.deltaX = -1 / 40 * originalEvent.wheelDeltaX);
        }
        else {
            event.deltaY = originalEvent.detail;
        }
        // it's time to fire the callback
        return callback(event);
    }, useCapture || false);
}
function _removeWheelListener(elem, eventName, callback, useCapture) {
    elem[_removeEventListener](prefix + eventName, callback, useCapture || false);
}
function detectEventModel(window, document) {
    if (window && window.addEventListener) {
        _addEventListener = "addEventListener";
        _removeEventListener = "removeEventListener";
    }
    else {
        _addEventListener = "attachEvent";
        _removeEventListener = "detachEvent";
        prefix = "on";
    }
    if (document) {
        // detect available wheel event
        support = "onwheel" in document.createElement("div") ? "wheel" :
            document.onmousewheel !== undefined ? "mousewheel" :
                "DOMMouseScroll"; // let's assume that remaining browsers are older Firefox
    }
    else {
        support = "wheel";
    }
}
/// <reference path="./ScrollPolyfill.ts" />
var VirtualScroll = (function () {
    function VirtualScroll() {
        // if(Main.config.browser == "firefox") this.multiplier = 0.3;
        // if (Browsers.chrome()) multiplier = 2;
        // if (Browsers.ie()) multiplier = 4;
        // if (FJ.Capabilities.touch) multiplier = 2;
        this.multiplier = 0.05;
        this.easing = 0.1;
        this.minX = null;
        this.maxX = null;
        this.minY = 0;
        this.maxY = 20000;
        this.lastPageX = 0;
        this.lastPageY = 0;
        this.attached = false;
        this.autoPilotMode = false;
        this.autoScroll = false;
        this.velocity = 0.1;
        this.event = {
            scrollX: 0,
            scrollY: 0,
            targetScrollX: 0,
            targetScrollY: 0,
            deltaX: 0,
            deltaY: 0,
            maxDeltaX: 0,
            maxDeltaY: 0,
            screenHeight: 0,
            maxY: this.maxY
        };
        this.sHeight = $(window).height();
    }
    VirtualScroll.prototype.jumpTo = function (data) {
        this.event.scrollY = data.yVal;
        this.event.targetScrollY = data.yVal;
        // this.scrollTo({x:0, y:data.yVal, d:30});
        // this._dispatch();
    };
    VirtualScroll.prototype.updateFromScrollbar = function (data) {
        //calculate the position based off of the percentage and then autoscroll there
        var pos = this.minY + Math.round((this.maxY - this.minY) * data.perc);
        this.scrollTo({ x: 0, y: pos, d: 30 });
    };
    VirtualScroll.prototype.reset = function () {
        this.setValue(0, 0);
    };
    VirtualScroll.prototype.setValue = function (x, y) {
        this.event.scrollX = x;
        this.event.scrollY = y;
        this.event.targetScrollX = x;
        this.event.targetScrollY = y;
        this.autoPilotMode = false;
    };
    VirtualScroll.prototype.scrollTo = function (data) {
        this.autoPilotMode = true;
        this.startX = this.event.scrollX;
        this.startY = this.event.scrollY;
        this.event.targetScrollX = data.x;
        this.event.targetScrollY = data.y;
        // 30 frames = roughyl 0.5s by default (but it could be estimated based on distance-to-travel)
        this.duration = data.d || 30;
        this.t = 0;
    };
    VirtualScroll.prototype.initialScroll = function (data) {
        this.initialHeight = data.y;
        this.scrollTo(data);
    };
    VirtualScroll.prototype.autoScrollTo = function () {
        this.t++;
        var dy = Utils.easeQuadOut(this.startY, this.event.targetScrollY, this.t / this.duration);
        this._set(dy - this.event.scrollY);
        if (this.t >= this.duration) {
            this.autoPilotMode = false;
        }
    };
    VirtualScroll.prototype._set = function (dy) {
        //			console.log(dy);
        // console.log("Set")
        if (this.easing && !this.autoPilotMode) {
            this.event.targetScrollY += dy;
        }
        else {
            this.event.scrollY += dy;
        }
        this.event.maxDeltaY = Math.max(this.event.maxDeltaY, Math.abs(dy));
        this.event.deltaY = dy;
        this.event.maxY = this.maxY;
        this.event.minY = this.minY;
        this.event.screenHeight = this.sHeight;
    };
    VirtualScroll.prototype.touch = function () {
        this._dispatch();
    };
    VirtualScroll.prototype._dispatch = function () {
        if (this.minX != null) {
            this.event.scrollX = Utils.clamp(this.minX, this.maxX, this.event.scrollX);
            this.event.targetScrollX = Utils.clamp(this.minX, this.maxX, this.event.targetScrollX);
        }
        if (this.minY != null) {
            this.event.scrollY = Utils.clamp(this.minY, this.maxY, this.event.scrollY);
            this.event.targetScrollY = Utils.clamp(this.minY, this.maxY, this.event.targetScrollY);
        }
        // this.dispatcher.dispatch(this.event);
        // console.log("DISPATCH EVENT!!!");
        // $(document).trigger('setPos', this.event);
        EventBus.dispatchEvent(VirtualScroll.UPDATE, this.event);
    };
    VirtualScroll.prototype.attach = function () {
        var _this = this;
        // if ('touchstart' in document.documentElement && 'touchmove' in document.documentElement) {
        document.addEventListener('touchstart', $.proxy(this.onTouchStart, this), false);
        document.addEventListener('touchmove', $.proxy(this.onTouchMove, this), false);
        // } else {
        this.onWheelCallback = addWheelListener(document, $.proxy(this.onWheel, this), false); // this will throw a ts complier error
        // this.onWheelCallback = addWheelListener(document, _.debounce( $.proxy(this.onWheel, this), 300), false); // this will throw a ts complier error
        // }
        TweenMax.ticker.addEventListener('tick', function () { return _this.onFrame(); });
        //requestAnimationFrame($.proxy(this.onFrame, this));
        // FJ.FrameImpulse.addEventListener($.proxy(this.onFrame, this)); ///TO DO
    };
    VirtualScroll.prototype.detach = function () {
        removeWheelListener(document, this.onWheelCallback);
        document.removeEventListener('touchstart', $.proxy(this.onTouchStart, this));
        document.removeEventListener('touchmove', $.proxy(this.onTouchMove, this));
    };
    VirtualScroll.prototype.onFrame = function () {
        var inc = (this.event.targetScrollY - this.event.scrollY);
        var oldY = this.event.scrollY;
        if (this.autoPilotMode) {
            this.autoScrollTo();
        }
        else if (this.autoScroll) {
            this.event.scrollY += this.velocity;
        }
        else if (this.easing) {
            inc *= this.easing;
            this.event.scrollY += inc;
        }
        if (Math.abs(this.event.targetScrollY - this.event.scrollY) > 0.1 || this.autoPilotMode || this.autoScroll) {
            this._dispatch();
        }
    };
    VirtualScroll.prototype.enableAutoScroll = function (velocity) {
        this.autoScroll = true;
        this.velocity = velocity;
    };
    VirtualScroll.prototype.disableAutoScroll = function () {
        this.autoScroll = false;
    };
    VirtualScroll.prototype.onWheel = function (e) {
        if (!this.autoPilotMode) {
            var deltaY = (e.deltaY == e.deltaY >> 0) ? e.deltaY : e.deltaY * e.deltaY * e.deltaY;
            deltaY *= this.multiplier;
            deltaY = Math.round(deltaY);
            if (deltaY < 0) {
                deltaY = Math.max(deltaY, -100);
            }
            else {
                deltaY = Math.min(deltaY, 100);
            }
            this._set(deltaY);
        }
    };
    VirtualScroll.prototype.onTouchStart = function (e) {
        this.lastPageX = 0;
        this.lastPageY = 0;
    };
    VirtualScroll.prototype.onTouchMove = function (e) {
        e.preventDefault();
        this.autoPilotMode = false;
        if (this.lastPageX != 0) {
            this._set(-(e.targetTouches[0].pageY - this.lastPageY) * this.multiplier);
        }
        this.lastPageX = e.targetTouches[0].pageX;
        this.lastPageY = e.targetTouches[0].pageY;
    };
    VirtualScroll.UPDATE = "vsupdate";
    return VirtualScroll;
}());
/// <reference path='../../scaffolding/Main.ts'/>
/// <reference path='../../scaffolding/EventBus.ts'/>
/// <reference path='../../scaffolding/Utils.ts'/>
/// <reference path='../../scaffolding/Component.ts'/>
/// <reference path='./InstallationGraveyardTitle.ts'/>
/// <reference path='../../scaffolding/VirtualScroller.ts'/>
var InstallationGraveyard = (function (_super) {
    __extends(InstallationGraveyard, _super);
    function InstallationGraveyard(container, data, delegate) {
        var _this = this;
        _super.call(this, container, data, delegate);
        this.atPage = 1;
        this.titleArray = [];
        this.firstLoad = true;
        this.lineHeight = 55;
        this.triggerPadding = 100;
        this.scrollPadding = 20;
        this.atY = 0;
        this.gettingPage = false;
        this.backgroundPool = [
            'bol_1g.mp4',
            'db_1g.mp4',
            'dh_1.mp4',
            'dh_2.mp4',
            'dh_3g.mp4',
            'dj_1g.mp4',
            'dj_2g.mp4',
            'dj_3g.mp4',
            'foac_1.mp4',
            'fr_1.mp4',
            'gl_1.mp4',
            'jk_1.mp4',
            'pp_1g.mp4',
            'rausch_1.mp4',
            'sdw_1.mp4',
            'sdw_2g.mp4',
            'sdw_3g.mp4',
            'sdw_4g.mp4',
            'tgd_1.mp4',
            'ti_1.mp4'
        ];
        this.pageData = [];
        this.scrollY = 0;
        this.setContent(Main.templates.find('.installationGraveyard').clone());
        this.api = this.data.api;
        this.api.baseUrl = "http://seances-900865127.us-east-1.elb.amazonaws.com/";
        this.bgVideo = this.content.find('.graveyardBgVideo');
        this.bgVideo.on('ended', function () { return _this.setBackground(); });
        this.setBackground();
        this.contentDiv = this.content.find('.content');
        this.resize();
        this.virtualScroller = new VirtualScroll();
        this.virtualScroller.attach();
        this.virtualScroller.setValue(0, -this.scrollPadding);
        EventBus.addEventListener(VirtualScroll.UPDATE, function (evt) { return _this.updatePosition(evt); }, this);
        this.getData();
        this.clearInterval = setInterval(function () { return _this.clearHidden(); }, 10000);
        this.autoScroll(0.5);
    }
    InstallationGraveyard.prototype.clearHidden = function () {
        var i = this.titleArray.length;
        while (i--) {
            var title = this.titleArray[i];
            var top_1 = title.data.top;
            if (top_1 + this.lineHeight < this.scrollY) {
                title.killMe();
                this.titleArray.splice(i, 1);
            }
        }
    };
    InstallationGraveyard.prototype.resize = function () {
        this.sHeight = $(window).height();
    };
    InstallationGraveyard.prototype.updatePosition = function (evt) {
        this.scrollY = evt.scrollY;
        this.contentDiv[0].style[Main.xform] = 'translateY(-' + this.scrollY + 'px)';
        if (this.scrollY > (this.atY - this.sHeight - this.triggerPadding) && !this.gettingPage) {
            this.getData();
        }
    };
    InstallationGraveyard.prototype.setBackground = function () {
        var src = this.getRandomVideo();
        this.bgVideo.attr('src', src);
        var el = this.bgVideo[0];
        el.load();
        el.play();
    };
    InstallationGraveyard.prototype.getData = function () {
        var _this = this;
        this.gettingPage = true;
        if (this.totalPages && this.atPage > this.totalPages) {
            this.atPage = 1;
        }
        this.api.getExperienceGraveyard(this.atPage, this.data.expId)
            .then(function (e) {
            _this.totalPages = e['total_pages'];
            _this.addTitles(e['data']);
            _this.pageData[_this.atPage - 1] = e['data'];
            _this.gettingPage = false;
            _this.atPage++;
        }, function (e) {
            var data = _.sample(_this.pageData);
            _this.addTitles(data);
            _this.gettingPage = false;
            _this.atPage++;
        });
    };
    InstallationGraveyard.prototype.addTitles = function (titles) {
        for (var i = 0; i < titles.length; i++) {
            var data = titles[i];
            data.top = this.atY;
            var movieTitle = new InstallationGraveyardTitle(this.contentDiv, data, this);
            this.titleArray.push(movieTitle);
            this.atY += this.lineHeight;
            this.setMaxY();
        }
    };
    InstallationGraveyard.prototype.getRandomVideo = function () {
        return CDN_GLOBAL_PREFIX + '/vid/backgrounds/' + _.sample(this.backgroundPool);
    };
    InstallationGraveyard.prototype.autoScroll = function (velocity) {
        this.virtualScroller.enableAutoScroll(velocity);
    };
    InstallationGraveyard.prototype.setMaxY = function () {
        var offset = 0;
        this.virtualScroller.minY = -this.scrollPadding;
        this.virtualScroller.maxY = this.atY - this.sHeight + this.scrollPadding - offset;
    };
    return InstallationGraveyard;
}(Component));
/// <reference path='../../scaffolding/Component.ts'/>
var InstallationControls = (function (_super) {
    __extends(InstallationControls, _super);
    function InstallationControls(container, data, delegate) {
        var _this = this;
        _super.call(this, container, data, delegate);
        this.confirm = false;
        this.socket = io(Main.socket);
        this.socket.on('connect', function (evt) { return _this.connectedToSocket(evt); });
        this.socket.on('error', function (evt) { return _this.connectionError(evt); });
        this.socket.on('reconnect', function (evt) { return _this.connectedToSocket(evt); });
        this.socket.on('disconnect', function (evt) { return _this.disconnectedFromSocket(evt); });
        this.socket.on('reset', function (evt) { return _this.reset(evt); });
        this.setContent(Main.templates.find('.controls').clone());
        this.viewersInput = this.content.find('.viewersInput');
        this.btnReset = this.content.find('.btnReset').on('click', function () { return _this.resetClicked(); });
        this.btnPlay = this.content.find('.btnPlayFilm').on('click', function () { return _this.playClicked(); });
        this.btnInit = this.content.find('.btnInitInterface').on('click', function () { return _this.initInterface(); });
        this.btnReady = this.content.find('.btnGetReady').on('click', function () { return _this.getReady(); });
    }
    InstallationControls.prototype.reset = function (evt) {
        location.reload();
    };
    InstallationControls.prototype.getReady = function () {
        this.btnPlay.prop('disabled', false);
        this.viewersInput.prop('disabled', false);
        this.btnReady.prop('disabled', true);
        if (this.confirm) {
            var c = confirm("Are you sure you want to get ready?");
            if (!c)
                return;
        }
        this.socket.emit('getReady');
    };
    InstallationControls.prototype.initInterface = function () {
        this.btnReady.prop('disabled', false);
        this.btnInit.prop('disabled', true);
        if (this.confirm) {
            var c = confirm("Are you sure you want to Load the first film?");
            if (!c)
                return;
        }
        this.socket.emit('initInterface');
    };
    InstallationControls.prototype.resetClicked = function () {
        if (this.confirm) {
            var c = confirm("Are you sure you want to Reset All Screens?");
            if (!c)
                return;
        }
        this.socket.emit('reset');
    };
    InstallationControls.prototype.playClicked = function () {
        this.btnPlay.prop('disabled', true);
        this.viewersInput.prop('disabled', true);
        //track the viewers
        var viewers = this.viewersInput.val();
        gaTrackEvent(viewers, 'playInstallationFilm');
        this.viewersInput.val('');
        if (this.confirm) {
            var c = confirm("Are you sure you want to Play the film: [filmname]");
            if (!c)
                return;
        }
        this.socket.emit('playFilm');
    };
    InstallationControls.prototype.connectionError = function (evt) {
        console.log("Socket Connection Error");
        console.log(evt);
    };
    InstallationControls.prototype.connectedToSocket = function (evt) {
        console.log("Socket Connection Successful");
        this.socket.emit('joinRoom', { 'roomName': Main.room });
    };
    InstallationControls.prototype.disconnectedFromSocket = function (evt) {
        console.log("Disconnected from Socket");
    };
    return InstallationControls;
}(Component));
/// <reference path='../scaffolding/Component.ts'/>
var SeancesMobileView = (function (_super) {
    __extends(SeancesMobileView, _super);
    function SeancesMobileView(container, data, del) {
        _super.call(this, container, data, del);
        this.bgImages = [
            "Grid_Image_Bits_of_Life_09.jpg",
            "Grid_Image_Bits_of_Life_10.jpg",
            "Grid_Image_Bits_of_life_13.jpg",
            "Grid_Image_Blind_Girl_06.jpg",
            "Grid_Image_Der_Januskopf_05.jpg",
            "Grid_Image_Der_Januskopf_06.jpg",
            "Grid_Image_Der_Januskopf_07.jpg",
            "Grid_Image_Dream_Woman_02.jpg",
            "Grid_Image_Dream_Woman_021.jpg",
            "Grid_Image_Dream_Woman_04.jpg",
            "Grid_Image_Forbidden_Room_04.jpg",
            "Grid_Image_GBS_01.jpg",
            "Grid_Image_Saint_Devil_Woman_03.jpg",
            "Grid_Image_Saint_Devil_Woman_04.jpg",
            "Grid_Image_Saint_Devil_Woman_051.jpg",
            "Grid_Image_Scorching_Flame_03.jpg",
            "Grid_Image_Tokyo_Ginza_Disctrict_04.jpg",
            "Grid_Image_Tokyo_Ginza_District_03.jpg",
            "Grid_Image_Women_Skeletons_08.jpg",
            "Grid_Image_Women_Skeletons_09.jpg"
        ];
        this.setContent(Main.templates.find('.mobileInterface').clone());
        this.container.find('.btnBegin').bind('click', function (e) {
            e.preventDefault();
            EventBus.dispatchEvent('PLAY_FILM');
        });
        this.setBackground();
        this.resize();
    }
    SeancesMobileView.prototype.setBackground = function () {
        var _this = this;
        var img = this.getRandomImage();
        this.bgImg = new Image();
        this.bgImg.crossOrigin = "anonymous";
        this.bgImg.onload = function () {
            _this.content.find('.bg').css('background-image', 'url(' + img + ')');
        };
        this.bgImg.onerror = function () { };
        this.bgImg.src = img;
    };
    SeancesMobileView.prototype.resize = function () {
        if (Main.sWidth > Main.sHeight) {
            this.content.removeClass('landscape');
        }
        else {
            this.content.addClass('landscape');
        }
    };
    SeancesMobileView.prototype.getRandomImage = function () {
        return CDN_GLOBAL_PREFIX + '/img/bg_img/' + _.sample(this.bgImages);
    };
    return SeancesMobileView;
}(Component));
/// <reference path='../../scaffolding/Component.ts'/>
var GraveyardTitle = (function (_super) {
    __extends(GraveyardTitle, _super);
    function GraveyardTitle(container, data, delegate) {
        var _this = this;
        _super.call(this, container, data, delegate);
        this.jitterStrength = 500;
        this.infoOpen = false;
        this.animateDelay = 7.6;
        this.setContent(Main.templates.find('.graveyardTitle').clone());
        this.titleData = data;
        this.content.find('.text').bind('click', function (e) { return _this.clicked(e); });
        this.content.find('.text').append(this.data.title);
        if (!Main.mobile) {
            var x = _.random(-this.jitterStrength, this.jitterStrength) / 100;
            var y = _.random(-this.jitterStrength, this.jitterStrength) / 100;
            var z = _.random(-this.jitterStrength, this.jitterStrength) / 100;
            var xform = 'translate3d(' + x + 'px,' + y + 'px,' + z + 'px)';
            this.content.find('.text')[0].style[Main.xform] = xform;
        }
        this.removeFunc = function () { return _this.clearInfo(); };
        if (this.data.animateIn) {
            this.content.addClass('hidden');
            TweenMax.delayedCall(this.animateDelay, function () {
                if (_this.content) {
                    _this.content.removeClass('hidden');
                    _this.dispatch(GraveyardTitle.OPEN_TITLE, _this);
                }
            });
        }
    }
    GraveyardTitle.prototype.clicked = function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (this.infoOpen) {
            this.dispatch(GraveyardTitle.CLOSE_TITLE, this);
        }
        else {
            this.dispatch(GraveyardTitle.OPEN_TITLE, this);
        }
    };
    GraveyardTitle.prototype.clearInfo = function () {
        this.info.killMe();
        this.info = undefined;
    };
    GraveyardTitle.prototype.closeInfo = function () {
        TweenMax.killDelayedCallsTo(this.removeFunc);
        if (this.data.animateIn) {
            this.content.removeClass('open');
        }
        else {
            this.content.removeClass('openSmall');
        }
        TweenMax.delayedCall(1, this.removeFunc);
        this.infoOpen = false;
    };
    GraveyardTitle.prototype.openInfo = function () {
        TweenMax.killDelayedCallsTo(this.removeFunc);
        if (this.data.animateIn) {
            this.content.addClass('open');
        }
        else {
            this.content.addClass('openSmall');
        }
        if (!this.info) {
            this.info = new Info(this.content, this.data, this);
        }
        this.infoOpen = true;
    };
    GraveyardTitle.OPEN_TITLE = "opentitle";
    GraveyardTitle.CLOSE_TITLE = "closetitle";
    return GraveyardTitle;
}(Component));
var Info = (function (_super) {
    __extends(Info, _super);
    function Info(container, data, del) {
        var _this = this;
        _super.call(this, container, data, del);
        this.setContent(Main.templates.find('.info').clone());
        this.content.find(".tell").bind('click', function (e) { return _this.shareTwitter(e); });
        this.content.find(".skip").bind('click', function (e) {
            _this.delegate.clicked(e);
        });
        if (!this.data.animateIn) {
            this.content.find('.data').hide();
        }
        this.setText();
    }
    Info.prototype.setText = function () {
        this.content.find('.movietitle').html(this.data.title);
        if (this.data.city !== null && this.data.country !== null) {
            this.content.find('.location').html(this.data.city + ", " + this.data.country);
        }
        this.getTime();
    };
    Info.prototype.shareTwitter = function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var tweet = "I Just watched [title] and you can't. #seances #threestars";
        tweet = tweet.replace('[title]', this.data.title);
        Share.onTwitter(Main.config.shareUrl, tweet);
        gaTrackEvent('share_twitter', 'click');
    };
    Info.prototype.getTime = function () {
        var month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var date = new Date(this.data.time_watched * 1000);
        var month = date.getMonth();
        var day = date.getDate();
        var year = date.getFullYear();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var amPm = 'am';
        if (hours > 12) {
            amPm = 'pm';
            hours = hours - 12;
        }
        else if (hours == 0) {
            amPm = 'pm';
            hours = 12;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        this.content.find('.date').html(month_names[month] + ' ' + day + ', ' + year);
        this.content.find('.lost').html('Lost at ' + hours + ":" + minutes + ' ' + amPm);
    };
    return Info;
}(Component));
/// <reference path='../../scaffolding/Main.ts'/>
/// <reference path='../../scaffolding/EventBus.ts'/>
/// <reference path='../../scaffolding/Utils.ts'/>
/// <reference path='../../scaffolding/Component.ts'/>
/// <reference path='./GraveyardTitle.ts'/>
var Graveyard = (function (_super) {
    __extends(Graveyard, _super);
    function Graveyard(container, data, delegate) {
        var _this = this;
        _super.call(this, container, data, delegate);
        this.atPage = 1;
        this.titleArray = [];
        this.triggerPadding = 20;
        this.topCutoff = -1000;
        this.gettingPage = false;
        this.bgVideoPool = [
            'bol_1g.mp4',
            'db_1g.mp4',
            'dh_1.mp4',
            'dh_2.mp4',
            'dh_3g.mp4',
            'dj_1g.mp4',
            'dj_2g.mp4',
            'dj_3g.mp4',
            'foac_1.mp4',
            'fr_1.mp4',
            'gl_1.mp4',
            'jk_1.mp4',
            'pp_1g.mp4',
            'rausch_1.mp4',
            'sdw_1.mp4',
            'sdw_2g.mp4',
            'sdw_3g.mp4',
            'sdw_4g.mp4',
            'tgd_1.mp4',
            'ti_1.mp4'
        ];
        this.bgImages = [
            "Grid_Image_Bits_of_Life_09.jpg",
            "Grid_Image_Bits_of_Life_10.jpg",
            "Grid_Image_Bits_of_life_13.jpg",
            "Grid_Image_Blind_Girl_06.jpg",
            "Grid_Image_Der_Januskopf_05.jpg",
            "Grid_Image_Der_Januskopf_06.jpg",
            "Grid_Image_Der_Januskopf_07.jpg",
            "Grid_Image_Dream_Woman_02.jpg",
            "Grid_Image_Dream_Woman_021.jpg",
            "Grid_Image_Dream_Woman_04.jpg",
            "Grid_Image_Forbidden_Room_04.jpg",
            "Grid_Image_GBS_01.jpg",
            "Grid_Image_Saint_Devil_Woman_03.jpg",
            "Grid_Image_Saint_Devil_Woman_04.jpg",
            "Grid_Image_Saint_Devil_Woman_051.jpg",
            "Grid_Image_Scorching_Flame_03.jpg",
            "Grid_Image_Tokyo_Ginza_Disctrict_04.jpg",
            "Grid_Image_Tokyo_Ginza_District_03.jpg",
            "Grid_Image_Women_Skeletons_08.jpg",
            "Grid_Image_Women_Skeletons_09.jpg"
        ];
        this.pageData = [];
        this.scrollY = 0;
        this.hasAnimated = false;
        this.setContent(Main.templates.find('.graveyard').clone());
        this.api = this.data.api;
        this.contentDiv = this.content.find('.content');
        this.contentDiv.bind('click', function (e) { return _this.closeTitle(e); });
        this.background = this.content.find('.bg');
        this.bgVideo = this.content.find('.graveyardBgVideo');
        this.graveyardCountDiv = this.content.find('.graveyardCount');
        this.graveCount = this.content.find('.number');
        this.resize();
        this.content.on('scroll', function () { return _this.checkScroll(); });
        if (!Main.mobile) {
            this.bgVideo.on('ended', function () { return _this.setBackground(); });
            this.setBackground();
        }
        else {
            this.setBackgroundImage();
        }
    }
    Graveyard.prototype.checkScroll = function () {
        this.atY = this.content.scrollTop();
        if (this.atY + this.content.innerHeight() >= this.content[0].scrollHeight - this.triggerPadding && !this.gettingPage) {
            this.getData();
        }
    };
    Graveyard.prototype.clearHidden = function () {
        var removed = 0;
        var currentTop = this.content.scrollTop();
        var height;
        var i = this.titleArray.length;
        while (i--) {
            var item = this.titleArray[i];
            height = item.content.height();
            var offset = item.content.offset().top;
            if (offset < this.topCutoff) {
                item.killMe();
                if (this.activeTitle == item) {
                    this.activeTitle = undefined;
                }
                this.titleArray.splice(i, 1);
                removed++;
            }
        }
        var newTop = currentTop + (removed * height);
        this.content.scrollTop(newTop);
    };
    Graveyard.prototype.resize = function () {
        this.sWidth = $(window).width();
        this.sHeight = $(window).height();
        var dims = Utils.fitToContainer({
            'containerWidth': this.sWidth,
            'containerHeight': this.sHeight,
            'contentWidth': 1920,
            'contentHeight': 1080,
            'scaleMode': 'proportionalOutside',
            'vAlign': 'center',
            'hAlign': 'center'
        });
        this.background.css(dims);
    };
    Graveyard.prototype.setBackground = function () {
        var _this = this;
        var src = this.getRandomVideo();
        this.bgVideo.attr('src', src);
        this.bgVideo.one('canplaythrough', function () {
            _this.getData();
            _this.getGraveyardCount();
        });
        var el = this.bgVideo[0];
        el.load();
        el.play();
    };
    Graveyard.prototype.setBackgroundImage = function () {
        var _this = this;
        this.bgImage = new Image();
        this.bgVideo.remove();
        this.bgImage.onload = function () {
            _this.content.find('.bg').css('background:url(' + imagePath + ')');
            // this.background.append(this.bgImage);
            _this.getData();
        };
        var imagePath = this.getRandomImage();
        this.bgImage.src = imagePath;
    };
    Graveyard.prototype.getData = function () {
        var _this = this;
        this.gettingPage = true;
        if (this.totalPages && this.atPage > this.totalPages) {
            this.atPage = 1;
        }
        this.api.getExperienceGraveyard(this.atPage, this.data.expId)
            .then(function (e) {
            _this.totalPages = e['total_pages'];
            _this.clearHidden();
            _this.addTitles(e['data']);
            _this.pageData[_this.atPage - 1] = e['data'];
            _this.gettingPage = false;
            _this.atPage++;
            if (!_this.onStage) {
                _this.showMe();
            }
        }, function (e) {
            var data = _.sample(_this.pageData);
            _this.addTitles(data);
            _this.gettingPage = false;
            _this.atPage++;
        });
    };
    Graveyard.prototype.getGraveyardCount = function () {
        var _this = this;
        this.api.getGraveyardCount()
            .then(function (e) {
            var num = e.current.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            _this.graveCount.html(" " + num);
        });
    };
    Graveyard.prototype.showCounter = function () {
        console.log(this.graveCount);
        this.graveyardCountDiv.show();
    };
    Graveyard.prototype.addTitles = function (titles) {
        var _this = this;
        for (var i = 0; i < titles.length; i++) {
            var data = titles[i];
            if (data.experience_id == this.data.expId && !this.hasAnimated) {
                data.animateIn = true;
                this.hasAnimated = true;
            }
            var movieTitle = new GraveyardTitle(this.contentDiv, data, this);
            movieTitle.on(GraveyardTitle.OPEN_TITLE, function (title) { return _this.openTitle(title); }, this);
            movieTitle.on(GraveyardTitle.CLOSE_TITLE, function (title) { return _this.closeTitle(title); }, this);
            this.titleArray.push(movieTitle);
        }
    };
    Graveyard.prototype.openTitle = function (title) {
        if (this.activeTitle) {
            this.activeTitle.closeInfo();
        }
        this.activeTitle = title;
        this.activeTitle.openInfo();
        this.content.addClass('lightbox');
    };
    Graveyard.prototype.closeTitle = function (title) {
        this.content.removeClass('lightbox');
        this.showCounter();
        if (this.activeTitle) {
            this.activeTitle.closeInfo();
            this.activeTitle = undefined;
        }
    };
    Graveyard.prototype.getRandomVideo = function () {
        return CDN_GLOBAL_PREFIX + '/vid/backgrounds/' + _.sample(this.bgVideoPool);
    };
    Graveyard.prototype.getRandomImage = function () {
        return CDN_GLOBAL_PREFIX + '/img/bg_img/' + _.sample(this.bgImages);
    };
    return Graveyard;
}(Component));
/// <reference path='../SeancesMobileView.ts'/>
/// <reference path='../graveyard/Graveyard.ts'/>
var MobileStage = (function () {
    function MobileStage(api, data, skipIntro, graveyard) {
        this.uuid = Utils.generateUUID();
        this.data = data;
        this.api = api;
        if (skipIntro) {
            this.startExperience();
        }
        else {
            this.startIntroduction();
        }
    }
    MobileStage.prototype.startIntroduction = function () {
        var _this = this;
        var intro = new IntroSceneNoThree($('#container'), {}, this);
        EventBus.addEventListener("INTRO_OVER", function () {
            intro.killMe();
            _this.startExperience();
        }, this);
    };
    MobileStage.prototype.startExperience = function () {
        var _this = this;
        console.log("start experience");
        this.api.getExperience()
            .then(function (e) { return e['data']; })
            .then(function (d) {
            console.log(d);
            var url = (d['m3u8_url']) ? d['m3u8_url'] : d['mp4_url'];
            _this.expId = d['id'];
            var vd = {
                src: url,
                expId: d['id']
            };
            _this.loadVideoPlayer(vd);
            _this.startMobileInterface();
            EventBus.addEventListener("PLAY_FILM", function () {
                _this.control.hideMe();
                _this.startVideoPlayer(vd);
            }, _this);
        });
    };
    MobileStage.prototype.startMobileInterface = function () {
        this.control = new SeancesMobileView(this.data.container, {}, this);
    };
    MobileStage.prototype.loadVideoPlayer = function (vd) {
        this.player = new VideoPlayer(this.data.container, {}, this);
        this.player.loadVideo(vd);
    };
    MobileStage.prototype.startVideoPlayer = function (vd) {
        var _this = this;
        this.player.playVideo();
        this.player.showMe();
        this.api.moveExperienceToGraveyard(vd.expId);
        EventBus.addEventListener("VIDEO_OVER", function () {
            _this.startGraveyardScene(); //TODO Mobile Graveyard
        }, this);
    };
    MobileStage.prototype.startGraveyardScene = function (expId) {
        this.graveyard = new Graveyard(this.data.container, { "api": this.api, "id": this.expId }, this);
    };
    return MobileStage;
}());
/// <reference path='./scaffolding/Main.ts'/>
/// <reference path='./scaffolding/three/NickelGroup.ts'/>
/// <reference path='./scaffolding/three/NickelScene.ts'/>
/// <reference path='./seances/VideoPlayer.ts'/>
/// <reference path='./seances/SeancesApi.ts'/>
/// <reference path='./seances/scenes/SeancesIntroScene.ts'/>
/// <reference path='./seances/scenes/IntroSceneNoThree.ts'/>
/// <reference path='./seances/scenes/AboutScene.ts'/>
/// <reference path='./seances/scenes/CreditsScene.ts'/>
/// <reference path='./seances/stages/SeancesStage.ts'/>
/// <reference path='./seances/stages/InstallationInterfaceStage.ts'/>
/// <reference path='./seances/installation/InstallationVideoPlayer.ts'/>
/// <reference path='./seances/installation/InstallationGraveyard.ts'/>
/// <reference path='./seances/installation/InstallationControls.ts'/>
/// <reference path='./seances/stages/MobileStage.ts'/>
/// <reference path='./seances/Header.ts'/>
/// <reference path='./seances/Footer.ts'/>
/// <reference path='./seances/graveyard/Graveyard.ts'/>
var _this = this;
Promise.config({
    warnings: false,
    longStackTraces: true
});
var api = new SeancesApi(window.fetch.bind(window), '/');
var container = $("#container");
var CDN_GLOBAL_PREFIX = '';
var header;
var footer;
var credit;
var about;
var stage;
var cfg = {
    custom: {
        families: [
            'Hoefler Text:n4,i4,n7,i7',
            'Hoefler Text SC',
            '7Sins',
            'adelle sans:n4'
        ]
    }
};
var fontPromise = new Promise(function (resolve, reject) {
    cfg.active = function () { return resolve(true); };
    cfg.inactive = function () { return reject(new Error('unable to load fonts')); };
});
WebFont.load(cfg);
Promise.all([fontPromise, window.fetch('/config')])
    .then(function (vals) { return vals[1].json(); })
    .then(function (config) {
    new Main(config);
    page('/', function () {
        initSeancesScene();
    });
    page('/skipIntro', function () {
        initSeancesScene(true);
    });
    page('/graveyard', function () {
        initSeancesScene(true, true);
    });
    page('/installation/interface/:room', function (req) {
        Main.room = req.params.room;
        var stage = new InstallationInterfaceStage(api, {
            container: container,
            enableGui: false,
            enableStats: false
        });
    });
    page('/installation/player/:room', function (req) {
        Main.room = req.params.room;
        var stage = new InstallationVideoPlayer(container, { api: api }, _this);
    });
    page('/installation/graveyard/:room', function (req) {
        Main.room = req.params.room;
        var stage = new InstallationGraveyard(container, { api: api }, _this);
    });
    page('/installation/controls/:room', function (req) {
        Main.room = req.params.room;
        var controls = new InstallationControls(container, {}, null);
    });
    page(); // DISPATCH OUR ROUTING
});
function initSeancesScene(skipIntro, graveyard) {
    if (skipIntro === void 0) { skipIntro = false; }
    if (graveyard === void 0) { graveyard = false; }
    // enable CDN
    CDN_GLOBAL_PREFIX = Main.config['siteAssetsBaseUrl'];
    var vars = {
        container: container,
        enableGui: false,
        enableStats: false,
    };
    if (Utils.canUseWebgl && !Main.mobile) {
        THREE.Cache.enabled = true;
        GridImages.preload(GridImages.PRELOAD_BATCH_SIZE);
        stage = new SeancesStage(api, vars, skipIntro, graveyard);
    }
    else {
        stage = new MobileStage(api, vars, skipIntro, graveyard);
    }
    header = new Header($('.top-bar'), {}, null);
    footer = new Footer($('#footer'), {}, null);
    credit = new CreditsScene($('.credits'), {}, null);
    about = new AboutScene($('.about'), {}, null);
    if (skipIntro || graveyard) {
        EventBus.dispatchEvent('INTRO_OVER');
    }
}
function buzzSoundCdn(url, volume) {
    if (volume === void 0) { volume = 80; }
    return new buzz.sound(CDN_GLOBAL_PREFIX + url, {
        'volume': volume
    });
}
